import { jsxs as be, jsx as M, Fragment as Yn } from "react/jsx-runtime";
import * as m from "react";
import Bn, { useState as rr, createContext as st, useImperativeHandle as Qu, useEffect as le, createElement as Pe, Children as Pi, useContext as ue, useMemo as Ge, useRef as ve, useCallback as J, useLayoutEffect as Ba, forwardRef as Ua, Component as Ci, useId as ed, Fragment as za, useInsertionEffect as td } from "react";
import * as nd from "react-dom";
import rd from "react-dom";
const Mi = "-", id = (e) => {
  const t = sd(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (s) => {
      const a = s.split(Mi);
      return a[0] === "" && a.length !== 1 && a.shift(), Wa(a, t) || od(s);
    },
    getConflictingClassGroupIds: (s, a) => {
      const c = n[s] || [];
      return a && r[s] ? [...c, ...r[s]] : c;
    }
  };
}, Wa = (e, t) => {
  var s;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), i = r ? Wa(e.slice(1), r) : void 0;
  if (i)
    return i;
  if (t.validators.length === 0)
    return;
  const o = e.join(Mi);
  return (s = t.validators.find(({
    validator: a
  }) => a(o))) == null ? void 0 : s.classGroupId;
}, Co = /^\[(.+)\]$/, od = (e) => {
  if (Co.test(e)) {
    const t = Co.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, sd = (e) => {
  const {
    theme: t,
    classGroups: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  for (const i in n)
    Kr(n[i], r, i, t);
  return r;
}, Kr = (e, t, n, r) => {
  e.forEach((i) => {
    if (typeof i == "string") {
      const o = i === "" ? t : Mo(t, i);
      o.classGroupId = n;
      return;
    }
    if (typeof i == "function") {
      if (ad(i)) {
        Kr(i(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: i,
        classGroupId: n
      });
      return;
    }
    Object.entries(i).forEach(([o, s]) => {
      Kr(s, Mo(t, o), n, r);
    });
  });
}, Mo = (e, t) => {
  let n = e;
  return t.split(Mi).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, ad = (e) => e.isThemeGetter, cd = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const i = (o, s) => {
    n.set(o, s), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(o) {
      let s = n.get(o);
      if (s !== void 0)
        return s;
      if ((s = r.get(o)) !== void 0)
        return i(o, s), s;
    },
    set(o, s) {
      n.has(o) ? n.set(o, s) : i(o, s);
    }
  };
}, Yr = "!", Zr = ":", ld = Zr.length, ud = (e) => {
  const {
    prefix: t,
    experimentalParseClassName: n
  } = e;
  let r = (i) => {
    const o = [];
    let s = 0, a = 0, c = 0, l;
    for (let g = 0; g < i.length; g++) {
      let p = i[g];
      if (s === 0 && a === 0) {
        if (p === Zr) {
          o.push(i.slice(c, g)), c = g + ld;
          continue;
        }
        if (p === "/") {
          l = g;
          continue;
        }
      }
      p === "[" ? s++ : p === "]" ? s-- : p === "(" ? a++ : p === ")" && a--;
    }
    const u = o.length === 0 ? i : i.substring(c), f = dd(u), d = f !== u, h = l && l > c ? l - c : void 0;
    return {
      modifiers: o,
      hasImportantModifier: d,
      baseClassName: f,
      maybePostfixModifierPosition: h
    };
  };
  if (t) {
    const i = t + Zr, o = r;
    r = (s) => s.startsWith(i) ? o(s.substring(i.length)) : {
      isExternal: !0,
      modifiers: [],
      hasImportantModifier: !1,
      baseClassName: s,
      maybePostfixModifierPosition: void 0
    };
  }
  if (n) {
    const i = r;
    r = (o) => n({
      className: o,
      parseClassName: i
    });
  }
  return r;
}, dd = (e) => e.endsWith(Yr) ? e.substring(0, e.length - 1) : e.startsWith(Yr) ? e.substring(1) : e, fd = (e) => {
  const t = Object.fromEntries(e.orderSensitiveModifiers.map((r) => [r, !0]));
  return (r) => {
    if (r.length <= 1)
      return r;
    const i = [];
    let o = [];
    return r.forEach((s) => {
      s[0] === "[" || t[s] ? (i.push(...o.sort(), s), o = []) : o.push(s);
    }), i.push(...o.sort()), i;
  };
}, hd = (e) => ({
  cache: cd(e.cacheSize),
  parseClassName: ud(e),
  sortModifiers: fd(e),
  ...id(e)
}), pd = /\s+/, md = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: i,
    sortModifiers: o
  } = t, s = [], a = e.trim().split(pd);
  let c = "";
  for (let l = a.length - 1; l >= 0; l -= 1) {
    const u = a[l], {
      isExternal: f,
      modifiers: d,
      hasImportantModifier: h,
      baseClassName: g,
      maybePostfixModifierPosition: p
    } = n(u);
    if (f) {
      c = u + (c.length > 0 ? " " + c : c);
      continue;
    }
    let y = !!p, v = r(y ? g.substring(0, p) : g);
    if (!v) {
      if (!y) {
        c = u + (c.length > 0 ? " " + c : c);
        continue;
      }
      if (v = r(g), !v) {
        c = u + (c.length > 0 ? " " + c : c);
        continue;
      }
      y = !1;
    }
    const x = o(d).join(":"), T = h ? x + Yr : x, E = T + v;
    if (s.includes(E))
      continue;
    s.push(E);
    const b = i(v, y);
    for (let A = 0; A < b.length; ++A) {
      const P = b[A];
      s.push(T + P);
    }
    c = u + (c.length > 0 ? " " + c : c);
  }
  return c;
};
function gd() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = Ga(t)) && (r && (r += " "), r += n);
  return r;
}
const Ga = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = Ga(e[r])) && (n && (n += " "), n += t);
  return n;
};
function yd(e, ...t) {
  let n, r, i, o = s;
  function s(c) {
    const l = t.reduce((u, f) => f(u), e());
    return n = hd(l), r = n.cache.get, i = n.cache.set, o = a, a(c);
  }
  function a(c) {
    const l = r(c);
    if (l)
      return l;
    const u = md(c, n);
    return i(c, u), u;
  }
  return function() {
    return o(gd.apply(null, arguments));
  };
}
const ie = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, Ha = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, Ka = /^\((?:(\w[\w-]*):)?(.+)\)$/i, vd = /^\d+\/\d+$/, bd = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, wd = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Td = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, xd = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Sd = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Dt = (e) => vd.test(e), _ = (e) => !!e && !Number.isNaN(Number(e)), qe = (e) => !!e && Number.isInteger(Number(e)), yr = (e) => e.endsWith("%") && _(e.slice(0, -1)), ze = (e) => bd.test(e), Ed = () => !0, Ad = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  wd.test(e) && !Td.test(e)
), Ya = () => !1, Pd = (e) => xd.test(e), Cd = (e) => Sd.test(e), Md = (e) => !R(e) && !D(e), Rd = (e) => Wt(e, qa, Ya), R = (e) => Ha.test(e), dt = (e) => Wt(e, Ja, Ad), vr = (e) => Wt(e, kd, _), Ro = (e) => Wt(e, Za, Ya), Dd = (e) => Wt(e, Xa, Cd), Rn = (e) => Wt(e, Qa, Pd), D = (e) => Ka.test(e), Qt = (e) => Gt(e, Ja), Od = (e) => Gt(e, Id), Do = (e) => Gt(e, Za), Vd = (e) => Gt(e, qa), Fd = (e) => Gt(e, Xa), Dn = (e) => Gt(e, Qa, !0), Wt = (e, t, n) => {
  const r = Ha.exec(e);
  return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, Gt = (e, t, n = !1) => {
  const r = Ka.exec(e);
  return r ? r[1] ? t(r[1]) : n : !1;
}, Za = (e) => e === "position" || e === "percentage", Xa = (e) => e === "image" || e === "url", qa = (e) => e === "length" || e === "size" || e === "bg-size", Ja = (e) => e === "length", kd = (e) => e === "number", Id = (e) => e === "family-name", Qa = (e) => e === "shadow", Nd = () => {
  const e = ie("color"), t = ie("font"), n = ie("text"), r = ie("font-weight"), i = ie("tracking"), o = ie("leading"), s = ie("breakpoint"), a = ie("container"), c = ie("spacing"), l = ie("radius"), u = ie("shadow"), f = ie("inset-shadow"), d = ie("text-shadow"), h = ie("drop-shadow"), g = ie("blur"), p = ie("perspective"), y = ie("aspect"), v = ie("ease"), x = ie("animate"), T = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], E = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], b = () => [...E(), D, R], A = () => ["auto", "hidden", "clip", "visible", "scroll"], P = () => ["auto", "contain", "none"], S = () => [D, R, c], I = () => [Dt, "full", "auto", ...S()], G = () => [qe, "none", "subgrid", D, R], he = () => ["auto", {
    span: ["full", qe, D, R]
  }, qe, D, R], Me = () => [qe, "auto", D, R], se = () => ["auto", "min", "max", "fr", D, R], pe = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], we = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], me = () => ["auto", ...S()], z = () => [Dt, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...S()], O = () => [e, D, R], Re = () => [...E(), Do, Ro, {
    position: [D, R]
  }], Te = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], je = () => ["auto", "cover", "contain", Vd, Rd, {
    size: [D, R]
  }], xe = () => [yr, Qt, dt], te = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    l,
    D,
    R
  ], re = () => ["", _, Qt, dt], ye = () => ["solid", "dashed", "dotted", "double"], lt = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], K = () => [_, yr, Do, Ro], ut = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    g,
    D,
    R
  ], $e = () => ["none", _, D, R], Be = () => ["none", _, D, R], Ue = () => [_, D, R], V = () => [Dt, "full", ...S()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [ze],
      breakpoint: [ze],
      color: [Ed],
      container: [ze],
      "drop-shadow": [ze],
      ease: ["in", "out", "in-out"],
      font: [Md],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [ze],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [ze],
      shadow: [ze],
      spacing: ["px", _],
      text: [ze],
      "text-shadow": [ze],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", Dt, R, D, y]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [_, R, D, a]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": T()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": T()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: b()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: A()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": A()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": A()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: P()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": P()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": P()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: I()
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": I()
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": I()
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: I()
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: I()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: I()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: I()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: I()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: I()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [qe, "auto", D, R]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [Dt, "full", "auto", a, ...S()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [_, Dt, "auto", "initial", "none", R]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", _, D, R]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", _, D, R]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [qe, "first", "last", "none", D, R]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": G()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: he()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": Me()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": Me()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": G()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: he()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": Me()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": Me()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": se()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": se()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: S()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": S()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": S()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...pe(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...we(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...we()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...pe()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...we(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...we(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": pe()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...we(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...we()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: S()
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: S()
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: S()
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: S()
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: S()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: S()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: S()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: S()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: S()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: me()
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: me()
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: me()
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: me()
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: me()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: me()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: me()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: me()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: me()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": S()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": S()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: z()
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [a, "screen", ...z()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          a,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...z()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          a,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [s]
          },
          ...z()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...z()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...z()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...z()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", n, Qt, dt]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [r, D, vr]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", yr, R]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Od, R, t]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [i, D, R]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [_, "none", D, vr]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          o,
          ...S()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", D, R]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", D, R]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: O()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: O()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...ye(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [_, "from-font", "auto", D, dt]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: O()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [_, "auto", D, R]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: S()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", D, R]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", D, R]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: Re()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: Te()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: je()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, qe, D, R],
          radial: ["", D, R],
          conic: [qe, D, R]
        }, Fd, Dd]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: O()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: xe()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: xe()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: xe()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: O()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: O()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: O()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: te()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": te()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": te()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": te()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": te()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": te()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": te()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": te()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": te()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": te()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": te()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": te()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": te()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": te()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": te()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: re()
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": re()
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": re()
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": re()
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": re()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": re()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": re()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": re()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": re()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": re()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": re()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...ye(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...ye(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: O()
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": O()
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": O()
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": O()
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": O()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": O()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": O()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": O()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": O()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: O()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...ye(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [_, D, R]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", _, Qt, dt]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: O()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          u,
          Dn,
          Rn
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: O()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", f, Dn, Rn]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": O()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: re()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: O()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [_, dt]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": O()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": re()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": O()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", d, Dn, Rn]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": O()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [_, D, R]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...lt(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": lt()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [_]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": K()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": K()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": O()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": O()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": K()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": K()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": O()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": O()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": K()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": K()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": O()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": O()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": K()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": K()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": O()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": O()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": K()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": K()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": O()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": O()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": K()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": K()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": O()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": O()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": K()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": K()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": O()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": O()
      }],
      "mask-image-radial": [{
        "mask-radial": [D, R]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": K()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": K()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": O()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": O()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": E()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [_]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": K()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": K()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": O()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": O()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: Re()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: Te()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: je()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", D, R]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          D,
          R
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: ut()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [_, D, R]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [_, D, R]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          h,
          Dn,
          Rn
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": O()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", _, D, R]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [_, D, R]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", _, D, R]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [_, D, R]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", _, D, R]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          D,
          R
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": ut()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [_, D, R]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [_, D, R]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", _, D, R]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [_, D, R]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", _, D, R]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [_, D, R]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [_, D, R]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", _, D, R]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": S()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": S()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": S()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", D, R]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [_, "initial", D, R]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", v, D, R]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [_, D, R]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", x, D, R]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [p, D, R]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": b()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: $e()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": $e()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": $e()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": $e()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: Be()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": Be()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": Be()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": Be()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: Ue()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": Ue()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": Ue()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [D, R, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: b()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: V()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": V()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": V()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": V()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: O()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: O()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", D, R]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": S()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": S()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": S()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": S()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": S()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": S()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": S()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": S()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": S()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": S()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": S()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": S()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": S()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": S()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": S()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": S()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": S()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": S()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", D, R]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...O()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [_, Qt, dt, vr]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...O()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, on = /* @__PURE__ */ yd(Nd), _d = `
  group justify-center
  text-lg font-medium no-underline
  px-5 rounded-xl h-11
  flex items-center gap-2
  transition-all min-w-fit

  disabled:pointer-events-none
  data-[is-disabled=true]:pointer-events-none

  data-[size="medium"]:h-12
  data-[size="large"]:h-16

  data-[variant="primary"]:bg-primary-100
  data-[variant="primary"]:text-white
  data-[variant="primary"]:hover:bg-primary-200
  data-[variant="primary"]:disabled:bg-gray-250
  data-[variant="primary"]:data-[is-disabled=true]:bg-gray-250
  data-[variant="primary"]:data-[inverse=true]:bg-white
  data-[variant="primary"]:data-[inverse=true]:text-primary-100
  data-[variant="primary"]:data-[inverse=true]:hover:bg-white
  data-[variant="primary"]:data-[inverse=true]:hover:text-primary-200
  data-[variant="primary"]:data-[inverse=true]:disabled:bg-gray-200
  data-[variant="primary"]:data-[inverse=true]:disabled:text-white
  data-[variant="primary"]:data-[inverse=true]:data-[is-disabled=true]:bg-gray-200
  data-[variant="primary"]:data-[inverse=true]:data-[is-disabled=true]:text-white

  data-[variant="secondary"]:border
  data-[variant="secondary"]:border-solid
  data-[variant="secondary"]:border-gray-150
  data-[variant="secondary"]:text-primary-100
  data-[variant="secondary"]:hover:border-primary-50
  data-[variant="secondary"]:hover:text-primary-50
  data-[variant="secondary"]:disabled:text-gray-250
  data-[variant="secondary"]:disabled:border-gray-250
  data-[variant="secondary"]:data-[is-disabled=true]:text-gray-250
  data-[variant="secondary"]:data-[is-disabled=true]:border-gray-250
  data-[variant="secondary"]:data-[inverse=true]:text-white
  data-[variant="secondary"]:data-[inverse=true]:border-white

  data-[variant="ghost"]:text-primary-100
  data-[variant="ghost"]:hover:text-primary-50
  data-[variant="ghost"]:disabled:text-gray-250
  data-[variant="ghost"]:data-[is-disabled=true]:text-gray-250

  data-[variant="ghost"]:data-[inverse=true]:text-white
`, Oo = "h-6 w-6", ec = Bn.forwardRef(
  ({
    children: e,
    className: t = "",
    variant: n = "primary",
    size: r = "small",
    prefixIcon: i,
    suffixIcon: o,
    isDisabled: s = !1,
    inverse: a = !1,
    onClick: c,
    type: l = "button",
    ...u
  }, f) => /* @__PURE__ */ be(
    "button",
    {
      onClick: (h) => {
        c && c(h);
      },
      className: on(_d, t),
      disabled: s,
      "data-variant": n,
      "data-size": r,
      "data-inverse": a,
      ...u,
      children: [
        i && Bn.cloneElement(i, {
          ...i.props,
          className: on(Oo, i.props.className)
        }),
        e,
        o && Bn.cloneElement(o, {
          ...o.props,
          className: on(Oo, o.props.className)
        })
      ]
    }
  )
);
ec.displayName = "Button";
const Ld = `
  font-sans
  rounded-lg p-9 relative
  border border-solid border-gray-150
  transition-all

  bg-white
  text-gray-400
`, jd = `
    bg-cover bg-center
    w-full
    h-60
`;
function $d({ children: e, imageSRC: t }) {
  return /* @__PURE__ */ be("div", { className: Ld, children: [
    t && /* @__PURE__ */ M(
      "div",
      {
        className: jd,
        style: {
          backgroundImage: `url("${t}")`
        }
      }
    ),
    e
  ] });
}
function nt(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function Vo(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function tc(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((i) => {
      const o = Vo(i, t);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const o = r[i];
          typeof o == "function" ? o() : Vo(e[i], null);
        }
      };
  };
}
function St(...e) {
  return m.useCallback(tc(...e), e);
}
function Bd(e, t) {
  const n = m.createContext(t), r = (o) => {
    const { children: s, ...a } = o, c = m.useMemo(() => a, Object.values(a));
    return /* @__PURE__ */ M(n.Provider, { value: c, children: s });
  };
  r.displayName = e + "Provider";
  function i(o) {
    const s = m.useContext(n);
    if (s) return s;
    if (t !== void 0) return t;
    throw new Error(`\`${o}\` must be used within \`${e}\``);
  }
  return [r, i];
}
function Ud(e, t = []) {
  let n = [];
  function r(o, s) {
    const a = m.createContext(s), c = n.length;
    n = [...n, s];
    const l = (f) => {
      var v;
      const { scope: d, children: h, ...g } = f, p = ((v = d == null ? void 0 : d[e]) == null ? void 0 : v[c]) || a, y = m.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ M(p.Provider, { value: y, children: h });
    };
    l.displayName = o + "Provider";
    function u(f, d) {
      var p;
      const h = ((p = d == null ? void 0 : d[e]) == null ? void 0 : p[c]) || a, g = m.useContext(h);
      if (g) return g;
      if (s !== void 0) return s;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [l, u];
  }
  const i = () => {
    const o = n.map((s) => m.createContext(s));
    return function(a) {
      const c = (a == null ? void 0 : a[e]) || o;
      return m.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: c } }),
        [a, c]
      );
    };
  };
  return i.scopeName = e, [r, zd(i, ...t)];
}
function zd(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const s = r.reduce((a, { useScope: c, scopeName: l }) => {
        const f = c(o)[`__scope${l}`];
        return { ...a, ...f };
      }, {});
      return m.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var Zn = globalThis != null && globalThis.document ? m.useLayoutEffect : () => {
}, Wd = m.useId || (() => {
}), Gd = 0;
function br(e) {
  const [t, n] = m.useState(Wd());
  return Zn(() => {
    n((r) => r ?? String(Gd++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
function bt(e) {
  const t = m.useRef(e);
  return m.useEffect(() => {
    t.current = e;
  }), m.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function Hd({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, i] = Kd({ defaultProp: t, onChange: n }), o = e !== void 0, s = o ? e : r, a = bt(n), c = m.useCallback(
    (l) => {
      if (o) {
        const f = typeof l == "function" ? l(e) : l;
        f !== e && a(f);
      } else
        i(l);
    },
    [o, e, i, a]
  );
  return [s, c];
}
function Kd({
  defaultProp: e,
  onChange: t
}) {
  const n = m.useState(e), [r] = n, i = m.useRef(r), o = bt(t);
  return m.useEffect(() => {
    i.current !== r && (o(r), i.current = r);
  }, [r, i, o]), n;
}
var Ri = m.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = m.Children.toArray(n), o = i.find(Zd);
  if (o) {
    const s = o.props.children, a = i.map((c) => c === o ? m.Children.count(s) > 1 ? m.Children.only(null) : m.isValidElement(s) ? s.props.children : null : c);
    return /* @__PURE__ */ M(Xr, { ...r, ref: t, children: m.isValidElement(s) ? m.cloneElement(s, void 0, a) : null });
  }
  return /* @__PURE__ */ M(Xr, { ...r, ref: t, children: n });
});
Ri.displayName = "Slot";
var Xr = m.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (m.isValidElement(n)) {
    const i = qd(n), o = Xd(r, n.props);
    return n.type !== m.Fragment && (o.ref = t ? tc(t, i) : i), m.cloneElement(n, o);
  }
  return m.Children.count(n) > 1 ? m.Children.only(null) : null;
});
Xr.displayName = "SlotClone";
var Yd = ({ children: e }) => /* @__PURE__ */ M(Yn, { children: e });
function Zd(e) {
  return m.isValidElement(e) && e.type === Yd;
}
function Xd(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...a) => {
      o(...a), i(...a);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function qd(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Jd = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Ze = Jd.reduce((e, t) => {
  const n = m.forwardRef((r, i) => {
    const { asChild: o, ...s } = r, a = o ? Ri : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ M(a, { ...s, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Qd(e, t) {
  e && nd.flushSync(() => e.dispatchEvent(t));
}
function ef(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = bt(e);
  m.useEffect(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var tf = "DismissableLayer", qr = "dismissableLayer.update", nf = "dismissableLayer.pointerDownOutside", rf = "dismissableLayer.focusOutside", Fo, nc = m.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), rc = m.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: o,
      onInteractOutside: s,
      onDismiss: a,
      ...c
    } = e, l = m.useContext(nc), [u, f] = m.useState(null), d = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = m.useState({}), g = St(t, (P) => f(P)), p = Array.from(l.layers), [y] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), v = p.indexOf(y), x = u ? p.indexOf(u) : -1, T = l.layersWithOutsidePointerEventsDisabled.size > 0, E = x >= v, b = af((P) => {
      const S = P.target, I = [...l.branches].some((G) => G.contains(S));
      !E || I || (i == null || i(P), s == null || s(P), P.defaultPrevented || a == null || a());
    }, d), A = cf((P) => {
      const S = P.target;
      [...l.branches].some((G) => G.contains(S)) || (o == null || o(P), s == null || s(P), P.defaultPrevented || a == null || a());
    }, d);
    return ef((P) => {
      x === l.layers.size - 1 && (r == null || r(P), !P.defaultPrevented && a && (P.preventDefault(), a()));
    }, d), m.useEffect(() => {
      if (u)
        return n && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (Fo = d.body.style.pointerEvents, d.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(u)), l.layers.add(u), ko(), () => {
          n && l.layersWithOutsidePointerEventsDisabled.size === 1 && (d.body.style.pointerEvents = Fo);
        };
    }, [u, d, n, l]), m.useEffect(() => () => {
      u && (l.layers.delete(u), l.layersWithOutsidePointerEventsDisabled.delete(u), ko());
    }, [u, l]), m.useEffect(() => {
      const P = () => h({});
      return document.addEventListener(qr, P), () => document.removeEventListener(qr, P);
    }, []), /* @__PURE__ */ M(
      Ze.div,
      {
        ...c,
        ref: g,
        style: {
          pointerEvents: T ? E ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: nt(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: nt(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: nt(
          e.onPointerDownCapture,
          b.onPointerDownCapture
        )
      }
    );
  }
);
rc.displayName = tf;
var of = "DismissableLayerBranch", sf = m.forwardRef((e, t) => {
  const n = m.useContext(nc), r = m.useRef(null), i = St(t, r);
  return m.useEffect(() => {
    const o = r.current;
    if (o)
      return n.branches.add(o), () => {
        n.branches.delete(o);
      };
  }, [n.branches]), /* @__PURE__ */ M(Ze.div, { ...e, ref: i });
});
sf.displayName = of;
function af(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = bt(e), r = m.useRef(!1), i = m.useRef(() => {
  });
  return m.useEffect(() => {
    const o = (a) => {
      if (a.target && !r.current) {
        let c = function() {
          ic(
            nf,
            n,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: a };
        a.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = c, t.addEventListener("click", i.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", o), t.removeEventListener("click", i.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function cf(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = bt(e), r = m.useRef(!1);
  return m.useEffect(() => {
    const i = (o) => {
      o.target && !r.current && ic(rf, n, { originalEvent: o }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function ko() {
  const e = new CustomEvent(qr);
  document.dispatchEvent(e);
}
function ic(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? Qd(i, o) : i.dispatchEvent(o);
}
var wr = "focusScope.autoFocusOnMount", Tr = "focusScope.autoFocusOnUnmount", Io = { bubbles: !1, cancelable: !0 }, lf = "FocusScope", oc = m.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: o,
    ...s
  } = e, [a, c] = m.useState(null), l = bt(i), u = bt(o), f = m.useRef(null), d = St(t, (p) => c(p)), h = m.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  m.useEffect(() => {
    if (r) {
      let p = function(T) {
        if (h.paused || !a) return;
        const E = T.target;
        a.contains(E) ? f.current = E : Je(f.current, { select: !0 });
      }, y = function(T) {
        if (h.paused || !a) return;
        const E = T.relatedTarget;
        E !== null && (a.contains(E) || Je(f.current, { select: !0 }));
      }, v = function(T) {
        if (document.activeElement === document.body)
          for (const b of T)
            b.removedNodes.length > 0 && Je(a);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", y);
      const x = new MutationObserver(v);
      return a && x.observe(a, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", y), x.disconnect();
      };
    }
  }, [r, a, h.paused]), m.useEffect(() => {
    if (a) {
      _o.add(h);
      const p = document.activeElement;
      if (!a.contains(p)) {
        const v = new CustomEvent(wr, Io);
        a.addEventListener(wr, l), a.dispatchEvent(v), v.defaultPrevented || (uf(mf(sc(a)), { select: !0 }), document.activeElement === p && Je(a));
      }
      return () => {
        a.removeEventListener(wr, l), setTimeout(() => {
          const v = new CustomEvent(Tr, Io);
          a.addEventListener(Tr, u), a.dispatchEvent(v), v.defaultPrevented || Je(p ?? document.body, { select: !0 }), a.removeEventListener(Tr, u), _o.remove(h);
        }, 0);
      };
    }
  }, [a, l, u, h]);
  const g = m.useCallback(
    (p) => {
      if (!n && !r || h.paused) return;
      const y = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, v = document.activeElement;
      if (y && v) {
        const x = p.currentTarget, [T, E] = df(x);
        T && E ? !p.shiftKey && v === E ? (p.preventDefault(), n && Je(T, { select: !0 })) : p.shiftKey && v === T && (p.preventDefault(), n && Je(E, { select: !0 })) : v === x && p.preventDefault();
      }
    },
    [n, r, h.paused]
  );
  return /* @__PURE__ */ M(Ze.div, { tabIndex: -1, ...s, ref: d, onKeyDown: g });
});
oc.displayName = lf;
function uf(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Je(r, { select: t }), document.activeElement !== n) return;
}
function df(e) {
  const t = sc(e), n = No(t, e), r = No(t.reverse(), e);
  return [n, r];
}
function sc(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function No(e, t) {
  for (const n of e)
    if (!ff(n, { upTo: t })) return n;
}
function ff(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function hf(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Je(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && hf(e) && t && e.select();
  }
}
var _o = pf();
function pf() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Lo(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Lo(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function Lo(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function mf(e) {
  return e.filter((t) => t.tagName !== "A");
}
var gf = "Portal", ac = m.forwardRef((e, t) => {
  var a;
  const { container: n, ...r } = e, [i, o] = m.useState(!1);
  Zn(() => o(!0), []);
  const s = n || i && ((a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : a.body);
  return s ? rd.createPortal(/* @__PURE__ */ M(Ze.div, { ...r, ref: t }), s) : null;
});
ac.displayName = gf;
function yf(e, t) {
  return m.useReducer((n, r) => t[n][r] ?? n, e);
}
var ir = (e) => {
  const { present: t, children: n } = e, r = vf(t), i = typeof n == "function" ? n({ present: r.isPresent }) : m.Children.only(n), o = St(r.ref, bf(i));
  return typeof n == "function" || r.isPresent ? m.cloneElement(i, { ref: o }) : null;
};
ir.displayName = "Presence";
function vf(e) {
  const [t, n] = m.useState(), r = m.useRef({}), i = m.useRef(e), o = m.useRef("none"), s = e ? "mounted" : "unmounted", [a, c] = yf(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return m.useEffect(() => {
    const l = On(r.current);
    o.current = a === "mounted" ? l : "none";
  }, [a]), Zn(() => {
    const l = r.current, u = i.current;
    if (u !== e) {
      const d = o.current, h = On(l);
      e ? c("MOUNT") : h === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(u && d !== h ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, c]), Zn(() => {
    if (t) {
      let l;
      const u = t.ownerDocument.defaultView ?? window, f = (h) => {
        const p = On(r.current).includes(h.animationName);
        if (h.target === t && p && (c("ANIMATION_END"), !i.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, d = (h) => {
        h.target === t && (o.current = On(r.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        u.clearTimeout(l), t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: m.useCallback((l) => {
      l && (r.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function On(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function bf(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var xr = 0;
function wf() {
  m.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? jo()), document.body.insertAdjacentElement("beforeend", e[1] ?? jo()), xr++, () => {
      xr === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), xr--;
    };
  }, []);
}
function jo() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var ke = function() {
  return ke = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, ke.apply(this, arguments);
};
function cc(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function Tf(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var Un = "right-scroll-bar-position", zn = "width-before-scroll-bar", xf = "with-scroll-bars-hidden", Sf = "--removed-body-scroll-bar-size";
function Sr(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Ef(e, t) {
  var n = rr(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var Af = typeof window < "u" ? m.useLayoutEffect : m.useEffect, $o = /* @__PURE__ */ new WeakMap();
function Pf(e, t) {
  var n = Ef(null, function(r) {
    return e.forEach(function(i) {
      return Sr(i, r);
    });
  });
  return Af(function() {
    var r = $o.get(n);
    if (r) {
      var i = new Set(r), o = new Set(e), s = n.current;
      i.forEach(function(a) {
        o.has(a) || Sr(a, null);
      }), o.forEach(function(a) {
        i.has(a) || Sr(a, s);
      });
    }
    $o.set(n, e);
  }, [e]), n;
}
function Cf(e) {
  return e;
}
function Mf(e, t) {
  t === void 0 && (t = Cf);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(o) {
      var s = t(o, r);
      return n.push(s), function() {
        n = n.filter(function(a) {
          return a !== s;
        });
      };
    },
    assignSyncMedium: function(o) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(o);
      }
      n = {
        push: function(a) {
          return o(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(o) {
      r = !0;
      var s = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(o), s = n;
      }
      var c = function() {
        var u = s;
        s = [], u.forEach(o);
      }, l = function() {
        return Promise.resolve().then(c);
      };
      l(), n = {
        push: function(u) {
          s.push(u), l();
        },
        filter: function(u) {
          return s = s.filter(u), n;
        }
      };
    }
  };
  return i;
}
function Rf(e) {
  e === void 0 && (e = {});
  var t = Mf(null);
  return t.options = ke({ async: !0, ssr: !1 }, e), t;
}
var lc = function(e) {
  var t = e.sideCar, n = cc(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return m.createElement(r, ke({}, n));
};
lc.isSideCarExport = !0;
function Df(e, t) {
  return e.useMedium(t), lc;
}
var uc = Rf(), Er = function() {
}, or = m.forwardRef(function(e, t) {
  var n = m.useRef(null), r = m.useState({
    onScrollCapture: Er,
    onWheelCapture: Er,
    onTouchMoveCapture: Er
  }), i = r[0], o = r[1], s = e.forwardProps, a = e.children, c = e.className, l = e.removeScrollBar, u = e.enabled, f = e.shards, d = e.sideCar, h = e.noIsolation, g = e.inert, p = e.allowPinchZoom, y = e.as, v = y === void 0 ? "div" : y, x = e.gapMode, T = cc(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), E = d, b = Pf([n, t]), A = ke(ke({}, T), i);
  return m.createElement(
    m.Fragment,
    null,
    u && m.createElement(E, { sideCar: uc, removeScrollBar: l, shards: f, noIsolation: h, inert: g, setCallbacks: o, allowPinchZoom: !!p, lockRef: n, gapMode: x }),
    s ? m.cloneElement(m.Children.only(a), ke(ke({}, A), { ref: b })) : m.createElement(v, ke({}, A, { className: c, ref: b }), a)
  );
});
or.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
or.classNames = {
  fullWidth: zn,
  zeroRight: Un
};
var dc = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Of() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = dc();
  return t && e.setAttribute("nonce", t), e;
}
function Vf(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Ff(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var kf = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Of()) && (Vf(t, n), Ff(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, If = function() {
  var e = kf();
  return function(t, n) {
    m.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Nf = function() {
  var e = If(), t = function(n) {
    var r = n.styles, i = n.dynamic;
    return e(r, i), null;
  };
  return t;
}, _f = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Ar = function(e) {
  return parseInt(e || "", 10) || 0;
}, Lf = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Ar(n), Ar(r), Ar(i)];
}, jf = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return _f;
  var t = Lf(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, $f = Nf(), $t = "data-scroll-locked", Bf = function(e, t, n, r) {
  var i = e.left, o = e.top, s = e.right, a = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(xf, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body[`).concat($t, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Un, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(zn, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(Un, " .").concat(Un, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(zn, " .").concat(zn, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat($t, `] {
    `).concat(Sf, ": ").concat(a, `px;
  }
`);
}, Bo = function() {
  var e = parseInt(document.body.getAttribute($t) || "0", 10);
  return isFinite(e) ? e : 0;
}, Uf = function() {
  m.useEffect(function() {
    return document.body.setAttribute($t, (Bo() + 1).toString()), function() {
      var e = Bo() - 1;
      e <= 0 ? document.body.removeAttribute($t) : document.body.setAttribute($t, e.toString());
    };
  }, []);
}, zf = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
  Uf();
  var o = m.useMemo(function() {
    return jf(i);
  }, [i]);
  return m.createElement($f, { styles: Bf(o, !t, i, n ? "" : "!important") });
};
function Wf() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = dc();
  return t && e.setAttribute("nonce", t), e;
}
function Gf(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Hf(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Kf = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Wf()) && (Gf(t, n), Hf(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Yf = function() {
  var e = Kf();
  return function(t, n) {
    m.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Zf = function() {
  var e = Yf(), t = function(n) {
    var r = n.styles, i = n.dynamic;
    return e(r, i), null;
  };
  return t;
}, Jr = !1;
if (typeof window < "u")
  try {
    var Vn = Object.defineProperty({}, "passive", {
      get: function() {
        return Jr = !0, !0;
      }
    });
    window.addEventListener("test", Vn, Vn), window.removeEventListener("test", Vn, Vn);
  } catch {
    Jr = !1;
  }
var Ot = Jr ? { passive: !1 } : !1, Xf = function(e) {
  return e.tagName === "TEXTAREA";
}, fc = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Xf(e) && n[t] === "visible")
  );
}, qf = function(e) {
  return fc(e, "overflowY");
}, Jf = function(e) {
  return fc(e, "overflowX");
}, Uo = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = hc(e, r);
    if (i) {
      var o = pc(e, r), s = o[1], a = o[2];
      if (s > a)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, Qf = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, eh = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, hc = function(e, t) {
  return e === "v" ? qf(t) : Jf(t);
}, pc = function(e, t) {
  return e === "v" ? Qf(t) : eh(t);
}, th = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, nh = function(e, t, n, r, i) {
  var o = th(e, window.getComputedStyle(t).direction), s = o * r, a = n.target, c = t.contains(a), l = !1, u = s > 0, f = 0, d = 0;
  do {
    var h = pc(e, a), g = h[0], p = h[1], y = h[2], v = p - y - o * g;
    (g || v) && hc(e, a) && (f += v, d += g), a instanceof ShadowRoot ? a = a.host : a = a.parentNode;
  } while (
    // portaled content
    !c && a !== document.body || // self content
    c && (t.contains(a) || t === a)
  );
  return (u && Math.abs(f) < 1 || !u && Math.abs(d) < 1) && (l = !0), l;
}, Fn = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, zo = function(e) {
  return [e.deltaX, e.deltaY];
}, Wo = function(e) {
  return e && "current" in e ? e.current : e;
}, rh = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, ih = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, oh = 0, Vt = [];
function sh(e) {
  var t = m.useRef([]), n = m.useRef([0, 0]), r = m.useRef(), i = m.useState(oh++)[0], o = m.useState(Zf)[0], s = m.useRef(e);
  m.useEffect(function() {
    s.current = e;
  }, [e]), m.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var p = Tf([e.lockRef.current], (e.shards || []).map(Wo), !0).filter(Boolean);
      return p.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), p.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = m.useCallback(function(p, y) {
    if ("touches" in p && p.touches.length === 2 || p.type === "wheel" && p.ctrlKey)
      return !s.current.allowPinchZoom;
    var v = Fn(p), x = n.current, T = "deltaX" in p ? p.deltaX : x[0] - v[0], E = "deltaY" in p ? p.deltaY : x[1] - v[1], b, A = p.target, P = Math.abs(T) > Math.abs(E) ? "h" : "v";
    if ("touches" in p && P === "h" && A.type === "range")
      return !1;
    var S = Uo(P, A);
    if (!S)
      return !0;
    if (S ? b = P : (b = P === "v" ? "h" : "v", S = Uo(P, A)), !S)
      return !1;
    if (!r.current && "changedTouches" in p && (T || E) && (r.current = b), !b)
      return !0;
    var I = r.current || b;
    return nh(I, y, p, I === "h" ? T : E);
  }, []), c = m.useCallback(function(p) {
    var y = p;
    if (!(!Vt.length || Vt[Vt.length - 1] !== o)) {
      var v = "deltaY" in y ? zo(y) : Fn(y), x = t.current.filter(function(b) {
        return b.name === y.type && (b.target === y.target || y.target === b.shadowParent) && rh(b.delta, v);
      })[0];
      if (x && x.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!x) {
        var T = (s.current.shards || []).map(Wo).filter(Boolean).filter(function(b) {
          return b.contains(y.target);
        }), E = T.length > 0 ? a(y, T[0]) : !s.current.noIsolation;
        E && y.cancelable && y.preventDefault();
      }
    }
  }, []), l = m.useCallback(function(p, y, v, x) {
    var T = { name: p, delta: y, target: v, should: x, shadowParent: ah(v) };
    t.current.push(T), setTimeout(function() {
      t.current = t.current.filter(function(E) {
        return E !== T;
      });
    }, 1);
  }, []), u = m.useCallback(function(p) {
    n.current = Fn(p), r.current = void 0;
  }, []), f = m.useCallback(function(p) {
    l(p.type, zo(p), p.target, a(p, e.lockRef.current));
  }, []), d = m.useCallback(function(p) {
    l(p.type, Fn(p), p.target, a(p, e.lockRef.current));
  }, []);
  m.useEffect(function() {
    return Vt.push(o), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: d
    }), document.addEventListener("wheel", c, Ot), document.addEventListener("touchmove", c, Ot), document.addEventListener("touchstart", u, Ot), function() {
      Vt = Vt.filter(function(p) {
        return p !== o;
      }), document.removeEventListener("wheel", c, Ot), document.removeEventListener("touchmove", c, Ot), document.removeEventListener("touchstart", u, Ot);
    };
  }, []);
  var h = e.removeScrollBar, g = e.inert;
  return m.createElement(
    m.Fragment,
    null,
    g ? m.createElement(o, { styles: ih(i) }) : null,
    h ? m.createElement(zf, { gapMode: e.gapMode }) : null
  );
}
function ah(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const ch = Df(uc, sh);
var mc = m.forwardRef(function(e, t) {
  return m.createElement(or, ke({}, e, { ref: t, sideCar: ch }));
});
mc.classNames = or.classNames;
var lh = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Ft = /* @__PURE__ */ new WeakMap(), kn = /* @__PURE__ */ new WeakMap(), In = {}, Pr = 0, gc = function(e) {
  return e && (e.host || gc(e.parentNode));
}, uh = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = gc(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, dh = function(e, t, n, r) {
  var i = uh(t, Array.isArray(e) ? e : [e]);
  In[n] || (In[n] = /* @__PURE__ */ new WeakMap());
  var o = In[n], s = [], a = /* @__PURE__ */ new Set(), c = new Set(i), l = function(f) {
    !f || a.has(f) || (a.add(f), l(f.parentNode));
  };
  i.forEach(l);
  var u = function(f) {
    !f || c.has(f) || Array.prototype.forEach.call(f.children, function(d) {
      if (a.has(d))
        u(d);
      else
        try {
          var h = d.getAttribute(r), g = h !== null && h !== "false", p = (Ft.get(d) || 0) + 1, y = (o.get(d) || 0) + 1;
          Ft.set(d, p), o.set(d, y), s.push(d), p === 1 && g && kn.set(d, !0), y === 1 && d.setAttribute(n, "true"), g || d.setAttribute(r, "true");
        } catch (v) {
          console.error("aria-hidden: cannot operate on ", d, v);
        }
    });
  };
  return u(t), a.clear(), Pr++, function() {
    s.forEach(function(f) {
      var d = Ft.get(f) - 1, h = o.get(f) - 1;
      Ft.set(f, d), o.set(f, h), d || (kn.has(f) || f.removeAttribute(r), kn.delete(f)), h || f.removeAttribute(n);
    }), Pr--, Pr || (Ft = /* @__PURE__ */ new WeakMap(), Ft = /* @__PURE__ */ new WeakMap(), kn = /* @__PURE__ */ new WeakMap(), In = {});
  };
}, fh = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), i = lh(e);
  return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live]"))), dh(r, i, n, "aria-hidden")) : function() {
    return null;
  };
}, Di = "Dialog", [yc, bT] = Ud(Di), [hh, Ve] = yc(Di), vc = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: o,
    modal: s = !0
  } = e, a = m.useRef(null), c = m.useRef(null), [l = !1, u] = Hd({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ M(
    hh,
    {
      scope: t,
      triggerRef: a,
      contentRef: c,
      contentId: br(),
      titleId: br(),
      descriptionId: br(),
      open: l,
      onOpenChange: u,
      onOpenToggle: m.useCallback(() => u((f) => !f), [u]),
      modal: s,
      children: n
    }
  );
};
vc.displayName = Di;
var bc = "DialogTrigger", ph = m.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Ve(bc, n), o = St(t, i.triggerRef);
    return /* @__PURE__ */ M(
      Ze.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": Fi(i.open),
        ...r,
        ref: o,
        onClick: nt(e.onClick, i.onOpenToggle)
      }
    );
  }
);
ph.displayName = bc;
var Oi = "DialogPortal", [mh, wc] = yc(Oi, {
  forceMount: void 0
}), Tc = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: i } = e, o = Ve(Oi, t);
  return /* @__PURE__ */ M(mh, { scope: t, forceMount: n, children: m.Children.map(r, (s) => /* @__PURE__ */ M(ir, { present: n || o.open, children: /* @__PURE__ */ M(ac, { asChild: !0, container: i, children: s }) })) });
};
Tc.displayName = Oi;
var Xn = "DialogOverlay", xc = m.forwardRef(
  (e, t) => {
    const n = wc(Xn, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = Ve(Xn, e.__scopeDialog);
    return o.modal ? /* @__PURE__ */ M(ir, { present: r || o.open, children: /* @__PURE__ */ M(gh, { ...i, ref: t }) }) : null;
  }
);
xc.displayName = Xn;
var gh = m.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Ve(Xn, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ M(mc, { as: Ri, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ M(
        Ze.div,
        {
          "data-state": Fi(i.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), wt = "DialogContent", Sc = m.forwardRef(
  (e, t) => {
    const n = wc(wt, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = Ve(wt, e.__scopeDialog);
    return /* @__PURE__ */ M(ir, { present: r || o.open, children: o.modal ? /* @__PURE__ */ M(yh, { ...i, ref: t }) : /* @__PURE__ */ M(vh, { ...i, ref: t }) });
  }
);
Sc.displayName = wt;
var yh = m.forwardRef(
  (e, t) => {
    const n = Ve(wt, e.__scopeDialog), r = m.useRef(null), i = St(t, n.contentRef, r);
    return m.useEffect(() => {
      const o = r.current;
      if (o) return fh(o);
    }, []), /* @__PURE__ */ M(
      Ec,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: nt(e.onCloseAutoFocus, (o) => {
          var s;
          o.preventDefault(), (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: nt(e.onPointerDownOutside, (o) => {
          const s = o.detail.originalEvent, a = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || a) && o.preventDefault();
        }),
        onFocusOutside: nt(
          e.onFocusOutside,
          (o) => o.preventDefault()
        )
      }
    );
  }
), vh = m.forwardRef(
  (e, t) => {
    const n = Ve(wt, e.__scopeDialog), r = m.useRef(!1), i = m.useRef(!1);
    return /* @__PURE__ */ M(
      Ec,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          var s, a;
          (s = e.onCloseAutoFocus) == null || s.call(e, o), o.defaultPrevented || (r.current || (a = n.triggerRef.current) == null || a.focus(), o.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (o) => {
          var c, l;
          (c = e.onInteractOutside) == null || c.call(e, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const s = o.target;
          ((l = n.triggerRef.current) == null ? void 0 : l.contains(s)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && i.current && o.preventDefault();
        }
      }
    );
  }
), Ec = m.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: o, ...s } = e, a = Ve(wt, n), c = m.useRef(null), l = St(t, c);
    return wf(), /* @__PURE__ */ be(Yn, { children: [
      /* @__PURE__ */ M(
        oc,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: i,
          onUnmountAutoFocus: o,
          children: /* @__PURE__ */ M(
            rc,
            {
              role: "dialog",
              id: a.contentId,
              "aria-describedby": a.descriptionId,
              "aria-labelledby": a.titleId,
              "data-state": Fi(a.open),
              ...s,
              ref: l,
              onDismiss: () => a.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ be(Yn, { children: [
        /* @__PURE__ */ M(wh, { titleId: a.titleId }),
        /* @__PURE__ */ M(xh, { contentRef: c, descriptionId: a.descriptionId })
      ] })
    ] });
  }
), Vi = "DialogTitle", Ac = m.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Ve(Vi, n);
    return /* @__PURE__ */ M(Ze.h2, { id: i.titleId, ...r, ref: t });
  }
);
Ac.displayName = Vi;
var Pc = "DialogDescription", Cc = m.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Ve(Pc, n);
    return /* @__PURE__ */ M(Ze.p, { id: i.descriptionId, ...r, ref: t });
  }
);
Cc.displayName = Pc;
var Mc = "DialogClose", bh = m.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Ve(Mc, n);
    return /* @__PURE__ */ M(
      Ze.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: nt(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
bh.displayName = Mc;
function Fi(e) {
  return e ? "open" : "closed";
}
var Rc = "DialogTitleWarning", [wT, Dc] = Bd(Rc, {
  contentName: wt,
  titleName: Vi,
  docsSlug: "dialog"
}), wh = ({ titleId: e }) => {
  const t = Dc(Rc), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return m.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, Th = "DialogDescriptionWarning", xh = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Dc(Th).contentName}}.`;
  return m.useEffect(() => {
    var o;
    const i = (o = e.current) == null ? void 0 : o.getAttribute("aria-describedby");
    t && i && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, Sh = vc, Eh = Tc, Ah = xc, Ph = Sc, Ch = Ac, Mh = Cc;
const Rh = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement("path", { d: "M140,32V64a12,12,0,0,1-24,0V32a12,12,0,0,1,24,0Zm33.25,62.75a12,12,0,0,0,8.49-3.52L204.37,68.6a12,12,0,0,0-17-17L164.77,74.26a12,12,0,0,0,8.48,20.49ZM224,116H192a12,12,0,0,0,0,24h32a12,12,0,0,0,0-24Zm-42.26,48.77a12,12,0,1,0-17,17l22.63,22.63a12,12,0,0,0,17-17ZM128,180a12,12,0,0,0-12,12v32a12,12,0,0,0,24,0V192A12,12,0,0,0,128,180ZM74.26,164.77,51.63,187.4a12,12,0,0,0,17,17l22.63-22.63a12,12,0,1,0-17-17ZM76,128a12,12,0,0,0-12-12H32a12,12,0,0,0,0,24H64A12,12,0,0,0,76,128ZM68.6,51.63a12,12,0,1,0-17,17L74.26,91.23a12,12,0,0,0,17-17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ m.createElement("path", { d: "M136,32V64a8,8,0,0,1-16,0V32a8,8,0,0,1,16,0Zm37.25,58.75a8,8,0,0,0,5.66-2.35l22.63-22.62a8,8,0,0,0-11.32-11.32L167.6,77.09a8,8,0,0,0,5.65,13.66ZM224,120H192a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm-45.09,47.6a8,8,0,0,0-11.31,11.31l22.62,22.63a8,8,0,0,0,11.32-11.32ZM128,184a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V192A8,8,0,0,0,128,184ZM77.09,167.6,54.46,190.22a8,8,0,0,0,11.32,11.32L88.4,178.91A8,8,0,0,0,77.09,167.6ZM72,128a8,8,0,0,0-8-8H32a8,8,0,0,0,0,16H64A8,8,0,0,0,72,128ZM65.78,54.46A8,8,0,0,0,54.46,65.78L77.09,88.4A8,8,0,0,0,88.4,77.09Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm33.94,58.75,17-17a8,8,0,0,1,11.32,11.32l-17,17a8,8,0,0,1-11.31-11.31ZM48,136a8,8,0,0,1,0-16H72a8,8,0,0,1,0,16Zm46.06,37.25-17,17a8,8,0,0,1-11.32-11.32l17-17a8,8,0,0,1,11.31,11.31Zm0-79.19a8,8,0,0,1-11.31,0l-17-17A8,8,0,0,1,77.09,65.77l17,17A8,8,0,0,1,94.06,94.06ZM136,208a8,8,0,0,1-16,0V184a8,8,0,0,1,16,0Zm0-136a8,8,0,0,1-16,0V48a8,8,0,0,1,16,0Zm54.23,118.23a8,8,0,0,1-11.32,0l-17-17a8,8,0,0,1,11.31-11.31l17,17A8,8,0,0,1,190.23,190.23ZM208,136H184a8,8,0,0,1,0-16h24a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement("path", { d: "M134,32V64a6,6,0,0,1-12,0V32a6,6,0,0,1,12,0Zm39.25,56.75A6,6,0,0,0,177.5,87l22.62-22.63a6,6,0,0,0-8.48-8.48L169,78.5a6,6,0,0,0,4.24,10.25ZM224,122H192a6,6,0,0,0,0,12h32a6,6,0,0,0,0-12Zm-46.5,47A6,6,0,0,0,169,177.5l22.63,22.62a6,6,0,0,0,8.48-8.48ZM128,186a6,6,0,0,0-6,6v32a6,6,0,0,0,12,0V192A6,6,0,0,0,128,186ZM78.5,169,55.88,191.64a6,6,0,1,0,8.48,8.48L87,177.5A6,6,0,1,0,78.5,169ZM70,128a6,6,0,0,0-6-6H32a6,6,0,0,0,0,12H64A6,6,0,0,0,70,128ZM64.36,55.88a6,6,0,0,0-8.48,8.48L78.5,87A6,6,0,1,0,87,78.5Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement("path", { d: "M136,32V64a8,8,0,0,1-16,0V32a8,8,0,0,1,16,0Zm37.25,58.75a8,8,0,0,0,5.66-2.35l22.63-22.62a8,8,0,0,0-11.32-11.32L167.6,77.09a8,8,0,0,0,5.65,13.66ZM224,120H192a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm-45.09,47.6a8,8,0,0,0-11.31,11.31l22.62,22.63a8,8,0,0,0,11.32-11.32ZM128,184a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V192A8,8,0,0,0,128,184ZM77.09,167.6,54.46,190.22a8,8,0,0,0,11.32,11.32L88.4,178.91A8,8,0,0,0,77.09,167.6ZM72,128a8,8,0,0,0-8-8H32a8,8,0,0,0,0,16H64A8,8,0,0,0,72,128ZM65.78,54.46A8,8,0,0,0,54.46,65.78L77.09,88.4A8,8,0,0,0,88.4,77.09Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement("path", { d: "M132,32V64a4,4,0,0,1-8,0V32a4,4,0,0,1,8,0Zm41.25,54.75a4,4,0,0,0,2.83-1.18L198.71,63a4,4,0,0,0-5.66-5.66L170.43,79.92a4,4,0,0,0,2.82,6.83ZM224,124H192a4,4,0,0,0,0,8h32a4,4,0,0,0,0-8Zm-47.92,46.43a4,4,0,1,0-5.65,5.65l22.62,22.63a4,4,0,0,0,5.66-5.66ZM128,188a4,4,0,0,0-4,4v32a4,4,0,0,0,8,0V192A4,4,0,0,0,128,188ZM79.92,170.43,57.29,193.05A4,4,0,0,0,63,198.71l22.62-22.63a4,4,0,1,0-5.65-5.65ZM68,128a4,4,0,0,0-4-4H32a4,4,0,0,0,0,8H64A4,4,0,0,0,68,128ZM63,57.29A4,4,0,0,0,57.29,63L79.92,85.57a4,4,0,1,0,5.65-5.65Z" }))
  ]
]), Dh = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement("path", { d: "M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement(
      "path",
      {
        d: "M216,56V200a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40H200A16,16,0,0,1,216,56Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ m.createElement("path", { d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM181.66,170.34a8,8,0,0,1-11.32,11.32L128,139.31,85.66,181.66a8,8,0,0,1-11.32-11.32L116.69,128,74.34,85.66A8,8,0,0,1,85.66,74.34L128,116.69l42.34-42.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement("path", { d: "M204.24,195.76a6,6,0,1,1-8.48,8.48L128,136.49,60.24,204.24a6,6,0,0,1-8.48-8.48L119.51,128,51.76,60.24a6,6,0,0,1,8.48-8.48L128,119.51l67.76-67.75a6,6,0,0,1,8.48,8.48L136.49,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement("path", { d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement("path", { d: "M202.83,197.17a4,4,0,0,1-5.66,5.66L128,133.66,58.83,202.83a4,4,0,0,1-5.66-5.66L122.34,128,53.17,58.83a4,4,0,0,1,5.66-5.66L128,122.34l69.17-69.17a4,4,0,1,1,5.66,5.66L133.66,128Z" }))
  ]
]), Oh = st({
  color: "currentColor",
  size: "1em",
  weight: "regular",
  mirrored: !1
}), ki = m.forwardRef(
  (e, t) => {
    const {
      alt: n,
      color: r,
      size: i,
      weight: o,
      mirrored: s,
      children: a,
      weights: c,
      ...l
    } = e, {
      color: u = "currentColor",
      size: f,
      weight: d = "regular",
      mirrored: h = !1,
      ...g
    } = m.useContext(Oh);
    return /* @__PURE__ */ m.createElement(
      "svg",
      {
        ref: t,
        xmlns: "http://www.w3.org/2000/svg",
        width: i ?? f,
        height: i ?? f,
        fill: r ?? u,
        viewBox: "0 0 256 256",
        transform: s || h ? "scale(-1, 1)" : void 0,
        ...g,
        ...l
      },
      !!n && /* @__PURE__ */ m.createElement("title", null, n),
      a,
      c.get(o ?? d)
    );
  }
);
ki.displayName = "IconBase";
const Oc = m.forwardRef((e, t) => /* @__PURE__ */ m.createElement(ki, { ref: t, ...e, weights: Rh }));
Oc.displayName = "SpinnerIcon";
const Ii = m.forwardRef((e, t) => /* @__PURE__ */ m.createElement(ki, { ref: t, ...e, weights: Dh }));
Ii.displayName = "XIcon";
const Vh = "fixed inset-0 bg-black/50 data-[state=open]:animate-overlayShow z-10", Fh = `
  fixed left-1/2 top-1/2 z-10
  -translate-x-1/2 -translate-y-1/2
  shadow-lg focus:outline-none

  data-[state=open]:animate-contentShow
`, kh = "flex flex-col gap-y-6 whitespace-pre-line", Ih = "flex items-center justify-between m-0 text-2xl text-gray-800", Nh = "m-0", _h = "h-8 w-8 cursor-pointer transition-colors hover:bg-gray-200 rounded-full flex items-center justify-center", Lh = "flex justify-end gap-2", TT = ({
  title: e,
  description: t,
  isOpen: n,
  children: r,
  onClose: i
}) => /* @__PURE__ */ M(Sh, { open: n, children: /* @__PURE__ */ be(Eh, { children: [
  /* @__PURE__ */ M(Ah, { className: Vh }),
  /* @__PURE__ */ M(Ph, { className: Fh, children: /* @__PURE__ */ M($d, { children: /* @__PURE__ */ be("div", { className: kh, children: [
    /* @__PURE__ */ be(Ch, { className: Ih, children: [
      /* @__PURE__ */ M("span", { children: e }),
      /* @__PURE__ */ M(Ii, { size: 32, className: _h, onClick: i })
    ] }),
    /* @__PURE__ */ M(Mh, { className: Nh, children: t }),
    /* @__PURE__ */ M("div", { className: Lh, children: r })
  ] }) }) })
] }) });
var jh = function(t) {
  return $h(t) && !Bh(t);
};
function $h(e) {
  return !!e && typeof e == "object";
}
function Bh(e) {
  var t = Object.prototype.toString.call(e);
  return t === "[object RegExp]" || t === "[object Date]" || Wh(e);
}
var Uh = typeof Symbol == "function" && Symbol.for, zh = Uh ? Symbol.for("react.element") : 60103;
function Wh(e) {
  return e.$$typeof === zh;
}
function Gh(e) {
  return Array.isArray(e) ? [] : {};
}
function qn(e, t) {
  return t.clone !== !1 && t.isMergeableObject(e) ? fn(Gh(e), e, t) : e;
}
function Hh(e, t, n) {
  return e.concat(t).map(function(r) {
    return qn(r, n);
  });
}
function Kh(e, t, n) {
  var r = {};
  return n.isMergeableObject(e) && Object.keys(e).forEach(function(i) {
    r[i] = qn(e[i], n);
  }), Object.keys(t).forEach(function(i) {
    !n.isMergeableObject(t[i]) || !e[i] ? r[i] = qn(t[i], n) : r[i] = fn(e[i], t[i], n);
  }), r;
}
function fn(e, t, n) {
  n = n || {}, n.arrayMerge = n.arrayMerge || Hh, n.isMergeableObject = n.isMergeableObject || jh;
  var r = Array.isArray(t), i = Array.isArray(e), o = r === i;
  return o ? r ? n.arrayMerge(e, t, n) : Kh(e, t, n) : qn(t, n);
}
fn.all = function(t, n) {
  if (!Array.isArray(t))
    throw new Error("first argument should be an array");
  return t.reduce(function(r, i) {
    return fn(r, i, n);
  }, {});
};
var Qr = fn, Vc = typeof global == "object" && global && global.Object === Object && global, Yh = typeof self == "object" && self && self.Object === Object && self, Le = Vc || Yh || Function("return this")(), rt = Le.Symbol, Fc = Object.prototype, Zh = Fc.hasOwnProperty, Xh = Fc.toString, en = rt ? rt.toStringTag : void 0;
function qh(e) {
  var t = Zh.call(e, en), n = e[en];
  try {
    e[en] = void 0;
    var r = !0;
  } catch {
  }
  var i = Xh.call(e);
  return r && (t ? e[en] = n : delete e[en]), i;
}
var Jh = Object.prototype, Qh = Jh.toString;
function ep(e) {
  return Qh.call(e);
}
var tp = "[object Null]", np = "[object Undefined]", Go = rt ? rt.toStringTag : void 0;
function Et(e) {
  return e == null ? e === void 0 ? np : tp : Go && Go in Object(e) ? qh(e) : ep(e);
}
function kc(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var Ni = kc(Object.getPrototypeOf, Object);
function At(e) {
  return e != null && typeof e == "object";
}
var rp = "[object Object]", ip = Function.prototype, op = Object.prototype, Ic = ip.toString, sp = op.hasOwnProperty, ap = Ic.call(Object);
function Ho(e) {
  if (!At(e) || Et(e) != rp)
    return !1;
  var t = Ni(e);
  if (t === null)
    return !0;
  var n = sp.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && Ic.call(n) == ap;
}
function cp() {
  this.__data__ = [], this.size = 0;
}
function Nc(e, t) {
  return e === t || e !== e && t !== t;
}
function sr(e, t) {
  for (var n = e.length; n--; )
    if (Nc(e[n][0], t))
      return n;
  return -1;
}
var lp = Array.prototype, up = lp.splice;
function dp(e) {
  var t = this.__data__, n = sr(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : up.call(t, n, 1), --this.size, !0;
}
function fp(e) {
  var t = this.__data__, n = sr(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function hp(e) {
  return sr(this.__data__, e) > -1;
}
function pp(e, t) {
  var n = this.__data__, r = sr(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
function Xe(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Xe.prototype.clear = cp;
Xe.prototype.delete = dp;
Xe.prototype.get = fp;
Xe.prototype.has = hp;
Xe.prototype.set = pp;
function mp() {
  this.__data__ = new Xe(), this.size = 0;
}
function gp(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function yp(e) {
  return this.__data__.get(e);
}
function vp(e) {
  return this.__data__.has(e);
}
function xn(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var bp = "[object AsyncFunction]", wp = "[object Function]", Tp = "[object GeneratorFunction]", xp = "[object Proxy]";
function _c(e) {
  if (!xn(e))
    return !1;
  var t = Et(e);
  return t == wp || t == Tp || t == bp || t == xp;
}
var Cr = Le["__core-js_shared__"], Ko = function() {
  var e = /[^.]+$/.exec(Cr && Cr.keys && Cr.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Sp(e) {
  return !!Ko && Ko in e;
}
var Ep = Function.prototype, Ap = Ep.toString;
function Pt(e) {
  if (e != null) {
    try {
      return Ap.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Pp = /[\\^$.*+?()[\]{}|]/g, Cp = /^\[object .+?Constructor\]$/, Mp = Function.prototype, Rp = Object.prototype, Dp = Mp.toString, Op = Rp.hasOwnProperty, Vp = RegExp(
  "^" + Dp.call(Op).replace(Pp, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Fp(e) {
  if (!xn(e) || Sp(e))
    return !1;
  var t = _c(e) ? Vp : Cp;
  return t.test(Pt(e));
}
function kp(e, t) {
  return e == null ? void 0 : e[t];
}
function Ct(e, t) {
  var n = kp(e, t);
  return Fp(n) ? n : void 0;
}
var hn = Ct(Le, "Map"), pn = Ct(Object, "create");
function Ip() {
  this.__data__ = pn ? pn(null) : {}, this.size = 0;
}
function Np(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var _p = "__lodash_hash_undefined__", Lp = Object.prototype, jp = Lp.hasOwnProperty;
function $p(e) {
  var t = this.__data__;
  if (pn) {
    var n = t[e];
    return n === _p ? void 0 : n;
  }
  return jp.call(t, e) ? t[e] : void 0;
}
var Bp = Object.prototype, Up = Bp.hasOwnProperty;
function zp(e) {
  var t = this.__data__;
  return pn ? t[e] !== void 0 : Up.call(t, e);
}
var Wp = "__lodash_hash_undefined__";
function Gp(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = pn && t === void 0 ? Wp : t, this;
}
function Tt(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Tt.prototype.clear = Ip;
Tt.prototype.delete = Np;
Tt.prototype.get = $p;
Tt.prototype.has = zp;
Tt.prototype.set = Gp;
function Hp() {
  this.size = 0, this.__data__ = {
    hash: new Tt(),
    map: new (hn || Xe)(),
    string: new Tt()
  };
}
function Kp(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function ar(e, t) {
  var n = e.__data__;
  return Kp(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function Yp(e) {
  var t = ar(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function Zp(e) {
  return ar(this, e).get(e);
}
function Xp(e) {
  return ar(this, e).has(e);
}
function qp(e, t) {
  var n = ar(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function at(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
at.prototype.clear = Hp;
at.prototype.delete = Yp;
at.prototype.get = Zp;
at.prototype.has = Xp;
at.prototype.set = qp;
var Jp = 200;
function Qp(e, t) {
  var n = this.__data__;
  if (n instanceof Xe) {
    var r = n.__data__;
    if (!hn || r.length < Jp - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new at(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
function Ht(e) {
  var t = this.__data__ = new Xe(e);
  this.size = t.size;
}
Ht.prototype.clear = mp;
Ht.prototype.delete = gp;
Ht.prototype.get = yp;
Ht.prototype.has = vp;
Ht.prototype.set = Qp;
function em(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var Yo = function() {
  try {
    var e = Ct(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
function Lc(e, t, n) {
  t == "__proto__" && Yo ? Yo(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var tm = Object.prototype, nm = tm.hasOwnProperty;
function jc(e, t, n) {
  var r = e[t];
  (!(nm.call(e, t) && Nc(r, n)) || n === void 0 && !(t in e)) && Lc(e, t, n);
}
function cr(e, t, n, r) {
  var i = !n;
  n || (n = {});
  for (var o = -1, s = t.length; ++o < s; ) {
    var a = t[o], c = void 0;
    c === void 0 && (c = e[a]), i ? Lc(n, a, c) : jc(n, a, c);
  }
  return n;
}
function rm(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var im = "[object Arguments]";
function Zo(e) {
  return At(e) && Et(e) == im;
}
var $c = Object.prototype, om = $c.hasOwnProperty, sm = $c.propertyIsEnumerable, am = Zo(/* @__PURE__ */ function() {
  return arguments;
}()) ? Zo : function(e) {
  return At(e) && om.call(e, "callee") && !sm.call(e, "callee");
}, Sn = Array.isArray;
function cm() {
  return !1;
}
var Bc = typeof exports == "object" && exports && !exports.nodeType && exports, Xo = Bc && typeof module == "object" && module && !module.nodeType && module, lm = Xo && Xo.exports === Bc, qo = lm ? Le.Buffer : void 0, um = qo ? qo.isBuffer : void 0, Uc = um || cm, dm = 9007199254740991, fm = /^(?:0|[1-9]\d*)$/;
function hm(e, t) {
  var n = typeof e;
  return t = t ?? dm, !!t && (n == "number" || n != "symbol" && fm.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var pm = 9007199254740991;
function zc(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= pm;
}
var mm = "[object Arguments]", gm = "[object Array]", ym = "[object Boolean]", vm = "[object Date]", bm = "[object Error]", wm = "[object Function]", Tm = "[object Map]", xm = "[object Number]", Sm = "[object Object]", Em = "[object RegExp]", Am = "[object Set]", Pm = "[object String]", Cm = "[object WeakMap]", Mm = "[object ArrayBuffer]", Rm = "[object DataView]", Dm = "[object Float32Array]", Om = "[object Float64Array]", Vm = "[object Int8Array]", Fm = "[object Int16Array]", km = "[object Int32Array]", Im = "[object Uint8Array]", Nm = "[object Uint8ClampedArray]", _m = "[object Uint16Array]", Lm = "[object Uint32Array]", H = {};
H[Dm] = H[Om] = H[Vm] = H[Fm] = H[km] = H[Im] = H[Nm] = H[_m] = H[Lm] = !0;
H[mm] = H[gm] = H[Mm] = H[ym] = H[Rm] = H[vm] = H[bm] = H[wm] = H[Tm] = H[xm] = H[Sm] = H[Em] = H[Am] = H[Pm] = H[Cm] = !1;
function jm(e) {
  return At(e) && zc(e.length) && !!H[Et(e)];
}
function _i(e) {
  return function(t) {
    return e(t);
  };
}
var Wc = typeof exports == "object" && exports && !exports.nodeType && exports, sn = Wc && typeof module == "object" && module && !module.nodeType && module, $m = sn && sn.exports === Wc, Mr = $m && Vc.process, Bt = function() {
  try {
    var e = sn && sn.require && sn.require("util").types;
    return e || Mr && Mr.binding && Mr.binding("util");
  } catch {
  }
}(), Jo = Bt && Bt.isTypedArray, Bm = Jo ? _i(Jo) : jm, Um = Object.prototype, zm = Um.hasOwnProperty;
function Gc(e, t) {
  var n = Sn(e), r = !n && am(e), i = !n && !r && Uc(e), o = !n && !r && !i && Bm(e), s = n || r || i || o, a = s ? rm(e.length, String) : [], c = a.length;
  for (var l in e)
    (t || zm.call(e, l)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    hm(l, c))) && a.push(l);
  return a;
}
var Wm = Object.prototype;
function Li(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || Wm;
  return e === n;
}
var Gm = kc(Object.keys, Object), Hm = Object.prototype, Km = Hm.hasOwnProperty;
function Ym(e) {
  if (!Li(e))
    return Gm(e);
  var t = [];
  for (var n in Object(e))
    Km.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function Hc(e) {
  return e != null && zc(e.length) && !_c(e);
}
function ji(e) {
  return Hc(e) ? Gc(e) : Ym(e);
}
function Zm(e, t) {
  return e && cr(t, ji(t), e);
}
function Xm(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var qm = Object.prototype, Jm = qm.hasOwnProperty;
function Qm(e) {
  if (!xn(e))
    return Xm(e);
  var t = Li(e), n = [];
  for (var r in e)
    r == "constructor" && (t || !Jm.call(e, r)) || n.push(r);
  return n;
}
function $i(e) {
  return Hc(e) ? Gc(e, !0) : Qm(e);
}
function eg(e, t) {
  return e && cr(t, $i(t), e);
}
var Kc = typeof exports == "object" && exports && !exports.nodeType && exports, Qo = Kc && typeof module == "object" && module && !module.nodeType && module, tg = Qo && Qo.exports === Kc, es = tg ? Le.Buffer : void 0, ts = es ? es.allocUnsafe : void 0;
function ng(e, t) {
  if (t)
    return e.slice();
  var n = e.length, r = ts ? ts(n) : new e.constructor(n);
  return e.copy(r), r;
}
function Yc(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
function rg(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = 0, o = []; ++n < r; ) {
    var s = e[n];
    t(s, n, e) && (o[i++] = s);
  }
  return o;
}
function Zc() {
  return [];
}
var ig = Object.prototype, og = ig.propertyIsEnumerable, ns = Object.getOwnPropertySymbols, Bi = ns ? function(e) {
  return e == null ? [] : (e = Object(e), rg(ns(e), function(t) {
    return og.call(e, t);
  }));
} : Zc;
function sg(e, t) {
  return cr(e, Bi(e), t);
}
function Xc(e, t) {
  for (var n = -1, r = t.length, i = e.length; ++n < r; )
    e[i + n] = t[n];
  return e;
}
var ag = Object.getOwnPropertySymbols, qc = ag ? function(e) {
  for (var t = []; e; )
    Xc(t, Bi(e)), e = Ni(e);
  return t;
} : Zc;
function cg(e, t) {
  return cr(e, qc(e), t);
}
function Jc(e, t, n) {
  var r = t(e);
  return Sn(e) ? r : Xc(r, n(e));
}
function lg(e) {
  return Jc(e, ji, Bi);
}
function ug(e) {
  return Jc(e, $i, qc);
}
var ei = Ct(Le, "DataView"), ti = Ct(Le, "Promise"), ni = Ct(Le, "Set"), ri = Ct(Le, "WeakMap"), rs = "[object Map]", dg = "[object Object]", is = "[object Promise]", os = "[object Set]", ss = "[object WeakMap]", as = "[object DataView]", fg = Pt(ei), hg = Pt(hn), pg = Pt(ti), mg = Pt(ni), gg = Pt(ri), We = Et;
(ei && We(new ei(new ArrayBuffer(1))) != as || hn && We(new hn()) != rs || ti && We(ti.resolve()) != is || ni && We(new ni()) != os || ri && We(new ri()) != ss) && (We = function(e) {
  var t = Et(e), n = t == dg ? e.constructor : void 0, r = n ? Pt(n) : "";
  if (r)
    switch (r) {
      case fg:
        return as;
      case hg:
        return rs;
      case pg:
        return is;
      case mg:
        return os;
      case gg:
        return ss;
    }
  return t;
});
var yg = Object.prototype, vg = yg.hasOwnProperty;
function bg(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && vg.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var cs = Le.Uint8Array;
function Ui(e) {
  var t = new e.constructor(e.byteLength);
  return new cs(t).set(new cs(e)), t;
}
function wg(e, t) {
  var n = t ? Ui(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var Tg = /\w*$/;
function xg(e) {
  var t = new e.constructor(e.source, Tg.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var ls = rt ? rt.prototype : void 0, us = ls ? ls.valueOf : void 0;
function Sg(e) {
  return us ? Object(us.call(e)) : {};
}
function Eg(e, t) {
  var n = t ? Ui(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var Ag = "[object Boolean]", Pg = "[object Date]", Cg = "[object Map]", Mg = "[object Number]", Rg = "[object RegExp]", Dg = "[object Set]", Og = "[object String]", Vg = "[object Symbol]", Fg = "[object ArrayBuffer]", kg = "[object DataView]", Ig = "[object Float32Array]", Ng = "[object Float64Array]", _g = "[object Int8Array]", Lg = "[object Int16Array]", jg = "[object Int32Array]", $g = "[object Uint8Array]", Bg = "[object Uint8ClampedArray]", Ug = "[object Uint16Array]", zg = "[object Uint32Array]";
function Wg(e, t, n) {
  var r = e.constructor;
  switch (t) {
    case Fg:
      return Ui(e);
    case Ag:
    case Pg:
      return new r(+e);
    case kg:
      return wg(e, n);
    case Ig:
    case Ng:
    case _g:
    case Lg:
    case jg:
    case $g:
    case Bg:
    case Ug:
    case zg:
      return Eg(e, n);
    case Cg:
      return new r();
    case Mg:
    case Og:
      return new r(e);
    case Rg:
      return xg(e);
    case Dg:
      return new r();
    case Vg:
      return Sg(e);
  }
}
var ds = Object.create, Gg = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!xn(t))
      return {};
    if (ds)
      return ds(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}();
function Hg(e) {
  return typeof e.constructor == "function" && !Li(e) ? Gg(Ni(e)) : {};
}
var Kg = "[object Map]";
function Yg(e) {
  return At(e) && We(e) == Kg;
}
var fs = Bt && Bt.isMap, Zg = fs ? _i(fs) : Yg, Xg = "[object Set]";
function qg(e) {
  return At(e) && We(e) == Xg;
}
var hs = Bt && Bt.isSet, Jg = hs ? _i(hs) : qg, Qg = 1, ey = 2, ty = 4, Qc = "[object Arguments]", ny = "[object Array]", ry = "[object Boolean]", iy = "[object Date]", oy = "[object Error]", el = "[object Function]", sy = "[object GeneratorFunction]", ay = "[object Map]", cy = "[object Number]", tl = "[object Object]", ly = "[object RegExp]", uy = "[object Set]", dy = "[object String]", fy = "[object Symbol]", hy = "[object WeakMap]", py = "[object ArrayBuffer]", my = "[object DataView]", gy = "[object Float32Array]", yy = "[object Float64Array]", vy = "[object Int8Array]", by = "[object Int16Array]", wy = "[object Int32Array]", Ty = "[object Uint8Array]", xy = "[object Uint8ClampedArray]", Sy = "[object Uint16Array]", Ey = "[object Uint32Array]", W = {};
W[Qc] = W[ny] = W[py] = W[my] = W[ry] = W[iy] = W[gy] = W[yy] = W[vy] = W[by] = W[wy] = W[ay] = W[cy] = W[tl] = W[ly] = W[uy] = W[dy] = W[fy] = W[Ty] = W[xy] = W[Sy] = W[Ey] = !0;
W[oy] = W[el] = W[hy] = !1;
function an(e, t, n, r, i, o) {
  var s, a = t & Qg, c = t & ey, l = t & ty;
  if (s !== void 0)
    return s;
  if (!xn(e))
    return e;
  var u = Sn(e);
  if (u) {
    if (s = bg(e), !a)
      return Yc(e, s);
  } else {
    var f = We(e), d = f == el || f == sy;
    if (Uc(e))
      return ng(e, a);
    if (f == tl || f == Qc || d && !i) {
      if (s = c || d ? {} : Hg(e), !a)
        return c ? cg(e, eg(s, e)) : sg(e, Zm(s, e));
    } else {
      if (!W[f])
        return i ? e : {};
      s = Wg(e, f, a);
    }
  }
  o || (o = new Ht());
  var h = o.get(e);
  if (h)
    return h;
  o.set(e, s), Jg(e) ? e.forEach(function(y) {
    s.add(an(y, t, n, y, e, o));
  }) : Zg(e) && e.forEach(function(y, v) {
    s.set(v, an(y, t, n, v, e, o));
  });
  var g = l ? c ? ug : lg : c ? $i : ji, p = u ? void 0 : g(e);
  return em(p || e, function(y, v) {
    p && (v = y, y = e[v]), jc(s, v, an(y, t, n, v, e, o));
  }), s;
}
var Ay = 1, Py = 4;
function nn(e) {
  return an(e, Ay | Py);
}
function nl(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Rr, ps;
function Cy() {
  if (ps) return Rr;
  ps = 1;
  var e = Array.isArray, t = Object.keys, n = Object.prototype.hasOwnProperty, r = typeof Element < "u";
  function i(o, s) {
    if (o === s) return !0;
    if (o && s && typeof o == "object" && typeof s == "object") {
      var a = e(o), c = e(s), l, u, f;
      if (a && c) {
        if (u = o.length, u != s.length) return !1;
        for (l = u; l-- !== 0; )
          if (!i(o[l], s[l])) return !1;
        return !0;
      }
      if (a != c) return !1;
      var d = o instanceof Date, h = s instanceof Date;
      if (d != h) return !1;
      if (d && h) return o.getTime() == s.getTime();
      var g = o instanceof RegExp, p = s instanceof RegExp;
      if (g != p) return !1;
      if (g && p) return o.toString() == s.toString();
      var y = t(o);
      if (u = y.length, u !== t(s).length)
        return !1;
      for (l = u; l-- !== 0; )
        if (!n.call(s, y[l])) return !1;
      if (r && o instanceof Element && s instanceof Element)
        return o === s;
      for (l = u; l-- !== 0; )
        if (f = y[l], !(f === "_owner" && o.$$typeof) && !i(o[f], s[f]))
          return !1;
      return !0;
    }
    return o !== o && s !== s;
  }
  return Rr = function(s, a) {
    try {
      return i(s, a);
    } catch (c) {
      if (c.message && c.message.match(/stack|recursion/i) || c.number === -2146828260)
        return console.warn("Warning: react-fast-compare does not handle circular references.", c.name, c.message), !1;
      throw c;
    }
  }, Rr;
}
var My = Cy();
const et = /* @__PURE__ */ nl(My);
var Ry = process.env.NODE_ENV === "production";
function Q(e, t) {
  if (!Ry) {
    var n = "Warning: " + t;
    typeof console < "u" && console.warn(n);
    try {
      throw Error(n);
    } catch {
    }
  }
}
var Dy = 4;
function ms(e) {
  return an(e, Dy);
}
function rl(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r; )
    i[n] = t(e[n], n, e);
  return i;
}
var Oy = "[object Symbol]";
function zi(e) {
  return typeof e == "symbol" || At(e) && Et(e) == Oy;
}
var Vy = "Expected a function";
function Wi(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(Vy);
  var n = function() {
    var r = arguments, i = t ? t.apply(this, r) : r[0], o = n.cache;
    if (o.has(i))
      return o.get(i);
    var s = e.apply(this, r);
    return n.cache = o.set(i, s) || o, s;
  };
  return n.cache = new (Wi.Cache || at)(), n;
}
Wi.Cache = at;
var Fy = 500;
function ky(e) {
  var t = Wi(e, function(r) {
    return n.size === Fy && n.clear(), r;
  }), n = t.cache;
  return t;
}
var Iy = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ny = /\\(\\)?/g, _y = ky(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Iy, function(n, r, i, o) {
    t.push(i ? o.replace(Ny, "$1") : r || n);
  }), t;
});
function Ly(e) {
  if (typeof e == "string" || zi(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var gs = rt ? rt.prototype : void 0, ys = gs ? gs.toString : void 0;
function il(e) {
  if (typeof e == "string")
    return e;
  if (Sn(e))
    return rl(e, il) + "";
  if (zi(e))
    return ys ? ys.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function jy(e) {
  return e == null ? "" : il(e);
}
function ol(e) {
  return Sn(e) ? rl(e, Ly) : zi(e) ? [e] : Yc(_y(jy(e)));
}
var Nn = { exports: {} }, $ = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vs;
function $y() {
  if (vs) return $;
  vs = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, p = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
  function T(b) {
    if (typeof b == "object" && b !== null) {
      var A = b.$$typeof;
      switch (A) {
        case t:
          switch (b = b.type, b) {
            case c:
            case l:
            case r:
            case o:
            case i:
            case f:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case a:
                case u:
                case g:
                case h:
                case s:
                  return b;
                default:
                  return A;
              }
          }
        case n:
          return A;
      }
    }
  }
  function E(b) {
    return T(b) === l;
  }
  return $.AsyncMode = c, $.ConcurrentMode = l, $.ContextConsumer = a, $.ContextProvider = s, $.Element = t, $.ForwardRef = u, $.Fragment = r, $.Lazy = g, $.Memo = h, $.Portal = n, $.Profiler = o, $.StrictMode = i, $.Suspense = f, $.isAsyncMode = function(b) {
    return E(b) || T(b) === c;
  }, $.isConcurrentMode = E, $.isContextConsumer = function(b) {
    return T(b) === a;
  }, $.isContextProvider = function(b) {
    return T(b) === s;
  }, $.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === t;
  }, $.isForwardRef = function(b) {
    return T(b) === u;
  }, $.isFragment = function(b) {
    return T(b) === r;
  }, $.isLazy = function(b) {
    return T(b) === g;
  }, $.isMemo = function(b) {
    return T(b) === h;
  }, $.isPortal = function(b) {
    return T(b) === n;
  }, $.isProfiler = function(b) {
    return T(b) === o;
  }, $.isStrictMode = function(b) {
    return T(b) === i;
  }, $.isSuspense = function(b) {
    return T(b) === f;
  }, $.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === r || b === l || b === o || b === i || b === f || b === d || typeof b == "object" && b !== null && (b.$$typeof === g || b.$$typeof === h || b.$$typeof === s || b.$$typeof === a || b.$$typeof === u || b.$$typeof === y || b.$$typeof === v || b.$$typeof === x || b.$$typeof === p);
  }, $.typeOf = T, $;
}
var B = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bs;
function By() {
  return bs || (bs = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, p = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
    function T(V) {
      return typeof V == "string" || typeof V == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      V === r || V === l || V === o || V === i || V === f || V === d || typeof V == "object" && V !== null && (V.$$typeof === g || V.$$typeof === h || V.$$typeof === s || V.$$typeof === a || V.$$typeof === u || V.$$typeof === y || V.$$typeof === v || V.$$typeof === x || V.$$typeof === p);
    }
    function E(V) {
      if (typeof V == "object" && V !== null) {
        var Mt = V.$$typeof;
        switch (Mt) {
          case t:
            var Rt = V.type;
            switch (Rt) {
              case c:
              case l:
              case r:
              case o:
              case i:
              case f:
                return Rt;
              default:
                var Mn = Rt && Rt.$$typeof;
                switch (Mn) {
                  case a:
                  case u:
                  case g:
                  case h:
                  case s:
                    return Mn;
                  default:
                    return Mt;
                }
            }
          case n:
            return Mt;
        }
      }
    }
    var b = c, A = l, P = a, S = s, I = t, G = u, he = r, Me = g, se = h, pe = n, we = o, me = i, z = f, O = !1;
    function Re(V) {
      return O || (O = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Te(V) || E(V) === c;
    }
    function Te(V) {
      return E(V) === l;
    }
    function je(V) {
      return E(V) === a;
    }
    function xe(V) {
      return E(V) === s;
    }
    function te(V) {
      return typeof V == "object" && V !== null && V.$$typeof === t;
    }
    function re(V) {
      return E(V) === u;
    }
    function ye(V) {
      return E(V) === r;
    }
    function lt(V) {
      return E(V) === g;
    }
    function K(V) {
      return E(V) === h;
    }
    function ut(V) {
      return E(V) === n;
    }
    function $e(V) {
      return E(V) === o;
    }
    function Be(V) {
      return E(V) === i;
    }
    function Ue(V) {
      return E(V) === f;
    }
    B.AsyncMode = b, B.ConcurrentMode = A, B.ContextConsumer = P, B.ContextProvider = S, B.Element = I, B.ForwardRef = G, B.Fragment = he, B.Lazy = Me, B.Memo = se, B.Portal = pe, B.Profiler = we, B.StrictMode = me, B.Suspense = z, B.isAsyncMode = Re, B.isConcurrentMode = Te, B.isContextConsumer = je, B.isContextProvider = xe, B.isElement = te, B.isForwardRef = re, B.isFragment = ye, B.isLazy = lt, B.isMemo = K, B.isPortal = ut, B.isProfiler = $e, B.isStrictMode = Be, B.isSuspense = Ue, B.isValidElementType = T, B.typeOf = E;
  }()), B;
}
var ws;
function Uy() {
  return ws || (ws = 1, process.env.NODE_ENV === "production" ? Nn.exports = $y() : Nn.exports = By()), Nn.exports;
}
var Dr, Ts;
function zy() {
  if (Ts) return Dr;
  Ts = 1;
  var e = Uy(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, n = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, r = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, i = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, o = {};
  o[e.ForwardRef] = r, o[e.Memo] = i;
  function s(g) {
    return e.isMemo(g) ? i : o[g.$$typeof] || t;
  }
  var a = Object.defineProperty, c = Object.getOwnPropertyNames, l = Object.getOwnPropertySymbols, u = Object.getOwnPropertyDescriptor, f = Object.getPrototypeOf, d = Object.prototype;
  function h(g, p, y) {
    if (typeof p != "string") {
      if (d) {
        var v = f(p);
        v && v !== d && h(g, v, y);
      }
      var x = c(p);
      l && (x = x.concat(l(p)));
      for (var T = s(g), E = s(p), b = 0; b < x.length; ++b) {
        var A = x[b];
        if (!n[A] && !(y && y[A]) && !(E && E[A]) && !(T && T[A])) {
          var P = u(p, A);
          try {
            a(g, A, P);
          } catch {
          }
        }
      }
    }
    return g;
  }
  return Dr = h, Dr;
}
var Wy = zy();
const Gy = /* @__PURE__ */ nl(Wy);
function U() {
  return U = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, U.apply(this, arguments);
}
function sl(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
function tt(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function xs(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
var lr = /* @__PURE__ */ st(void 0);
lr.displayName = "FormikContext";
var Hy = lr.Provider, Ky = lr.Consumer;
function Kt() {
  var e = ue(lr);
  return e || (process.env.NODE_ENV !== "production" ? Q(!1, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.") : Q()), e;
}
var Ss = function(t) {
  return Array.isArray(t) && t.length === 0;
}, oe = function(t) {
  return typeof t == "function";
}, Yt = function(t) {
  return t !== null && typeof t == "object";
}, Yy = function(t) {
  return String(Math.floor(Number(t))) === t;
}, Or = function(t) {
  return Object.prototype.toString.call(t) === "[object String]";
}, Gi = function(t) {
  return Pi.count(t) === 0;
}, Vr = function(t) {
  return Yt(t) && oe(t.then);
};
function Zy(e) {
  if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u")
    return null;
  try {
    return e.activeElement || e.body;
  } catch {
    return e.body;
  }
}
function Y(e, t, n, r) {
  r === void 0 && (r = 0);
  for (var i = ol(t); e && r < i.length; )
    e = e[i[r++]];
  return r !== i.length && !e || e === void 0 ? n : e;
}
function Ie(e, t, n) {
  for (var r = ms(e), i = r, o = 0, s = ol(t); o < s.length - 1; o++) {
    var a = s[o], c = Y(e, s.slice(0, o + 1));
    if (c && (Yt(c) || Array.isArray(c)))
      i = i[a] = ms(c);
    else {
      var l = s[o + 1];
      i = i[a] = Yy(l) && Number(l) >= 0 ? [] : {};
    }
  }
  return (o === 0 ? e : i)[s[o]] === n ? e : (n === void 0 ? delete i[s[o]] : i[s[o]] = n, o === 0 && n === void 0 && delete r[s[o]], r);
}
function al(e, t, n, r) {
  n === void 0 && (n = /* @__PURE__ */ new WeakMap()), r === void 0 && (r = {});
  for (var i = 0, o = Object.keys(e); i < o.length; i++) {
    var s = o[i], a = e[s];
    Yt(a) ? n.get(a) || (n.set(a, !0), r[s] = Array.isArray(a) ? [] : {}, al(a, t, n, r[s])) : r[s] = t;
  }
  return r;
}
function Xy(e, t) {
  switch (t.type) {
    case "SET_VALUES":
      return U({}, e, {
        values: t.payload
      });
    case "SET_TOUCHED":
      return U({}, e, {
        touched: t.payload
      });
    case "SET_ERRORS":
      return et(e.errors, t.payload) ? e : U({}, e, {
        errors: t.payload
      });
    case "SET_STATUS":
      return U({}, e, {
        status: t.payload
      });
    case "SET_ISSUBMITTING":
      return U({}, e, {
        isSubmitting: t.payload
      });
    case "SET_ISVALIDATING":
      return U({}, e, {
        isValidating: t.payload
      });
    case "SET_FIELD_VALUE":
      return U({}, e, {
        values: Ie(e.values, t.payload.field, t.payload.value)
      });
    case "SET_FIELD_TOUCHED":
      return U({}, e, {
        touched: Ie(e.touched, t.payload.field, t.payload.value)
      });
    case "SET_FIELD_ERROR":
      return U({}, e, {
        errors: Ie(e.errors, t.payload.field, t.payload.value)
      });
    case "RESET_FORM":
      return U({}, e, t.payload);
    case "SET_FORMIK_STATE":
      return t.payload(e);
    case "SUBMIT_ATTEMPT":
      return U({}, e, {
        touched: al(e.values, !0),
        isSubmitting: !0,
        submitCount: e.submitCount + 1
      });
    case "SUBMIT_FAILURE":
      return U({}, e, {
        isSubmitting: !1
      });
    case "SUBMIT_SUCCESS":
      return U({}, e, {
        isSubmitting: !1
      });
    default:
      return e;
  }
}
var ft = {}, _n = {};
function qy(e) {
  var t = e.validateOnChange, n = t === void 0 ? !0 : t, r = e.validateOnBlur, i = r === void 0 ? !0 : r, o = e.validateOnMount, s = o === void 0 ? !1 : o, a = e.isInitialValid, c = e.enableReinitialize, l = c === void 0 ? !1 : c, u = e.onSubmit, f = tt(e, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]), d = U({
    validateOnChange: n,
    validateOnBlur: i,
    validateOnMount: s,
    onSubmit: u
  }, f), h = ve(d.initialValues), g = ve(d.initialErrors || ft), p = ve(d.initialTouched || _n), y = ve(d.initialStatus), v = ve(!1), x = ve({});
  process.env.NODE_ENV !== "production" && le(function() {
    typeof a > "u" || (process.env.NODE_ENV !== "production" ? Q(!1, "isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead.") : Q());
  }, []), le(function() {
    return v.current = !0, function() {
      v.current = !1;
    };
  }, []);
  var T = rr(0), E = T[1], b = ve({
    values: nn(d.initialValues),
    errors: nn(d.initialErrors) || ft,
    touched: nn(d.initialTouched) || _n,
    status: nn(d.initialStatus),
    isSubmitting: !1,
    isValidating: !1,
    submitCount: 0
  }), A = b.current, P = J(function(w) {
    var C = b.current;
    b.current = Xy(C, w), C !== b.current && E(function(F) {
      return F + 1;
    });
  }, []), S = J(function(w, C) {
    return new Promise(function(F, k) {
      var L = d.validate(w, C);
      L == null ? F(ft) : Vr(L) ? L.then(function(j) {
        F(j || ft);
      }, function(j) {
        process.env.NODE_ENV !== "production" && console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", j), k(j);
      }) : F(L);
    });
  }, [d.validate]), I = J(function(w, C) {
    var F = d.validationSchema, k = oe(F) ? F(C) : F, L = C && k.validateAt ? k.validateAt(C, w) : ev(w, k);
    return new Promise(function(j, ae) {
      L.then(function() {
        j(ft);
      }, function(Fe) {
        Fe.name === "ValidationError" ? j(Qy(Fe)) : (process.env.NODE_ENV !== "production" && console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", Fe), ae(Fe));
      });
    });
  }, [d.validationSchema]), G = J(function(w, C) {
    return new Promise(function(F) {
      return F(x.current[w].validate(C));
    });
  }, []), he = J(function(w) {
    var C = Object.keys(x.current).filter(function(k) {
      return oe(x.current[k].validate);
    }), F = C.length > 0 ? C.map(function(k) {
      return G(k, Y(w, k));
    }) : [Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")];
    return Promise.all(F).then(function(k) {
      return k.reduce(function(L, j, ae) {
        return j === "DO_NOT_DELETE_YOU_WILL_BE_FIRED" || j && (L = Ie(L, C[ae], j)), L;
      }, {});
    });
  }, [G]), Me = J(function(w) {
    return Promise.all([he(w), d.validationSchema ? I(w) : {}, d.validate ? S(w) : {}]).then(function(C) {
      var F = C[0], k = C[1], L = C[2], j = Qr.all([F, k, L], {
        arrayMerge: tv
      });
      return j;
    });
  }, [d.validate, d.validationSchema, he, S, I]), se = Se(function(w) {
    return w === void 0 && (w = A.values), P({
      type: "SET_ISVALIDATING",
      payload: !0
    }), Me(w).then(function(C) {
      return v.current && (P({
        type: "SET_ISVALIDATING",
        payload: !1
      }), P({
        type: "SET_ERRORS",
        payload: C
      })), C;
    });
  });
  le(function() {
    s && v.current === !0 && et(h.current, d.initialValues) && se(h.current);
  }, [s, se]);
  var pe = J(function(w) {
    var C = w && w.values ? w.values : h.current, F = w && w.errors ? w.errors : g.current ? g.current : d.initialErrors || {}, k = w && w.touched ? w.touched : p.current ? p.current : d.initialTouched || {}, L = w && w.status ? w.status : y.current ? y.current : d.initialStatus;
    h.current = C, g.current = F, p.current = k, y.current = L;
    var j = function() {
      P({
        type: "RESET_FORM",
        payload: {
          isSubmitting: !!w && !!w.isSubmitting,
          errors: F,
          touched: k,
          status: L,
          values: C,
          isValidating: !!w && !!w.isValidating,
          submitCount: w && w.submitCount && typeof w.submitCount == "number" ? w.submitCount : 0
        }
      });
    };
    if (d.onReset) {
      var ae = d.onReset(A.values, Mt);
      Vr(ae) ? ae.then(j) : j();
    } else
      j();
  }, [d.initialErrors, d.initialStatus, d.initialTouched, d.onReset]);
  le(function() {
    v.current === !0 && !et(h.current, d.initialValues) && l && (h.current = d.initialValues, pe(), s && se(h.current));
  }, [l, d.initialValues, pe, s, se]), le(function() {
    l && v.current === !0 && !et(g.current, d.initialErrors) && (g.current = d.initialErrors || ft, P({
      type: "SET_ERRORS",
      payload: d.initialErrors || ft
    }));
  }, [l, d.initialErrors]), le(function() {
    l && v.current === !0 && !et(p.current, d.initialTouched) && (p.current = d.initialTouched || _n, P({
      type: "SET_TOUCHED",
      payload: d.initialTouched || _n
    }));
  }, [l, d.initialTouched]), le(function() {
    l && v.current === !0 && !et(y.current, d.initialStatus) && (y.current = d.initialStatus, P({
      type: "SET_STATUS",
      payload: d.initialStatus
    }));
  }, [l, d.initialStatus, d.initialTouched]);
  var we = Se(function(w) {
    if (x.current[w] && oe(x.current[w].validate)) {
      var C = Y(A.values, w), F = x.current[w].validate(C);
      return Vr(F) ? (P({
        type: "SET_ISVALIDATING",
        payload: !0
      }), F.then(function(k) {
        return k;
      }).then(function(k) {
        P({
          type: "SET_FIELD_ERROR",
          payload: {
            field: w,
            value: k
          }
        }), P({
          type: "SET_ISVALIDATING",
          payload: !1
        });
      })) : (P({
        type: "SET_FIELD_ERROR",
        payload: {
          field: w,
          value: F
        }
      }), Promise.resolve(F));
    } else if (d.validationSchema)
      return P({
        type: "SET_ISVALIDATING",
        payload: !0
      }), I(A.values, w).then(function(k) {
        return k;
      }).then(function(k) {
        P({
          type: "SET_FIELD_ERROR",
          payload: {
            field: w,
            value: Y(k, w)
          }
        }), P({
          type: "SET_ISVALIDATING",
          payload: !1
        });
      });
    return Promise.resolve();
  }), me = J(function(w, C) {
    var F = C.validate;
    x.current[w] = {
      validate: F
    };
  }, []), z = J(function(w) {
    delete x.current[w];
  }, []), O = Se(function(w, C) {
    P({
      type: "SET_TOUCHED",
      payload: w
    });
    var F = C === void 0 ? i : C;
    return F ? se(A.values) : Promise.resolve();
  }), Re = J(function(w) {
    P({
      type: "SET_ERRORS",
      payload: w
    });
  }, []), Te = Se(function(w, C) {
    var F = oe(w) ? w(A.values) : w;
    P({
      type: "SET_VALUES",
      payload: F
    });
    var k = C === void 0 ? n : C;
    return k ? se(F) : Promise.resolve();
  }), je = J(function(w, C) {
    P({
      type: "SET_FIELD_ERROR",
      payload: {
        field: w,
        value: C
      }
    });
  }, []), xe = Se(function(w, C, F) {
    P({
      type: "SET_FIELD_VALUE",
      payload: {
        field: w,
        value: C
      }
    });
    var k = F === void 0 ? n : F;
    return k ? se(Ie(A.values, w, C)) : Promise.resolve();
  }), te = J(function(w, C) {
    var F = C, k = w, L;
    if (!Or(w)) {
      w.persist && w.persist();
      var j = w.target ? w.target : w.currentTarget, ae = j.type, Fe = j.name, mr = j.id, gr = j.value, Xu = j.checked, qu = j.outerHTML, Po = j.options, Ju = j.multiple;
      F = C || Fe || mr, !F && process.env.NODE_ENV !== "production" && Es({
        htmlContent: qu,
        documentationAnchorLink: "handlechange-e-reactchangeeventany--void",
        handlerName: "handleChange"
      }), k = /number|range/.test(ae) ? (L = parseFloat(gr), isNaN(L) ? "" : L) : /checkbox/.test(ae) ? rv(Y(A.values, F), Xu, gr) : Po && Ju ? nv(Po) : gr;
    }
    F && xe(F, k);
  }, [xe, A.values]), re = Se(function(w) {
    if (Or(w))
      return function(C) {
        return te(C, w);
      };
    te(w);
  }), ye = Se(function(w, C, F) {
    C === void 0 && (C = !0), P({
      type: "SET_FIELD_TOUCHED",
      payload: {
        field: w,
        value: C
      }
    });
    var k = F === void 0 ? i : F;
    return k ? se(A.values) : Promise.resolve();
  }), lt = J(function(w, C) {
    w.persist && w.persist();
    var F = w.target, k = F.name, L = F.id, j = F.outerHTML, ae = C || k || L;
    !ae && process.env.NODE_ENV !== "production" && Es({
      htmlContent: j,
      documentationAnchorLink: "handleblur-e-any--void",
      handlerName: "handleBlur"
    }), ye(ae, !0);
  }, [ye]), K = Se(function(w) {
    if (Or(w))
      return function(C) {
        return lt(C, w);
      };
    lt(w);
  }), ut = J(function(w) {
    oe(w) ? P({
      type: "SET_FORMIK_STATE",
      payload: w
    }) : P({
      type: "SET_FORMIK_STATE",
      payload: function() {
        return w;
      }
    });
  }, []), $e = J(function(w) {
    P({
      type: "SET_STATUS",
      payload: w
    });
  }, []), Be = J(function(w) {
    P({
      type: "SET_ISSUBMITTING",
      payload: w
    });
  }, []), Ue = Se(function() {
    return P({
      type: "SUBMIT_ATTEMPT"
    }), se().then(function(w) {
      var C = w instanceof Error, F = !C && Object.keys(w).length === 0;
      if (F) {
        var k;
        try {
          if (k = Rt(), k === void 0)
            return;
        } catch (L) {
          throw L;
        }
        return Promise.resolve(k).then(function(L) {
          return v.current && P({
            type: "SUBMIT_SUCCESS"
          }), L;
        }).catch(function(L) {
          if (v.current)
            throw P({
              type: "SUBMIT_FAILURE"
            }), L;
        });
      } else if (v.current && (P({
        type: "SUBMIT_FAILURE"
      }), C))
        throw w;
    });
  }), V = Se(function(w) {
    if (w && w.preventDefault && oe(w.preventDefault) && w.preventDefault(), w && w.stopPropagation && oe(w.stopPropagation) && w.stopPropagation(), process.env.NODE_ENV !== "production" && typeof document < "u") {
      var C = Zy();
      C !== null && C instanceof HTMLButtonElement && (C.attributes && C.attributes.getNamedItem("type") || (process.env.NODE_ENV !== "production" ? Q(!1, 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.') : Q()));
    }
    Ue().catch(function(F) {
      console.warn("Warning: An unhandled error was caught from submitForm()", F);
    });
  }), Mt = {
    resetForm: pe,
    validateForm: se,
    validateField: we,
    setErrors: Re,
    setFieldError: je,
    setFieldTouched: ye,
    setFieldValue: xe,
    setStatus: $e,
    setSubmitting: Be,
    setTouched: O,
    setValues: Te,
    setFormikState: ut,
    submitForm: Ue
  }, Rt = Se(function() {
    return u(A.values, Mt);
  }), Mn = Se(function(w) {
    w && w.preventDefault && oe(w.preventDefault) && w.preventDefault(), w && w.stopPropagation && oe(w.stopPropagation) && w.stopPropagation(), pe();
  }), Gu = J(function(w) {
    return {
      value: Y(A.values, w),
      error: Y(A.errors, w),
      touched: !!Y(A.touched, w),
      initialValue: Y(h.current, w),
      initialTouched: !!Y(p.current, w),
      initialError: Y(g.current, w)
    };
  }, [A.errors, A.touched, A.values]), Hu = J(function(w) {
    return {
      setValue: function(F, k) {
        return xe(w, F, k);
      },
      setTouched: function(F, k) {
        return ye(w, F, k);
      },
      setError: function(F) {
        return je(w, F);
      }
    };
  }, [xe, ye, je]), Ku = J(function(w) {
    var C = Yt(w), F = C ? w.name : w, k = Y(A.values, F), L = {
      name: F,
      value: k,
      onChange: re,
      onBlur: K
    };
    if (C) {
      var j = w.type, ae = w.value, Fe = w.as, mr = w.multiple;
      j === "checkbox" ? ae === void 0 ? L.checked = !!k : (L.checked = !!(Array.isArray(k) && ~k.indexOf(ae)), L.value = ae) : j === "radio" ? (L.checked = k === ae, L.value = ae) : Fe === "select" && mr && (L.value = L.value || [], L.multiple = !0);
    }
    return L;
  }, [K, re, A.values]), pr = Ge(function() {
    return !et(h.current, A.values);
  }, [h.current, A.values]), Yu = Ge(function() {
    return typeof a < "u" ? pr ? A.errors && Object.keys(A.errors).length === 0 : a !== !1 && oe(a) ? a(d) : a : A.errors && Object.keys(A.errors).length === 0;
  }, [a, pr, A.errors, d]), Zu = U({}, A, {
    initialValues: h.current,
    initialErrors: g.current,
    initialTouched: p.current,
    initialStatus: y.current,
    handleBlur: K,
    handleChange: re,
    handleReset: Mn,
    handleSubmit: V,
    resetForm: pe,
    setErrors: Re,
    setFormikState: ut,
    setFieldTouched: ye,
    setFieldValue: xe,
    setFieldError: je,
    setStatus: $e,
    setSubmitting: Be,
    setTouched: O,
    setValues: Te,
    submitForm: Ue,
    validateForm: se,
    validateField: we,
    isValid: Yu,
    dirty: pr,
    unregisterField: z,
    registerField: me,
    getFieldProps: Ku,
    getFieldMeta: Gu,
    getFieldHelpers: Hu,
    validateOnBlur: i,
    validateOnChange: n,
    validateOnMount: s
  });
  return Zu;
}
function Jy(e) {
  var t = qy(e), n = e.component, r = e.children, i = e.render, o = e.innerRef;
  return Qu(o, function() {
    return t;
  }), process.env.NODE_ENV !== "production" && le(function() {
    e.render && (process.env.NODE_ENV !== "production" ? Q(!1, "<Formik render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Formik render={(props) => ...} /> with <Formik>{(props) => ...}</Formik>") : Q());
  }, []), Pe(Hy, {
    value: t
  }, n ? Pe(n, t) : i ? i(t) : r ? oe(r) ? r(t) : Gi(r) ? null : Pi.only(r) : null);
}
function Es(e) {
  var t = e.htmlContent, n = e.documentationAnchorLink, r = e.handlerName;
  console.warn("Warning: Formik called `" + r + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + t + `
    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#` + n + `
  `);
}
function Qy(e) {
  var t = {};
  if (e.inner) {
    if (e.inner.length === 0)
      return Ie(t, e.path, e.message);
    for (var i = e.inner, n = Array.isArray(i), r = 0, i = n ? i : i[Symbol.iterator](); ; ) {
      var o;
      if (n) {
        if (r >= i.length) break;
        o = i[r++];
      } else {
        if (r = i.next(), r.done) break;
        o = r.value;
      }
      var s = o;
      Y(t, s.path) || (t = Ie(t, s.path, s.message));
    }
  }
  return t;
}
function ev(e, t, n, r) {
  n === void 0 && (n = !1);
  var i = ii(e);
  return t[n ? "validateSync" : "validate"](i, {
    abortEarly: !1,
    context: i
  });
}
function ii(e) {
  var t = Array.isArray(e) ? [] : {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      var r = String(n);
      Array.isArray(e[r]) === !0 ? t[r] = e[r].map(function(i) {
        return Array.isArray(i) === !0 || Ho(i) ? ii(i) : i !== "" ? i : void 0;
      }) : Ho(e[r]) ? t[r] = ii(e[r]) : t[r] = e[r] !== "" ? e[r] : void 0;
    }
  return t;
}
function tv(e, t, n) {
  var r = e.slice();
  return t.forEach(function(o, s) {
    if (typeof r[s] > "u") {
      var a = n.clone !== !1, c = a && n.isMergeableObject(o);
      r[s] = c ? Qr(Array.isArray(o) ? [] : {}, o, n) : o;
    } else n.isMergeableObject(o) ? r[s] = Qr(e[s], o, n) : e.indexOf(o) === -1 && r.push(o);
  }), r;
}
function nv(e) {
  return Array.from(e).filter(function(t) {
    return t.selected;
  }).map(function(t) {
    return t.value;
  });
}
function rv(e, t, n) {
  if (typeof e == "boolean")
    return !!t;
  var r = [], i = !1, o = -1;
  if (Array.isArray(e))
    r = e, o = e.indexOf(n), i = o >= 0;
  else if (!n || n == "true" || n == "false")
    return !!t;
  return t && n && !i ? r.concat(n) : i ? r.slice(0, o).concat(r.slice(o + 1)) : r;
}
var iv = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? Ba : le;
function Se(e) {
  var t = ve(e);
  return iv(function() {
    t.current = e;
  }), J(function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return t.current.apply(void 0, r);
  }, []);
}
function ur(e) {
  var t = Kt(), n = t.getFieldProps, r = t.getFieldMeta, i = t.getFieldHelpers, o = t.registerField, s = t.unregisterField, a = Yt(e), c = a ? e : {
    name: e
  }, l = c.name, u = c.validate;
  le(function() {
    return l && o(l, {
      validate: u
    }), function() {
      l && s(l);
    };
  }, [o, s, l, u]), process.env.NODE_ENV !== "production" && (t || (process.env.NODE_ENV !== "production" ? Q(!1, "useField() / <Field /> must be used underneath a <Formik> component or withFormik() higher order component") : Q())), l || (process.env.NODE_ENV !== "production" ? Q(!1, "Invalid field name. Either pass `useField` a string or an object containing a `name` key.") : Q());
  var f = Ge(function() {
    return i(l);
  }, [i, l]);
  return [n(c), r(l), f];
}
function cl(e) {
  var t = e.validate, n = e.name, r = e.render, i = e.children, o = e.as, s = e.component, a = e.className, c = tt(e, ["validate", "name", "render", "children", "as", "component", "className"]), l = Kt(), u = tt(l, ["validate", "validationSchema"]);
  process.env.NODE_ENV !== "production" && le(function() {
    r && (process.env.NODE_ENV !== "production" ? Q(!1, '<Field render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Field name="' + n + '" render={({field, form}) => ...} /> with <Field name="' + n + '">{({field, form, meta}) => ...}</Field>') : Q()), o && i && oe(i) && (process.env.NODE_ENV !== "production" ? Q(!1, "You should not use <Field as> and <Field children> as a function in the same <Field> component; <Field as> will be ignored.") : Q()), s && i && oe(i) && (process.env.NODE_ENV !== "production" ? Q(!1, "You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.") : Q()), r && i && !Gi(i) && (process.env.NODE_ENV !== "production" ? Q(!1, "You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored") : Q());
  }, []);
  var f = u.registerField, d = u.unregisterField;
  le(function() {
    return f(n, {
      validate: t
    }), function() {
      d(n);
    };
  }, [f, d, n, t]);
  var h = u.getFieldProps(U({
    name: n
  }, c)), g = u.getFieldMeta(n), p = {
    field: h,
    form: u
  };
  if (r)
    return r(U({}, p, {
      meta: g
    }));
  if (oe(i))
    return i(U({}, p, {
      meta: g
    }));
  if (s) {
    if (typeof s == "string") {
      var y = c.innerRef, v = tt(c, ["innerRef"]);
      return Pe(s, U({
        ref: y
      }, h, v, {
        className: a
      }), i);
    }
    return Pe(s, U({
      field: h,
      form: u
    }, c, {
      className: a
    }), i);
  }
  var x = o || "input";
  if (typeof x == "string") {
    var T = c.innerRef, E = tt(c, ["innerRef"]);
    return Pe(x, U({
      ref: T
    }, h, E, {
      className: a
    }), i);
  }
  return Pe(x, U({}, h, c, {
    className: a
  }), i);
}
var ov = /* @__PURE__ */ Ua(function(e, t) {
  var n = e.action, r = tt(e, ["action"]), i = n ?? "#", o = Kt(), s = o.handleReset, a = o.handleSubmit;
  return Pe("form", U({
    onSubmit: a,
    ref: t,
    onReset: s,
    action: i
  }, r));
});
ov.displayName = "Form";
function sv(e) {
  var t = function(i) {
    return Pe(Ky, null, function(o) {
      return o || (process.env.NODE_ENV !== "production" ? Q(!1, "Formik context is undefined, please verify you are rendering <Form>, <Field>, <FastField>, <FieldArray>, or your custom context-using component as a child of a <Formik> component. Component name: " + e.name) : Q()), Pe(e, U({}, i, {
        formik: o
      }));
    });
  }, n = e.displayName || e.name || e.constructor && e.constructor.name || "Component";
  return t.WrappedComponent = e, t.displayName = "FormikConnect(" + n + ")", Gy(
    t,
    e
    // cast type to ComponentClass (even if SFC)
  );
}
var av = function(t, n, r) {
  var i = xt(t), o = i[n];
  return i.splice(n, 1), i.splice(r, 0, o), i;
}, cv = function(t, n, r) {
  var i = xt(t), o = i[n];
  return i[n] = i[r], i[r] = o, i;
}, Fr = function(t, n, r) {
  var i = xt(t);
  return i.splice(n, 0, r), i;
}, lv = function(t, n, r) {
  var i = xt(t);
  return i[n] = r, i;
}, xt = function(t) {
  if (t) {
    if (Array.isArray(t))
      return [].concat(t);
    var n = Object.keys(t).map(function(r) {
      return parseInt(r);
    }).reduce(function(r, i) {
      return i > r ? i : r;
    }, 0);
    return Array.from(U({}, t, {
      length: n + 1
    }));
  } else return [];
}, As = function(t, n) {
  var r = typeof t == "function" ? t : n;
  return function(i) {
    if (Array.isArray(i) || Yt(i)) {
      var o = xt(i);
      return r(o);
    }
    return i;
  };
}, uv = /* @__PURE__ */ function(e) {
  sl(t, e);
  function t(r) {
    var i;
    return i = e.call(this, r) || this, i.updateArrayField = function(o, s, a) {
      var c = i.props, l = c.name, u = c.formik.setFormikState;
      u(function(f) {
        var d = As(a, o), h = As(s, o), g = Ie(f.values, l, o(Y(f.values, l))), p = a ? d(Y(f.errors, l)) : void 0, y = s ? h(Y(f.touched, l)) : void 0;
        return Ss(p) && (p = void 0), Ss(y) && (y = void 0), U({}, f, {
          values: g,
          errors: a ? Ie(f.errors, l, p) : f.errors,
          touched: s ? Ie(f.touched, l, y) : f.touched
        });
      });
    }, i.push = function(o) {
      return i.updateArrayField(function(s) {
        return [].concat(xt(s), [nn(o)]);
      }, !1, !1);
    }, i.handlePush = function(o) {
      return function() {
        return i.push(o);
      };
    }, i.swap = function(o, s) {
      return i.updateArrayField(function(a) {
        return cv(a, o, s);
      }, !0, !0);
    }, i.handleSwap = function(o, s) {
      return function() {
        return i.swap(o, s);
      };
    }, i.move = function(o, s) {
      return i.updateArrayField(function(a) {
        return av(a, o, s);
      }, !0, !0);
    }, i.handleMove = function(o, s) {
      return function() {
        return i.move(o, s);
      };
    }, i.insert = function(o, s) {
      return i.updateArrayField(function(a) {
        return Fr(a, o, s);
      }, function(a) {
        return Fr(a, o, null);
      }, function(a) {
        return Fr(a, o, null);
      });
    }, i.handleInsert = function(o, s) {
      return function() {
        return i.insert(o, s);
      };
    }, i.replace = function(o, s) {
      return i.updateArrayField(function(a) {
        return lv(a, o, s);
      }, !1, !1);
    }, i.handleReplace = function(o, s) {
      return function() {
        return i.replace(o, s);
      };
    }, i.unshift = function(o) {
      var s = -1;
      return i.updateArrayField(function(a) {
        var c = a ? [o].concat(a) : [o];
        return s = c.length, c;
      }, function(a) {
        return a ? [null].concat(a) : [null];
      }, function(a) {
        return a ? [null].concat(a) : [null];
      }), s;
    }, i.handleUnshift = function(o) {
      return function() {
        return i.unshift(o);
      };
    }, i.handleRemove = function(o) {
      return function() {
        return i.remove(o);
      };
    }, i.handlePop = function() {
      return function() {
        return i.pop();
      };
    }, i.remove = i.remove.bind(xs(i)), i.pop = i.pop.bind(xs(i)), i;
  }
  var n = t.prototype;
  return n.componentDidUpdate = function(i) {
    this.props.validateOnChange && this.props.formik.validateOnChange && !et(Y(i.formik.values, i.name), Y(this.props.formik.values, this.props.name)) && this.props.formik.validateForm(this.props.formik.values);
  }, n.remove = function(i) {
    var o;
    return this.updateArrayField(
      // so this gets call 3 times
      function(s) {
        var a = s ? xt(s) : [];
        return o || (o = a[i]), oe(a.splice) && a.splice(i, 1), oe(a.every) && a.every(function(c) {
          return c === void 0;
        }) ? [] : a;
      },
      !0,
      !0
    ), o;
  }, n.pop = function() {
    var i;
    return this.updateArrayField(
      // so this gets call 3 times
      function(o) {
        var s = o.slice();
        return i || (i = s && s.pop && s.pop()), s;
      },
      !0,
      !0
    ), i;
  }, n.render = function() {
    var i = {
      push: this.push,
      pop: this.pop,
      swap: this.swap,
      move: this.move,
      insert: this.insert,
      replace: this.replace,
      unshift: this.unshift,
      remove: this.remove,
      handlePush: this.handlePush,
      handlePop: this.handlePop,
      handleSwap: this.handleSwap,
      handleMove: this.handleMove,
      handleInsert: this.handleInsert,
      handleReplace: this.handleReplace,
      handleUnshift: this.handleUnshift,
      handleRemove: this.handleRemove
    }, o = this.props, s = o.component, a = o.render, c = o.children, l = o.name, u = o.formik, f = tt(u, ["validate", "validationSchema"]), d = U({}, i, {
      form: f,
      name: l
    });
    return s ? Pe(s, d) : a ? a(d) : c ? typeof c == "function" ? c(d) : Gi(c) ? null : Pi.only(c) : null;
  }, t;
}(Ci);
uv.defaultProps = {
  validateOnChange: !0
};
var dv = /* @__PURE__ */ function(e) {
  sl(t, e);
  function t() {
    return e.apply(this, arguments) || this;
  }
  var n = t.prototype;
  return n.shouldComponentUpdate = function(i) {
    return Y(this.props.formik.errors, this.props.name) !== Y(i.formik.errors, this.props.name) || Y(this.props.formik.touched, this.props.name) !== Y(i.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(i).length;
  }, n.render = function() {
    var i = this.props, o = i.component, s = i.formik, a = i.render, c = i.children, l = i.name, u = tt(i, ["component", "formik", "render", "children", "name"]), f = Y(s.touched, l), d = Y(s.errors, l);
    return f && d ? a ? oe(a) ? a(d) : null : c ? oe(c) ? c(d) : null : o ? Pe(o, u, d) : d : null;
  }, t;
}(Ci), ll = /* @__PURE__ */ sv(dv);
const ul = Bn.createContext({}), Hi = () => ue(ul), fv = "w-full", dl = "flex mx-4 mt-2 text-xs text-feedback-danger-200";
function hv({ disableOnSubmit: e, disableOnNotDirty: t, isDisabled: n, ...r }) {
  const { isSubmitting: i, dirty: o } = Kt(), { isForcedDirty: s, onNavigationEvent: a } = Hi(), c = (u) => {
    a(() => r.onClick);
  }, l = Ge(() => !!(n || e && i || t && !o || t && typeof s == "boolean" && !s), [e, t, n, i, s, o]);
  return /* @__PURE__ */ M(
    ec,
    {
      ...r,
      isDisabled: l,
      onClick: r.type !== "submit" && (o || typeof s < "u" && s) ? c : r.onClick
    }
  );
}
const fl = st({});
function pv(e) {
  const t = ve(null);
  return t.current === null && (t.current = e()), t.current;
}
const Ki = typeof window < "u", mv = Ki ? Ba : le, Yi = /* @__PURE__ */ st(null);
function Zi(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function Xi(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
const He = (e, t, n) => n > t ? t : n < e ? e : n;
function oi(e, t) {
  return t ? `${e}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${t}` : e;
}
let Zt = () => {
}, Ke = () => {
};
process.env.NODE_ENV !== "production" && (Zt = (e, t, n) => {
  !e && typeof console < "u" && console.warn(oi(t, n));
}, Ke = (e, t, n) => {
  if (!e)
    throw new Error(oi(t, n));
});
const Ye = {}, hl = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e);
function pl(e) {
  return typeof e == "object" && e !== null;
}
const ml = (e) => /^0[^.\s]+$/u.test(e);
// @__NO_SIDE_EFFECTS__
function qi(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const Ce = /* @__NO_SIDE_EFFECTS__ */ (e) => e, gv = (e, t) => (n) => t(e(n)), En = (...e) => e.reduce(gv), mn = /* @__NO_SIDE_EFFECTS__ */ (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
};
class Ji {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return Zi(this.subscriptions, t), () => Xi(this.subscriptions, t);
  }
  notify(t, n, r) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let o = 0; o < i; o++) {
          const s = this.subscriptions[o];
          s && s(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const Oe = /* @__NO_SIDE_EFFECTS__ */ (e) => e * 1e3, Ne = /* @__NO_SIDE_EFFECTS__ */ (e) => e / 1e3;
function gl(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const Ps = /* @__PURE__ */ new Set();
function Qi(e, t, n) {
  e || Ps.has(t) || (console.warn(oi(t, n)), Ps.add(t));
}
const yl = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, yv = 1e-7, vv = 12;
function bv(e, t, n, r, i) {
  let o, s, a = 0;
  do
    s = t + (n - t) / 2, o = yl(s, r, i) - e, o > 0 ? n = s : t = s;
  while (Math.abs(o) > yv && ++a < vv);
  return s;
}
function An(e, t, n, r) {
  if (e === t && n === r)
    return Ce;
  const i = (o) => bv(o, 0, 1, e, n);
  return (o) => o === 0 || o === 1 ? o : yl(i(o), t, r);
}
const vl = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, bl = (e) => (t) => 1 - e(1 - t), wl = /* @__PURE__ */ An(0.33, 1.53, 0.69, 0.99), eo = /* @__PURE__ */ bl(wl), Tl = /* @__PURE__ */ vl(eo), xl = (e) => (e *= 2) < 1 ? 0.5 * eo(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), to = (e) => 1 - Math.sin(Math.acos(e)), Sl = bl(to), El = vl(to), wv = /* @__PURE__ */ An(0.42, 0, 1, 1), Tv = /* @__PURE__ */ An(0, 0, 0.58, 1), Al = /* @__PURE__ */ An(0.42, 0, 0.58, 1), xv = (e) => Array.isArray(e) && typeof e[0] != "number", Pl = (e) => Array.isArray(e) && typeof e[0] == "number", Cs = {
  linear: Ce,
  easeIn: wv,
  easeInOut: Al,
  easeOut: Tv,
  circIn: to,
  circInOut: El,
  circOut: Sl,
  backIn: eo,
  backInOut: Tl,
  backOut: wl,
  anticipate: xl
}, Sv = (e) => typeof e == "string", Ms = (e) => {
  if (Pl(e)) {
    Ke(e.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
    const [t, n, r, i] = e;
    return An(t, n, r, i);
  } else if (Sv(e))
    return Ke(Cs[e] !== void 0, `Invalid easing type '${e}'`, "invalid-easing-type"), Cs[e];
  return e;
}, Ln = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function Ev(e, t) {
  let n = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), i = !1, o = !1;
  const s = /* @__PURE__ */ new WeakSet();
  let a = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function c(u) {
    s.has(u) && (l.schedule(u), e()), u(a);
  }
  const l = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (u, f = !1, d = !1) => {
      const g = d && i ? n : r;
      return f && s.add(u), g.has(u) || g.add(u), u;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (u) => {
      r.delete(u), s.delete(u);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (u) => {
      if (a = u, i) {
        o = !0;
        return;
      }
      i = !0, [n, r] = [r, n], n.forEach(c), n.clear(), i = !1, o && (o = !1, l.process(u));
    }
  };
  return l;
}
const Av = 40;
function Cl(e, t) {
  let n = !1, r = !0;
  const i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, o = () => n = !0, s = Ln.reduce((T, E) => (T[E] = Ev(o), T), {}), { setup: a, read: c, resolveKeyframes: l, preUpdate: u, update: f, preRender: d, render: h, postRender: g } = s, p = () => {
    const T = Ye.useManualTiming ? i.timestamp : performance.now();
    n = !1, Ye.useManualTiming || (i.delta = r ? 1e3 / 60 : Math.max(Math.min(T - i.timestamp, Av), 1)), i.timestamp = T, i.isProcessing = !0, a.process(i), c.process(i), l.process(i), u.process(i), f.process(i), d.process(i), h.process(i), g.process(i), i.isProcessing = !1, n && t && (r = !1, e(p));
  }, y = () => {
    n = !0, r = !0, i.isProcessing || e(p);
  };
  return { schedule: Ln.reduce((T, E) => {
    const b = s[E];
    return T[E] = (A, P = !1, S = !1) => (n || y(), b.schedule(A, P, S)), T;
  }, {}), cancel: (T) => {
    for (let E = 0; E < Ln.length; E++)
      s[Ln[E]].cancel(T);
  }, state: i, steps: s };
}
const { schedule: Z, cancel: it, state: ce, steps: kr } = /* @__PURE__ */ Cl(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Ce, !0);
let Wn;
function Pv() {
  Wn = void 0;
}
const ge = {
  now: () => (Wn === void 0 && ge.set(ce.isProcessing || Ye.useManualTiming ? ce.timestamp : performance.now()), Wn),
  set: (e) => {
    Wn = e, queueMicrotask(Pv);
  }
}, Ml = (e) => (t) => typeof t == "string" && t.startsWith(e), no = /* @__PURE__ */ Ml("--"), Cv = /* @__PURE__ */ Ml("var(--"), ro = (e) => Cv(e) ? Mv.test(e.split("/*")[0].trim()) : !1, Mv = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, Xt = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, gn = {
  ...Xt,
  transform: (e) => He(0, 1, e)
}, jn = {
  ...Xt,
  default: 1
}, cn = (e) => Math.round(e * 1e5) / 1e5, io = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function Rv(e) {
  return e == null;
}
const Dv = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, oo = (e, t) => (n) => !!(typeof n == "string" && Dv.test(n) && n.startsWith(e) || t && !Rv(n) && Object.prototype.hasOwnProperty.call(n, t)), Rl = (e, t, n) => (r) => {
  if (typeof r != "string")
    return r;
  const [i, o, s, a] = r.match(io);
  return {
    [e]: parseFloat(i),
    [t]: parseFloat(o),
    [n]: parseFloat(s),
    alpha: a !== void 0 ? parseFloat(a) : 1
  };
}, Ov = (e) => He(0, 255, e), Ir = {
  ...Xt,
  transform: (e) => Math.round(Ov(e))
}, mt = {
  test: /* @__PURE__ */ oo("rgb", "red"),
  parse: /* @__PURE__ */ Rl("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + Ir.transform(e) + ", " + Ir.transform(t) + ", " + Ir.transform(n) + ", " + cn(gn.transform(r)) + ")"
};
function Vv(e) {
  let t = "", n = "", r = "", i = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), i = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), i = e.substring(4, 5), t += t, n += n, r += r, i += i), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const si = {
  test: /* @__PURE__ */ oo("#"),
  parse: Vv,
  transform: mt.transform
}, Pn = /* @__NO_SIDE_EFFECTS__ */ (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), Qe = /* @__PURE__ */ Pn("deg"), _e = /* @__PURE__ */ Pn("%"), N = /* @__PURE__ */ Pn("px"), Fv = /* @__PURE__ */ Pn("vh"), kv = /* @__PURE__ */ Pn("vw"), Rs = {
  ..._e,
  parse: (e) => _e.parse(e) / 100,
  transform: (e) => _e.transform(e * 100)
}, kt = {
  test: /* @__PURE__ */ oo("hsl", "hue"),
  parse: /* @__PURE__ */ Rl("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + _e.transform(cn(t)) + ", " + _e.transform(cn(n)) + ", " + cn(gn.transform(r)) + ")"
}, ne = {
  test: (e) => mt.test(e) || si.test(e) || kt.test(e),
  parse: (e) => mt.test(e) ? mt.parse(e) : kt.test(e) ? kt.parse(e) : si.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? mt.transform(e) : kt.transform(e),
  getAnimatableNone: (e) => {
    const t = ne.parse(e);
    return t.alpha = 0, ne.transform(t);
  }
}, Iv = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function Nv(e) {
  var t, n;
  return isNaN(e) && typeof e == "string" && (((t = e.match(io)) == null ? void 0 : t.length) || 0) + (((n = e.match(Iv)) == null ? void 0 : n.length) || 0) > 0;
}
const Dl = "number", Ol = "color", _v = "var", Lv = "var(", Ds = "${}", jv = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function yn(e) {
  const t = e.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, i = [];
  let o = 0;
  const a = t.replace(jv, (c) => (ne.test(c) ? (r.color.push(o), i.push(Ol), n.push(ne.parse(c))) : c.startsWith(Lv) ? (r.var.push(o), i.push(_v), n.push(c)) : (r.number.push(o), i.push(Dl), n.push(parseFloat(c))), ++o, Ds)).split(Ds);
  return { values: n, split: a, indexes: r, types: i };
}
function Vl(e) {
  return yn(e).values;
}
function Fl(e) {
  const { split: t, types: n } = yn(e), r = t.length;
  return (i) => {
    let o = "";
    for (let s = 0; s < r; s++)
      if (o += t[s], i[s] !== void 0) {
        const a = n[s];
        a === Dl ? o += cn(i[s]) : a === Ol ? o += ne.transform(i[s]) : o += i[s];
      }
    return o;
  };
}
const $v = (e) => typeof e == "number" ? 0 : ne.test(e) ? ne.getAnimatableNone(e) : e;
function Bv(e) {
  const t = Vl(e);
  return Fl(e)(t.map($v));
}
const ot = {
  test: Nv,
  parse: Vl,
  createTransformer: Fl,
  getAnimatableNone: Bv
};
function Nr(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function Uv({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let i = 0, o = 0, s = 0;
  if (!t)
    i = o = s = n;
  else {
    const a = n < 0.5 ? n * (1 + t) : n + t - n * t, c = 2 * n - a;
    i = Nr(c, a, e + 1 / 3), o = Nr(c, a, e), s = Nr(c, a, e - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(o * 255),
    blue: Math.round(s * 255),
    alpha: r
  };
}
function Jn(e, t) {
  return (n) => n > 0 ? t : e;
}
const q = (e, t, n) => e + (t - e) * n, _r = (e, t, n) => {
  const r = e * e, i = n * (t * t - r) + r;
  return i < 0 ? 0 : Math.sqrt(i);
}, zv = [si, mt, kt], Wv = (e) => zv.find((t) => t.test(e));
function Os(e) {
  const t = Wv(e);
  if (Zt(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !t)
    return !1;
  let n = t.parse(e);
  return t === kt && (n = Uv(n)), n;
}
const Vs = (e, t) => {
  const n = Os(e), r = Os(t);
  if (!n || !r)
    return Jn(e, t);
  const i = { ...n };
  return (o) => (i.red = _r(n.red, r.red, o), i.green = _r(n.green, r.green, o), i.blue = _r(n.blue, r.blue, o), i.alpha = q(n.alpha, r.alpha, o), mt.transform(i));
}, ai = /* @__PURE__ */ new Set(["none", "hidden"]);
function Gv(e, t) {
  return ai.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
function Hv(e, t) {
  return (n) => q(e, t, n);
}
function so(e) {
  return typeof e == "number" ? Hv : typeof e == "string" ? ro(e) ? Jn : ne.test(e) ? Vs : Zv : Array.isArray(e) ? kl : typeof e == "object" ? ne.test(e) ? Vs : Kv : Jn;
}
function kl(e, t) {
  const n = [...e], r = n.length, i = e.map((o, s) => so(o)(o, t[s]));
  return (o) => {
    for (let s = 0; s < r; s++)
      n[s] = i[s](o);
    return n;
  };
}
function Kv(e, t) {
  const n = { ...e, ...t }, r = {};
  for (const i in n)
    e[i] !== void 0 && t[i] !== void 0 && (r[i] = so(e[i])(e[i], t[i]));
  return (i) => {
    for (const o in r)
      n[o] = r[o](i);
    return n;
  };
}
function Yv(e, t) {
  const n = [], r = { color: 0, var: 0, number: 0 };
  for (let i = 0; i < t.values.length; i++) {
    const o = t.types[i], s = e.indexes[o][r[o]], a = e.values[s] ?? 0;
    n[i] = a, r[o]++;
  }
  return n;
}
const Zv = (e, t) => {
  const n = ot.createTransformer(t), r = yn(e), i = yn(t);
  return r.indexes.var.length === i.indexes.var.length && r.indexes.color.length === i.indexes.color.length && r.indexes.number.length >= i.indexes.number.length ? ai.has(e) && !i.values.length || ai.has(t) && !r.values.length ? Gv(e, t) : En(kl(Yv(r, i), i.values), n) : (Zt(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), Jn(e, t));
};
function Il(e, t, n) {
  return typeof e == "number" && typeof t == "number" && typeof n == "number" ? q(e, t, n) : so(e)(e, t);
}
const Xv = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: (n = !0) => Z.update(t, n),
    stop: () => it(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => ce.isProcessing ? ce.timestamp : ge.now()
  };
}, Nl = (e, t, n = 10) => {
  let r = "";
  const i = Math.max(Math.round(t / n), 2);
  for (let o = 0; o < i; o++)
    r += Math.round(e(o / (i - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${r.substring(0, r.length - 2)})`;
}, Qn = 2e4;
function ao(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < Qn; )
    t += n, r = e.next(t);
  return t >= Qn ? 1 / 0 : t;
}
function qv(e, t = 100, n) {
  const r = n({ ...e, keyframes: [0, t] }), i = Math.min(ao(r), Qn);
  return {
    type: "keyframes",
    ease: (o) => r.next(i * o).value / t,
    duration: /* @__PURE__ */ Ne(i)
  };
}
const Jv = 5;
function _l(e, t, n) {
  const r = Math.max(t - Jv, 0);
  return gl(n - e(r), t - r);
}
const X = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, Fs = 1e-3;
function Qv({ duration: e = X.duration, bounce: t = X.bounce, velocity: n = X.velocity, mass: r = X.mass }) {
  let i, o;
  Zt(e <= /* @__PURE__ */ Oe(X.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let s = 1 - t;
  s = He(X.minDamping, X.maxDamping, s), e = He(X.minDuration, X.maxDuration, /* @__PURE__ */ Ne(e)), s < 1 ? (i = (l) => {
    const u = l * s, f = u * e, d = u - n, h = ci(l, s), g = Math.exp(-f);
    return Fs - d / h * g;
  }, o = (l) => {
    const f = l * s * e, d = f * n + n, h = Math.pow(s, 2) * Math.pow(l, 2) * e, g = Math.exp(-f), p = ci(Math.pow(l, 2), s);
    return (-i(l) + Fs > 0 ? -1 : 1) * ((d - h) * g) / p;
  }) : (i = (l) => {
    const u = Math.exp(-l * e), f = (l - n) * e + 1;
    return -1e-3 + u * f;
  }, o = (l) => {
    const u = Math.exp(-l * e), f = (n - l) * (e * e);
    return u * f;
  });
  const a = 5 / e, c = t0(i, o, a);
  if (e = /* @__PURE__ */ Oe(e), isNaN(c))
    return {
      stiffness: X.stiffness,
      damping: X.damping,
      duration: e
    };
  {
    const l = Math.pow(c, 2) * r;
    return {
      stiffness: l,
      damping: s * 2 * Math.sqrt(r * l),
      duration: e
    };
  }
}
const e0 = 12;
function t0(e, t, n) {
  let r = n;
  for (let i = 1; i < e0; i++)
    r = r - e(r) / t(r);
  return r;
}
function ci(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const n0 = ["duration", "bounce"], r0 = ["stiffness", "damping", "mass"];
function ks(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function i0(e) {
  let t = {
    velocity: X.velocity,
    stiffness: X.stiffness,
    damping: X.damping,
    mass: X.mass,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!ks(e, r0) && ks(e, n0))
    if (e.visualDuration) {
      const n = e.visualDuration, r = 2 * Math.PI / (n * 1.2), i = r * r, o = 2 * He(0.05, 1, 1 - (e.bounce || 0)) * Math.sqrt(i);
      t = {
        ...t,
        mass: X.mass,
        stiffness: i,
        damping: o
      };
    } else {
      const n = Qv(e);
      t = {
        ...t,
        ...n,
        mass: X.mass
      }, t.isResolvedFromDuration = !0;
    }
  return t;
}
function er(e = X.visualDuration, t = X.bounce) {
  const n = typeof e != "object" ? {
    visualDuration: e,
    keyframes: [0, 1],
    bounce: t
  } : e;
  let { restSpeed: r, restDelta: i } = n;
  const o = n.keyframes[0], s = n.keyframes[n.keyframes.length - 1], a = { done: !1, value: o }, { stiffness: c, damping: l, mass: u, duration: f, velocity: d, isResolvedFromDuration: h } = i0({
    ...n,
    velocity: -/* @__PURE__ */ Ne(n.velocity || 0)
  }), g = d || 0, p = l / (2 * Math.sqrt(c * u)), y = s - o, v = /* @__PURE__ */ Ne(Math.sqrt(c / u)), x = Math.abs(y) < 5;
  r || (r = x ? X.restSpeed.granular : X.restSpeed.default), i || (i = x ? X.restDelta.granular : X.restDelta.default);
  let T;
  if (p < 1) {
    const b = ci(v, p);
    T = (A) => {
      const P = Math.exp(-p * v * A);
      return s - P * ((g + p * v * y) / b * Math.sin(b * A) + y * Math.cos(b * A));
    };
  } else if (p === 1)
    T = (b) => s - Math.exp(-v * b) * (y + (g + v * y) * b);
  else {
    const b = v * Math.sqrt(p * p - 1);
    T = (A) => {
      const P = Math.exp(-p * v * A), S = Math.min(b * A, 300);
      return s - P * ((g + p * v * y) * Math.sinh(S) + b * y * Math.cosh(S)) / b;
    };
  }
  const E = {
    calculatedDuration: h && f || null,
    next: (b) => {
      const A = T(b);
      if (h)
        a.done = b >= f;
      else {
        let P = b === 0 ? g : 0;
        p < 1 && (P = b === 0 ? /* @__PURE__ */ Oe(g) : _l(T, b, A));
        const S = Math.abs(P) <= r, I = Math.abs(s - A) <= i;
        a.done = S && I;
      }
      return a.value = a.done ? s : A, a;
    },
    toString: () => {
      const b = Math.min(ao(E), Qn), A = Nl((P) => E.next(b * P).value, b, 30);
      return b + "ms " + A;
    },
    toTransition: () => {
    }
  };
  return E;
}
er.applyToOptions = (e) => {
  const t = qv(e, 100, er);
  return e.ease = t.ease, e.duration = /* @__PURE__ */ Oe(t.duration), e.type = "keyframes", e;
};
function li({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: i = 10, bounceStiffness: o = 500, modifyTarget: s, min: a, max: c, restDelta: l = 0.5, restSpeed: u }) {
  const f = e[0], d = {
    done: !1,
    value: f
  }, h = (S) => a !== void 0 && S < a || c !== void 0 && S > c, g = (S) => a === void 0 ? c : c === void 0 || Math.abs(a - S) < Math.abs(c - S) ? a : c;
  let p = n * t;
  const y = f + p, v = s === void 0 ? y : s(y);
  v !== y && (p = v - f);
  const x = (S) => -p * Math.exp(-S / r), T = (S) => v + x(S), E = (S) => {
    const I = x(S), G = T(S);
    d.done = Math.abs(I) <= l, d.value = d.done ? v : G;
  };
  let b, A;
  const P = (S) => {
    h(d.value) && (b = S, A = er({
      keyframes: [d.value, g(d.value)],
      velocity: _l(T, S, d.value),
      // TODO: This should be passing * 1000
      damping: i,
      stiffness: o,
      restDelta: l,
      restSpeed: u
    }));
  };
  return P(0), {
    calculatedDuration: null,
    next: (S) => {
      let I = !1;
      return !A && b === void 0 && (I = !0, E(S), P(S)), b !== void 0 && S >= b ? A.next(S - b) : (!I && E(S), d);
    }
  };
}
function o0(e, t, n) {
  const r = [], i = n || Ye.mix || Il, o = e.length - 1;
  for (let s = 0; s < o; s++) {
    let a = i(e[s], e[s + 1]);
    if (t) {
      const c = Array.isArray(t) ? t[s] || Ce : t;
      a = En(c, a);
    }
    r.push(a);
  }
  return r;
}
function s0(e, t, { clamp: n = !0, ease: r, mixer: i } = {}) {
  const o = e.length;
  if (Ke(o === t.length, "Both input and output ranges must be the same length", "range-length"), o === 1)
    return () => t[0];
  if (o === 2 && t[0] === t[1])
    return () => t[1];
  const s = e[0] === e[1];
  e[0] > e[o - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const a = o0(t, r, i), c = a.length, l = (u) => {
    if (s && u < e[0])
      return t[0];
    let f = 0;
    if (c > 1)
      for (; f < e.length - 2 && !(u < e[f + 1]); f++)
        ;
    const d = /* @__PURE__ */ mn(e[f], e[f + 1], u);
    return a[f](d);
  };
  return n ? (u) => l(He(e[0], e[o - 1], u)) : l;
}
function a0(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const i = /* @__PURE__ */ mn(0, t, r);
    e.push(q(n, 1, i));
  }
}
function c0(e) {
  const t = [0];
  return a0(t, e.length - 1), t;
}
function l0(e, t) {
  return e.map((n) => n * t);
}
function u0(e, t) {
  return e.map(() => t || Al).splice(0, e.length - 1);
}
function It({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const i = xv(r) ? r.map(Ms) : Ms(r), o = {
    done: !1,
    value: t[0]
  }, s = l0(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : c0(t),
    e
  ), a = s0(s, t, {
    ease: Array.isArray(i) ? i : u0(t, i)
  });
  return {
    calculatedDuration: e,
    next: (c) => (o.value = a(c), o.done = c >= e, o)
  };
}
const d0 = (e) => e !== null;
function co(e, { repeat: t, repeatType: n = "loop" }, r, i = 1) {
  const o = e.filter(d0), a = i < 0 || t && n !== "loop" && t % 2 === 1 ? 0 : o.length - 1;
  return !a || r === void 0 ? o[a] : r;
}
const f0 = {
  decay: li,
  inertia: li,
  tween: It,
  keyframes: It,
  spring: er
};
function Ll(e) {
  typeof e.type == "string" && (e.type = f0[e.type]);
}
class lo {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((t) => {
      this.resolve = t;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
}
const h0 = (e) => e / 100;
class uo extends lo {
  constructor(t) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.stop = () => {
      var r, i;
      const { motionValue: n } = this.options;
      n && n.updatedAt !== ge.now() && this.tick(ge.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), (i = (r = this.options).onStop) == null || i.call(r));
    }, this.options = t, this.initAnimation(), this.play(), t.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: t } = this;
    Ll(t);
    const { type: n = It, repeat: r = 0, repeatDelay: i = 0, repeatType: o, velocity: s = 0 } = t;
    let { keyframes: a } = t;
    const c = n || It;
    process.env.NODE_ENV !== "production" && c !== It && Ke(a.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${a}`, "spring-two-frames"), c !== It && typeof a[0] != "number" && (this.mixKeyframes = En(h0, Il(a[0], a[1])), a = [0, 100]);
    const l = c({ ...t, keyframes: a });
    o === "mirror" && (this.mirroredGenerator = c({
      ...t,
      keyframes: [...a].reverse(),
      velocity: -s
    })), l.calculatedDuration === null && (l.calculatedDuration = ao(l));
    const { calculatedDuration: u } = l;
    this.calculatedDuration = u, this.resolvedDuration = u + i, this.totalDuration = this.resolvedDuration * (r + 1) - i, this.generator = l;
  }
  updateTime(t) {
    const n = Math.round(t - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = n;
  }
  tick(t, n = !1) {
    const { generator: r, totalDuration: i, mixKeyframes: o, mirroredGenerator: s, resolvedDuration: a, calculatedDuration: c } = this;
    if (this.startTime === null)
      return r.next(0);
    const { delay: l = 0, keyframes: u, repeat: f, repeatType: d, repeatDelay: h, type: g, onUpdate: p, finalKeyframe: y } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - i / this.speed, this.startTime)), n ? this.currentTime = t : this.updateTime(t);
    const v = this.currentTime - l * (this.playbackSpeed >= 0 ? 1 : -1), x = this.playbackSpeed >= 0 ? v < 0 : v > i;
    this.currentTime = Math.max(v, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = i);
    let T = this.currentTime, E = r;
    if (f) {
      const S = Math.min(this.currentTime, i) / a;
      let I = Math.floor(S), G = S % 1;
      !G && S >= 1 && (G = 1), G === 1 && I--, I = Math.min(I, f + 1), !!(I % 2) && (d === "reverse" ? (G = 1 - G, h && (G -= h / a)) : d === "mirror" && (E = s)), T = He(0, 1, G) * a;
    }
    const b = x ? { done: !1, value: u[0] } : E.next(T);
    o && (b.value = o(b.value));
    let { done: A } = b;
    !x && c !== null && (A = this.playbackSpeed >= 0 ? this.currentTime >= i : this.currentTime <= 0);
    const P = this.holdTime === null && (this.state === "finished" || this.state === "running" && A);
    return P && g !== li && (b.value = co(u, this.options, y, this.speed)), p && p(b.value), P && this.finish(), b;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
  get duration() {
    return /* @__PURE__ */ Ne(this.calculatedDuration);
  }
  get time() {
    return /* @__PURE__ */ Ne(this.currentTime);
  }
  set time(t) {
    var n;
    t = /* @__PURE__ */ Oe(t), this.currentTime = t, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.playbackSpeed), (n = this.driver) == null || n.start(!1);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    this.updateTime(ge.now());
    const n = this.playbackSpeed !== t;
    this.playbackSpeed = t, n && (this.time = /* @__PURE__ */ Ne(this.currentTime));
  }
  play() {
    var i, o;
    if (this.isStopped)
      return;
    const { driver: t = Xv, startTime: n } = this.options;
    this.driver || (this.driver = t((s) => this.tick(s))), (o = (i = this.options).onPlay) == null || o.call(i);
    const r = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = r) : this.holdTime !== null ? this.startTime = r - this.holdTime : this.startTime || (this.startTime = n ?? r), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(ge.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    var t, n;
    this.notifyFinished(), this.teardown(), this.state = "finished", (n = (t = this.options).onComplete) == null || n.call(t);
  }
  cancel() {
    var t, n;
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), (n = (t = this.options).onCancel) == null || n.call(t);
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
  attachTimeline(t) {
    var n;
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), (n = this.driver) == null || n.stop(), t.observe(this);
  }
}
function p0(e) {
  for (let t = 1; t < e.length; t++)
    e[t] ?? (e[t] = e[t - 1]);
}
const gt = (e) => e * 180 / Math.PI, ui = (e) => {
  const t = gt(Math.atan2(e[1], e[0]));
  return di(t);
}, m0 = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (e) => (Math.abs(e[0]) + Math.abs(e[3])) / 2,
  rotate: ui,
  rotateZ: ui,
  skewX: (e) => gt(Math.atan(e[1])),
  skewY: (e) => gt(Math.atan(e[2])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[2])) / 2
}, di = (e) => (e = e % 360, e < 0 && (e += 360), e), Is = ui, Ns = (e) => Math.sqrt(e[0] * e[0] + e[1] * e[1]), _s = (e) => Math.sqrt(e[4] * e[4] + e[5] * e[5]), g0 = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: Ns,
  scaleY: _s,
  scale: (e) => (Ns(e) + _s(e)) / 2,
  rotateX: (e) => di(gt(Math.atan2(e[6], e[5]))),
  rotateY: (e) => di(gt(Math.atan2(-e[2], e[0]))),
  rotateZ: Is,
  rotate: Is,
  skewX: (e) => gt(Math.atan(e[4])),
  skewY: (e) => gt(Math.atan(e[1])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[4])) / 2
};
function fi(e) {
  return e.includes("scale") ? 1 : 0;
}
function hi(e, t) {
  if (!e || e === "none")
    return fi(t);
  const n = e.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let r, i;
  if (n)
    r = g0, i = n;
  else {
    const a = e.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    r = m0, i = a;
  }
  if (!i)
    return fi(t);
  const o = r[t], s = i[1].split(",").map(v0);
  return typeof o == "function" ? o(s) : s[o];
}
const y0 = (e, t) => {
  const { transform: n = "none" } = getComputedStyle(e);
  return hi(n, t);
};
function v0(e) {
  return parseFloat(e.trim());
}
const qt = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], Jt = new Set(qt), Ls = (e) => e === Xt || e === N, b0 = /* @__PURE__ */ new Set(["x", "y", "z"]), w0 = qt.filter((e) => !b0.has(e));
function T0(e) {
  const t = [];
  return w0.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t;
}
const yt = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: (e, { transform: t }) => hi(t, "x"),
  y: (e, { transform: t }) => hi(t, "y")
};
yt.translateX = yt.x;
yt.translateY = yt.y;
const vt = /* @__PURE__ */ new Set();
let pi = !1, mi = !1, gi = !1;
function jl() {
  if (mi) {
    const e = Array.from(vt).filter((r) => r.needsMeasurement), t = new Set(e.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    t.forEach((r) => {
      const i = T0(r);
      i.length && (n.set(r, i), r.render());
    }), e.forEach((r) => r.measureInitialState()), t.forEach((r) => {
      r.render();
      const i = n.get(r);
      i && i.forEach(([o, s]) => {
        var a;
        (a = r.getValue(o)) == null || a.set(s);
      });
    }), e.forEach((r) => r.measureEndState()), e.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  mi = !1, pi = !1, vt.forEach((e) => e.complete(gi)), vt.clear();
}
function $l() {
  vt.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (mi = !0);
  });
}
function x0() {
  gi = !0, $l(), jl(), gi = !1;
}
class fo {
  constructor(t, n, r, i, o, s = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...t], this.onComplete = n, this.name = r, this.motionValue = i, this.element = o, this.isAsync = s;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (vt.add(this), pi || (pi = !0, Z.read($l), Z.resolveKeyframes(jl))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: n, element: r, motionValue: i } = this;
    if (t[0] === null) {
      const o = i == null ? void 0 : i.get(), s = t[t.length - 1];
      if (o !== void 0)
        t[0] = o;
      else if (r && n) {
        const a = r.readValue(n, s);
        a != null && (t[0] = a);
      }
      t[0] === void 0 && (t[0] = s), i && o === void 0 && i.set(t[0]);
    }
    p0(t);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(t = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, t), vt.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (vt.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const S0 = (e) => e.startsWith("--");
function E0(e, t, n) {
  S0(t) ? e.style.setProperty(t, n) : e.style[t] = n;
}
const A0 = /* @__PURE__ */ qi(() => window.ScrollTimeline !== void 0), P0 = {};
function C0(e, t) {
  const n = /* @__PURE__ */ qi(e);
  return () => P0[t] ?? n();
}
const Bl = /* @__PURE__ */ C0(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), rn = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, js = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ rn([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ rn([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ rn([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ rn([0.33, 1.53, 0.69, 0.99])
};
function Ul(e, t) {
  if (e)
    return typeof e == "function" ? Bl() ? Nl(e, t) : "ease-out" : Pl(e) ? rn(e) : Array.isArray(e) ? e.map((n) => Ul(n, t) || js.easeOut) : js[e];
}
function M0(e, t, n, { delay: r = 0, duration: i = 300, repeat: o = 0, repeatType: s = "loop", ease: a = "easeOut", times: c } = {}, l = void 0) {
  const u = {
    [t]: n
  };
  c && (u.offset = c);
  const f = Ul(a, i);
  Array.isArray(f) && (u.easing = f);
  const d = {
    delay: r,
    duration: i,
    easing: Array.isArray(f) ? "linear" : f,
    fill: "both",
    iterations: o + 1,
    direction: s === "reverse" ? "alternate" : "normal"
  };
  return l && (d.pseudoElement = l), e.animate(u, d);
}
function zl(e) {
  return typeof e == "function" && "applyToOptions" in e;
}
function R0({ type: e, ...t }) {
  return zl(e) && Bl() ? e.applyToOptions(t) : (t.duration ?? (t.duration = 300), t.ease ?? (t.ease = "easeOut"), t);
}
class D0 extends lo {
  constructor(t) {
    if (super(), this.finishedTime = null, this.isStopped = !1, !t)
      return;
    const { element: n, name: r, keyframes: i, pseudoElement: o, allowFlatten: s = !1, finalKeyframe: a, onComplete: c } = t;
    this.isPseudoElement = !!o, this.allowFlatten = s, this.options = t, Ke(typeof t.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const l = R0(t);
    this.animation = M0(n, r, i, l, o), l.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !o) {
        const u = co(i, this.options, a, this.speed);
        this.updateMotionValue ? this.updateMotionValue(u) : E0(n, r, u), this.animation.cancel();
      }
      c == null || c(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    var t, n;
    (n = (t = this.animation).finish) == null || n.call(t);
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: t } = this;
    t === "idle" || t === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    var t, n;
    this.isPseudoElement || (n = (t = this.animation).commitStyles) == null || n.call(t);
  }
  get duration() {
    var n, r;
    const t = ((r = (n = this.animation.effect) == null ? void 0 : n.getComputedTiming) == null ? void 0 : r.call(n).duration) || 0;
    return /* @__PURE__ */ Ne(Number(t));
  }
  get time() {
    return /* @__PURE__ */ Ne(Number(this.animation.currentTime) || 0);
  }
  set time(t) {
    this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ Oe(t);
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(t) {
    t < 0 && (this.finishedTime = null), this.animation.playbackRate = t;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return Number(this.animation.startTime);
  }
  set startTime(t) {
    this.animation.startTime = t;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: t, observe: n }) {
    var r;
    return this.allowFlatten && ((r = this.animation.effect) == null || r.updateTiming({ easing: "linear" })), this.animation.onfinish = null, t && A0() ? (this.animation.timeline = t, Ce) : n(this);
  }
}
const Wl = {
  anticipate: xl,
  backInOut: Tl,
  circInOut: El
};
function O0(e) {
  return e in Wl;
}
function V0(e) {
  typeof e.ease == "string" && O0(e.ease) && (e.ease = Wl[e.ease]);
}
const $s = 10;
class F0 extends D0 {
  constructor(t) {
    V0(t), Ll(t), super(t), t.startTime && (this.startTime = t.startTime), this.options = t;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read commited styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(t) {
    const { motionValue: n, onUpdate: r, onComplete: i, element: o, ...s } = this.options;
    if (!n)
      return;
    if (t !== void 0) {
      n.set(t);
      return;
    }
    const a = new uo({
      ...s,
      autoplay: !1
    }), c = /* @__PURE__ */ Oe(this.finishedTime ?? this.time);
    n.setWithVelocity(a.sample(c - $s).value, a.sample(c).value, $s), a.stop();
  }
}
const Bs = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(ot.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function k0(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t)
      return !0;
}
function I0(e, t, n, r) {
  const i = e[0];
  if (i === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const o = e[e.length - 1], s = Bs(i, t), a = Bs(o, t);
  return Zt(s === a, `You are trying to animate ${t} from "${i}" to "${o}". "${s ? o : i}" is not an animatable value.`, "value-not-animatable"), !s || !a ? !1 : k0(e) || (n === "spring" || zl(n)) && r;
}
const N0 = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Could be re-enabled now we have support for linear() easing
  // "background-color"
]), _0 = /* @__PURE__ */ qi(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function L0(e) {
  var u;
  const { motionValue: t, name: n, repeatDelay: r, repeatType: i, damping: o, type: s } = e;
  if (!(((u = t == null ? void 0 : t.owner) == null ? void 0 : u.current) instanceof HTMLElement))
    return !1;
  const { onUpdate: c, transformTemplate: l } = t.owner.getProps();
  return _0() && n && N0.has(n) && (n !== "transform" || !l) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !c && !r && i !== "mirror" && o !== 0 && s !== "inertia";
}
const j0 = 40;
class $0 extends lo {
  constructor({ autoplay: t = !0, delay: n = 0, type: r = "keyframes", repeat: i = 0, repeatDelay: o = 0, repeatType: s = "loop", keyframes: a, name: c, motionValue: l, element: u, ...f }) {
    var g;
    super(), this.stop = () => {
      var p, y;
      this._animation && (this._animation.stop(), (p = this.stopTimeline) == null || p.call(this)), (y = this.keyframeResolver) == null || y.cancel();
    }, this.createdAt = ge.now();
    const d = {
      autoplay: t,
      delay: n,
      type: r,
      repeat: i,
      repeatDelay: o,
      repeatType: s,
      name: c,
      motionValue: l,
      element: u,
      ...f
    }, h = (u == null ? void 0 : u.KeyframeResolver) || fo;
    this.keyframeResolver = new h(a, (p, y, v) => this.onKeyframesResolved(p, y, d, !v), c, l, u), (g = this.keyframeResolver) == null || g.scheduleResolve();
  }
  onKeyframesResolved(t, n, r, i) {
    this.keyframeResolver = void 0;
    const { name: o, type: s, velocity: a, delay: c, isHandoff: l, onUpdate: u } = r;
    this.resolvedAt = ge.now(), I0(t, o, s, a) || ((Ye.instantAnimations || !c) && (u == null || u(co(t, r, n))), t[0] = t[t.length - 1], r.duration = 0, r.repeat = 0);
    const d = {
      startTime: i ? this.resolvedAt ? this.resolvedAt - this.createdAt > j0 ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: n,
      ...r,
      keyframes: t
    }, h = !l && L0(d) ? new F0({
      ...d,
      element: d.motionValue.owner.current
    }) : new uo(d);
    h.finished.then(() => this.notifyFinished()).catch(Ce), this.pendingTimeline && (this.stopTimeline = h.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = h;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(t, n) {
    return this.finished.finally(t).then(() => {
    });
  }
  get animation() {
    var t;
    return this._animation || ((t = this.keyframeResolver) == null || t.resume(), x0()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get time() {
    return this.animation.time;
  }
  set time(t) {
    this.animation.time = t;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(t) {
    this.animation.speed = t;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(t) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(t) : this.pendingTimeline = t, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    var t;
    this._animation && this.animation.cancel(), (t = this.keyframeResolver) == null || t.cancel();
  }
}
const B0 = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function U0(e) {
  const t = B0.exec(e);
  if (!t)
    return [,];
  const [, n, r, i] = t;
  return [`--${n ?? r}`, i];
}
const z0 = 4;
function Gl(e, t, n = 1) {
  Ke(n <= z0, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
  const [r, i] = U0(e);
  if (!r)
    return;
  const o = window.getComputedStyle(t).getPropertyValue(r);
  if (o) {
    const s = o.trim();
    return hl(s) ? parseFloat(s) : s;
  }
  return ro(i) ? Gl(i, t, n + 1) : i;
}
function ho(e, t) {
  return (e == null ? void 0 : e[t]) ?? (e == null ? void 0 : e.default) ?? e;
}
const Hl = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...qt
]), W0 = {
  test: (e) => e === "auto",
  parse: (e) => e
}, Kl = (e) => (t) => t.test(e), Yl = [Xt, N, _e, Qe, kv, Fv, W0], Us = (e) => Yl.find(Kl(e));
function G0(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || ml(e) : !0;
}
const H0 = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function K0(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(io) || [];
  if (!r)
    return e;
  const i = n.replace(r, "");
  let o = H0.has(t) ? 1 : 0;
  return r !== n && (o *= 100), t + "(" + o + i + ")";
}
const Y0 = /\b([a-z-]*)\(.*?\)/gu, yi = {
  ...ot,
  getAnimatableNone: (e) => {
    const t = e.match(Y0);
    return t ? t.map(K0).join(" ") : e;
  }
}, zs = {
  ...Xt,
  transform: Math.round
}, Z0 = {
  rotate: Qe,
  rotateX: Qe,
  rotateY: Qe,
  rotateZ: Qe,
  scale: jn,
  scaleX: jn,
  scaleY: jn,
  scaleZ: jn,
  skew: Qe,
  skewX: Qe,
  skewY: Qe,
  distance: N,
  translateX: N,
  translateY: N,
  translateZ: N,
  x: N,
  y: N,
  z: N,
  perspective: N,
  transformPerspective: N,
  opacity: gn,
  originX: Rs,
  originY: Rs,
  originZ: N
}, po = {
  // Border props
  borderWidth: N,
  borderTopWidth: N,
  borderRightWidth: N,
  borderBottomWidth: N,
  borderLeftWidth: N,
  borderRadius: N,
  radius: N,
  borderTopLeftRadius: N,
  borderTopRightRadius: N,
  borderBottomRightRadius: N,
  borderBottomLeftRadius: N,
  // Positioning props
  width: N,
  maxWidth: N,
  height: N,
  maxHeight: N,
  top: N,
  right: N,
  bottom: N,
  left: N,
  // Spacing props
  padding: N,
  paddingTop: N,
  paddingRight: N,
  paddingBottom: N,
  paddingLeft: N,
  margin: N,
  marginTop: N,
  marginRight: N,
  marginBottom: N,
  marginLeft: N,
  // Misc
  backgroundPositionX: N,
  backgroundPositionY: N,
  ...Z0,
  zIndex: zs,
  // SVG
  fillOpacity: gn,
  strokeOpacity: gn,
  numOctaves: zs
}, X0 = {
  ...po,
  // Color props
  color: ne,
  backgroundColor: ne,
  outlineColor: ne,
  fill: ne,
  stroke: ne,
  // Border props
  borderColor: ne,
  borderTopColor: ne,
  borderRightColor: ne,
  borderBottomColor: ne,
  borderLeftColor: ne,
  filter: yi,
  WebkitFilter: yi
}, Zl = (e) => X0[e];
function Xl(e, t) {
  let n = Zl(e);
  return n !== yi && (n = ot), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const q0 = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function J0(e, t, n) {
  let r = 0, i;
  for (; r < e.length && !i; ) {
    const o = e[r];
    typeof o == "string" && !q0.has(o) && yn(o).values.length && (i = e[r]), r++;
  }
  if (i && n)
    for (const o of t)
      e[o] = Xl(n, i);
}
class Q0 extends fo {
  constructor(t, n, r, i, o) {
    super(t, n, r, i, o, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: n, name: r } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let c = 0; c < t.length; c++) {
      let l = t[c];
      if (typeof l == "string" && (l = l.trim(), ro(l))) {
        const u = Gl(l, n.current);
        u !== void 0 && (t[c] = u), c === t.length - 1 && (this.finalKeyframe = l);
      }
    }
    if (this.resolveNoneKeyframes(), !Hl.has(r) || t.length !== 2)
      return;
    const [i, o] = t, s = Us(i), a = Us(o);
    if (s !== a)
      if (Ls(s) && Ls(a))
        for (let c = 0; c < t.length; c++) {
          const l = t[c];
          typeof l == "string" && (t[c] = parseFloat(l));
        }
      else yt[r] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: n } = this, r = [];
    for (let i = 0; i < t.length; i++)
      (t[i] === null || G0(t[i])) && r.push(i);
    r.length && J0(t, r, n);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: n, name: r } = this;
    if (!t || !t.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = yt[r](t.measureViewportBox(), window.getComputedStyle(t.current)), n[0] = this.measuredOrigin;
    const i = n[n.length - 1];
    i !== void 0 && t.getValue(r, i).jump(i, !1);
  }
  measureEndState() {
    var a;
    const { element: t, name: n, unresolvedKeyframes: r } = this;
    if (!t || !t.current)
      return;
    const i = t.getValue(n);
    i && i.jump(this.measuredOrigin, !1);
    const o = r.length - 1, s = r[o];
    r[o] = yt[n](t.measureViewportBox(), window.getComputedStyle(t.current)), s !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = s), (a = this.removedTransforms) != null && a.length && this.removedTransforms.forEach(([c, l]) => {
      t.getValue(c).set(l);
    }), this.resolveNoneKeyframes();
  }
}
function eb(e, t, n) {
  if (e instanceof EventTarget)
    return [e];
  if (typeof e == "string") {
    let r = document;
    const i = (n == null ? void 0 : n[e]) ?? r.querySelectorAll(e);
    return i ? Array.from(i) : [];
  }
  return Array.from(e);
}
const ql = (e, t) => t && typeof e == "number" ? t.transform(e) : e;
function tb(e) {
  return pl(e) && "offsetHeight" in e;
}
const Ws = 30, nb = (e) => !isNaN(parseFloat(e));
class rb {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(t, n = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r, i = !0) => {
      var s, a;
      const o = ge.now();
      if (this.updatedAt !== o && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && ((s = this.events.change) == null || s.notify(this.current), this.dependents))
        for (const c of this.dependents)
          c.dirty();
      i && ((a = this.events.renderRequest) == null || a.notify(this.current));
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = n.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = ge.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = nb(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && Qi(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new Ji());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), Z.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(t, n) : this.passiveEffect(t, this.updateAndNotify);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, n = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    var t;
    (t = this.events.change) == null || t.notify(this.current);
  }
  addDependent(t) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(t);
  }
  removeDependent(t) {
    this.dependents && this.dependents.delete(t);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = ge.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > Ws)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, Ws);
    return gl(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    var t, n;
    (t = this.dependents) == null || t.clear(), (n = this.events.destroy) == null || n.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Ut(e, t) {
  return new rb(e, t);
}
const { schedule: mo } = /* @__PURE__ */ Cl(queueMicrotask, !1), De = {
  x: !1,
  y: !1
};
function Jl() {
  return De.x || De.y;
}
function ib(e) {
  return e === "x" || e === "y" ? De[e] ? null : (De[e] = !0, () => {
    De[e] = !1;
  }) : De.x || De.y ? null : (De.x = De.y = !0, () => {
    De.x = De.y = !1;
  });
}
function Ql(e, t) {
  const n = eb(e), r = new AbortController(), i = {
    passive: !0,
    ...t,
    signal: r.signal
  };
  return [n, i, () => r.abort()];
}
function Gs(e) {
  return !(e.pointerType === "touch" || Jl());
}
function ob(e, t, n = {}) {
  const [r, i, o] = Ql(e, n), s = (a) => {
    if (!Gs(a))
      return;
    const { target: c } = a, l = t(c, a);
    if (typeof l != "function" || !c)
      return;
    const u = (f) => {
      Gs(f) && (l(f), c.removeEventListener("pointerleave", u));
    };
    c.addEventListener("pointerleave", u, i);
  };
  return r.forEach((a) => {
    a.addEventListener("pointerenter", s, i);
  }), o;
}
const eu = (e, t) => t ? e === t ? !0 : eu(e, t.parentElement) : !1, go = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1, sb = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function ab(e) {
  return sb.has(e.tagName) || e.tabIndex !== -1;
}
const Gn = /* @__PURE__ */ new WeakSet();
function Hs(e) {
  return (t) => {
    t.key === "Enter" && e(t);
  };
}
function Lr(e, t) {
  e.dispatchEvent(new PointerEvent("pointer" + t, { isPrimary: !0, bubbles: !0 }));
}
const cb = (e, t) => {
  const n = e.currentTarget;
  if (!n)
    return;
  const r = Hs(() => {
    if (Gn.has(n))
      return;
    Lr(n, "down");
    const i = Hs(() => {
      Lr(n, "up");
    }), o = () => Lr(n, "cancel");
    n.addEventListener("keyup", i, t), n.addEventListener("blur", o, t);
  });
  n.addEventListener("keydown", r, t), n.addEventListener("blur", () => n.removeEventListener("keydown", r), t);
};
function Ks(e) {
  return go(e) && !Jl();
}
function lb(e, t, n = {}) {
  const [r, i, o] = Ql(e, n), s = (a) => {
    const c = a.currentTarget;
    if (!Ks(a))
      return;
    Gn.add(c);
    const l = t(c, a), u = (h, g) => {
      window.removeEventListener("pointerup", f), window.removeEventListener("pointercancel", d), Gn.has(c) && Gn.delete(c), Ks(h) && typeof l == "function" && l(h, { success: g });
    }, f = (h) => {
      u(h, c === window || c === document || n.useGlobalTarget || eu(c, h.target));
    }, d = (h) => {
      u(h, !1);
    };
    window.addEventListener("pointerup", f, i), window.addEventListener("pointercancel", d, i);
  };
  return r.forEach((a) => {
    (n.useGlobalTarget ? window : a).addEventListener("pointerdown", s, i), tb(a) && (a.addEventListener("focus", (l) => cb(l, i)), !ab(a) && !a.hasAttribute("tabindex") && (a.tabIndex = 0));
  }), o;
}
function tu(e) {
  return pl(e) && "ownerSVGElement" in e;
}
function ub(e) {
  return tu(e) && e.tagName === "svg";
}
const de = (e) => !!(e && e.getVelocity), db = [...Yl, ne, ot], fb = (e) => db.find(Kl(e)), nu = st({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
});
function hb(e = !0) {
  const t = ue(Yi);
  if (t === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: r, register: i } = t, o = ed();
  le(() => {
    if (e)
      return i(o);
  }, [e]);
  const s = J(() => e && r && r(o), [o, r, e]);
  return !n && r ? [!1, s] : [!0];
}
const ru = st({ strict: !1 }), Ys = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, zt = {};
for (const e in Ys)
  zt[e] = {
    isEnabled: (t) => Ys[e].some((n) => !!t[n])
  };
function pb(e) {
  for (const t in e)
    zt[t] = {
      ...zt[t],
      ...e[t]
    };
}
const mb = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function tr(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || mb.has(e);
}
let iu = (e) => !tr(e);
function gb(e) {
  typeof e == "function" && (iu = (t) => t.startsWith("on") ? !tr(t) : e(t));
}
try {
  gb(require("@emotion/is-prop-valid").default);
} catch {
}
function yb(e, t, n) {
  const r = {};
  for (const i in e)
    i === "values" && typeof e.values == "object" || (iu(i) || n === !0 && tr(i) || !t && !tr(i) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && i.startsWith("onDrag")) && (r[i] = e[i]);
  return r;
}
const dr = /* @__PURE__ */ st({});
function fr(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
function vn(e) {
  return typeof e == "string" || Array.isArray(e);
}
const yo = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], vo = ["initial", ...yo];
function hr(e) {
  return fr(e.animate) || vo.some((t) => vn(e[t]));
}
function ou(e) {
  return !!(hr(e) || e.variants);
}
function vb(e, t) {
  if (hr(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || vn(n) ? n : void 0,
      animate: vn(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function bb(e) {
  const { initial: t, animate: n } = vb(e, ue(dr));
  return Ge(() => ({ initial: t, animate: n }), [Zs(t), Zs(n)]);
}
function Zs(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const bn = {};
function wb(e) {
  for (const t in e)
    bn[t] = e[t], no(t) && (bn[t].isCSSVariable = !0);
}
function su(e, { layout: t, layoutId: n }) {
  return Jt.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!bn[e] || e === "opacity");
}
const Tb = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, xb = qt.length;
function Sb(e, t, n) {
  let r = "", i = !0;
  for (let o = 0; o < xb; o++) {
    const s = qt[o], a = e[s];
    if (a === void 0)
      continue;
    let c = !0;
    if (typeof a == "number" ? c = a === (s.startsWith("scale") ? 1 : 0) : c = parseFloat(a) === 0, !c || n) {
      const l = ql(a, po[s]);
      if (!c) {
        i = !1;
        const u = Tb[s] || s;
        r += `${u}(${l}) `;
      }
      n && (t[s] = l);
    }
  }
  return r = r.trim(), n ? r = n(t, i ? "" : r) : i && (r = "none"), r;
}
function bo(e, t, n) {
  const { style: r, vars: i, transformOrigin: o } = e;
  let s = !1, a = !1;
  for (const c in t) {
    const l = t[c];
    if (Jt.has(c)) {
      s = !0;
      continue;
    } else if (no(c)) {
      i[c] = l;
      continue;
    } else {
      const u = ql(l, po[c]);
      c.startsWith("origin") ? (a = !0, o[c] = u) : r[c] = u;
    }
  }
  if (t.transform || (s || n ? r.transform = Sb(t, e.transform, n) : r.transform && (r.transform = "none")), a) {
    const { originX: c = "50%", originY: l = "50%", originZ: u = 0 } = o;
    r.transformOrigin = `${c} ${l} ${u}`;
  }
}
const wo = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function au(e, t, n) {
  for (const r in t)
    !de(t[r]) && !su(r, n) && (e[r] = t[r]);
}
function Eb({ transformTemplate: e }, t) {
  return Ge(() => {
    const n = wo();
    return bo(n, t, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function Ab(e, t) {
  const n = e.style || {}, r = {};
  return au(r, n, e), Object.assign(r, Eb(e, t)), r;
}
function Pb(e, t) {
  const n = {}, r = Ab(e, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
const Cb = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, Mb = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function Rb(e, t, n = 1, r = 0, i = !0) {
  e.pathLength = 1;
  const o = i ? Cb : Mb;
  e[o.offset] = N.transform(-r);
  const s = N.transform(t), a = N.transform(n);
  e[o.array] = `${s} ${a}`;
}
function cu(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  pathLength: i,
  pathSpacing: o = 1,
  pathOffset: s = 0,
  // This is object creation, which we try to avoid per-frame.
  ...a
}, c, l, u) {
  if (bo(e, a, l), c) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: f, style: d } = e;
  f.transform && (d.transform = f.transform, delete f.transform), (d.transform || f.transformOrigin) && (d.transformOrigin = f.transformOrigin ?? "50% 50%", delete f.transformOrigin), d.transform && (d.transformBox = (u == null ? void 0 : u.transformBox) ?? "fill-box", delete f.transformBox), t !== void 0 && (f.x = t), n !== void 0 && (f.y = n), r !== void 0 && (f.scale = r), i !== void 0 && Rb(f, i, o, s, !1);
}
const lu = () => ({
  ...wo(),
  attrs: {}
}), uu = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function Db(e, t, n, r) {
  const i = Ge(() => {
    const o = lu();
    return cu(o, t, uu(r), e.transformTemplate, e.style), {
      ...o.attrs,
      style: { ...o.style }
    };
  }, [t]);
  if (e.style) {
    const o = {};
    au(o, e.style, e), i.style = { ...o, ...i.style };
  }
  return i;
}
const Ob = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function To(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(Ob.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
function Vb(e, t, n, { latestValues: r }, i, o = !1) {
  const a = (To(e) ? Db : Pb)(t, r, i, e), c = yb(t, typeof e == "string", o), l = e !== za ? { ...c, ...a, ref: n } : {}, { children: u } = t, f = Ge(() => de(u) ? u.get() : u, [u]);
  return Pe(e, {
    ...l,
    children: f
  });
}
function Xs(e) {
  const t = [{}, {}];
  return e == null || e.values.forEach((n, r) => {
    t[0][r] = n.get(), t[1][r] = n.getVelocity();
  }), t;
}
function xo(e, t, n, r) {
  if (typeof t == "function") {
    const [i, o] = Xs(r);
    t = t(n !== void 0 ? n : e.custom, i, o);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [i, o] = Xs(r);
    t = t(n !== void 0 ? n : e.custom, i, o);
  }
  return t;
}
function Hn(e) {
  return de(e) ? e.get() : e;
}
function Fb({ scrapeMotionValuesFromProps: e, createRenderState: t }, n, r, i) {
  return {
    latestValues: kb(n, r, i, e),
    renderState: t()
  };
}
function kb(e, t, n, r) {
  const i = {}, o = r(e, {});
  for (const d in o)
    i[d] = Hn(o[d]);
  let { initial: s, animate: a } = e;
  const c = hr(e), l = ou(e);
  t && l && !c && e.inherit !== !1 && (s === void 0 && (s = t.initial), a === void 0 && (a = t.animate));
  let u = n ? n.initial === !1 : !1;
  u = u || s === !1;
  const f = u ? a : s;
  if (f && typeof f != "boolean" && !fr(f)) {
    const d = Array.isArray(f) ? f : [f];
    for (let h = 0; h < d.length; h++) {
      const g = xo(e, d[h]);
      if (g) {
        const { transitionEnd: p, transition: y, ...v } = g;
        for (const x in v) {
          let T = v[x];
          if (Array.isArray(T)) {
            const E = u ? T.length - 1 : 0;
            T = T[E];
          }
          T !== null && (i[x] = T);
        }
        for (const x in p)
          i[x] = p[x];
      }
    }
  }
  return i;
}
const du = (e) => (t, n) => {
  const r = ue(dr), i = ue(Yi), o = () => Fb(e, t, r, i);
  return n ? o() : pv(o);
};
function So(e, t, n) {
  var o;
  const { style: r } = e, i = {};
  for (const s in r)
    (de(r[s]) || t.style && de(t.style[s]) || su(s, e) || ((o = n == null ? void 0 : n.getValue(s)) == null ? void 0 : o.liveStyle) !== void 0) && (i[s] = r[s]);
  return i;
}
const Ib = /* @__PURE__ */ du({
  scrapeMotionValuesFromProps: So,
  createRenderState: wo
});
function fu(e, t, n) {
  const r = So(e, t, n);
  for (const i in e)
    if (de(e[i]) || de(t[i])) {
      const o = qt.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      r[o] = e[i];
    }
  return r;
}
const Nb = /* @__PURE__ */ du({
  scrapeMotionValuesFromProps: fu,
  createRenderState: lu
}), _b = Symbol.for("motionComponentSymbol");
function Nt(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function Lb(e, t, n) {
  return J(
    (r) => {
      r && e.onMount && e.onMount(r), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : Nt(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
const Eo = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), jb = "framerAppearId", hu = "data-" + Eo(jb), pu = st({});
function $b(e, t, n, r, i) {
  var p, y;
  const { visualElement: o } = ue(dr), s = ue(ru), a = ue(Yi), c = ue(nu).reducedMotion, l = ve(null);
  r = r || s.renderer, !l.current && r && (l.current = r(e, {
    visualState: t,
    parent: o,
    props: n,
    presenceContext: a,
    blockInitialAnimation: a ? a.initial === !1 : !1,
    reducedMotionConfig: c
  }));
  const u = l.current, f = ue(pu);
  u && !u.projection && i && (u.type === "html" || u.type === "svg") && Bb(l.current, n, i, f);
  const d = ve(!1);
  td(() => {
    u && d.current && u.update(n, a);
  });
  const h = n[hu], g = ve(!!h && !((p = window.MotionHandoffIsComplete) != null && p.call(window, h)) && ((y = window.MotionHasOptimisedAnimation) == null ? void 0 : y.call(window, h)));
  return mv(() => {
    u && (d.current = !0, window.MotionIsMounted = !0, u.updateFeatures(), u.scheduleRenderMicrotask(), g.current && u.animationState && u.animationState.animateChanges());
  }), le(() => {
    u && (!g.current && u.animationState && u.animationState.animateChanges(), g.current && (queueMicrotask(() => {
      var v;
      (v = window.MotionHandoffMarkAsComplete) == null || v.call(window, h);
    }), g.current = !1));
  }), u;
}
function Bb(e, t, n, r) {
  const { layoutId: i, layout: o, drag: s, dragConstraints: a, layoutScroll: c, layoutRoot: l, layoutCrossfade: u } = t;
  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : mu(e.parent)), e.projection.setOptions({
    layoutId: i,
    layout: o,
    alwaysMeasureLayout: !!s || a && Nt(a),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof o == "string" ? o : "both",
    initialPromotionConfig: r,
    crossfade: u,
    layoutScroll: c,
    layoutRoot: l
  });
}
function mu(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : mu(e.parent);
}
function jr(e, { forwardMotionProps: t = !1 } = {}, n, r) {
  n && pb(n);
  const i = To(e) ? Nb : Ib;
  function o(a, c) {
    let l;
    const u = {
      ...ue(nu),
      ...a,
      layoutId: Ub(a)
    }, { isStatic: f } = u, d = bb(a), h = i(a, f);
    if (!f && Ki) {
      zb(u, n);
      const g = Wb(u);
      l = g.MeasureLayout, d.visualElement = $b(e, h, u, r, g.ProjectionNode);
    }
    return be(dr.Provider, { value: d, children: [l && d.visualElement ? M(l, { visualElement: d.visualElement, ...u }) : null, Vb(e, a, Lb(h, d.visualElement, c), h, f, t)] });
  }
  o.displayName = `motion.${typeof e == "string" ? e : `create(${e.displayName ?? e.name ?? ""})`}`;
  const s = Ua(o);
  return s[_b] = e, s;
}
function Ub({ layoutId: e }) {
  const t = ue(fl).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function zb(e, t) {
  const n = ue(ru).strict;
  if (process.env.NODE_ENV !== "production" && t && n) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    e.ignoreStrict ? Zt(!1, r, "lazy-strict-mode") : Ke(!1, r, "lazy-strict-mode");
  }
}
function Wb(e) {
  const { drag: t, layout: n } = zt;
  if (!t && !n)
    return {};
  const r = { ...t, ...n };
  return {
    MeasureLayout: t != null && t.isEnabled(e) || n != null && n.isEnabled(e) ? r.MeasureLayout : void 0,
    ProjectionNode: r.ProjectionNode
  };
}
function Gb(e, t) {
  if (typeof Proxy > "u")
    return jr;
  const n = /* @__PURE__ */ new Map(), r = (o, s) => jr(o, s, e, t), i = (o, s) => (process.env.NODE_ENV !== "production" && Qi(!1, "motion() is deprecated. Use motion.create() instead."), r(o, s));
  return new Proxy(i, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (o, s) => s === "create" ? r : (n.has(s) || n.set(s, jr(s, void 0, e, t)), n.get(s))
  });
}
function gu({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function Hb({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function Kb(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function $r(e) {
  return e === void 0 || e === 1;
}
function vi({ scale: e, scaleX: t, scaleY: n }) {
  return !$r(e) || !$r(t) || !$r(n);
}
function pt(e) {
  return vi(e) || yu(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function yu(e) {
  return qs(e.x) || qs(e.y);
}
function qs(e) {
  return e && e !== "0%";
}
function nr(e, t, n) {
  const r = e - n, i = t * r;
  return n + i;
}
function Js(e, t, n, r, i) {
  return i !== void 0 && (e = nr(e, i, r)), nr(e, n, r) + t;
}
function bi(e, t = 0, n = 1, r, i) {
  e.min = Js(e.min, t, n, r, i), e.max = Js(e.max, t, n, r, i);
}
function vu(e, { x: t, y: n }) {
  bi(e.x, t.translate, t.scale, t.originPoint), bi(e.y, n.translate, n.scale, n.originPoint);
}
const Qs = 0.999999999999, ea = 1.0000000000001;
function Yb(e, t, n, r = !1) {
  const i = n.length;
  if (!i)
    return;
  t.x = t.y = 1;
  let o, s;
  for (let a = 0; a < i; a++) {
    o = n[a], s = o.projectionDelta;
    const { visualElement: c } = o.options;
    c && c.props.style && c.props.style.display === "contents" || (r && o.options.layoutScroll && o.scroll && o !== o.root && Lt(e, {
      x: -o.scroll.offset.x,
      y: -o.scroll.offset.y
    }), s && (t.x *= s.x.scale, t.y *= s.y.scale, vu(e, s)), r && pt(o.latestValues) && Lt(e, o.latestValues));
  }
  t.x < ea && t.x > Qs && (t.x = 1), t.y < ea && t.y > Qs && (t.y = 1);
}
function _t(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function ta(e, t, n, r, i = 0.5) {
  const o = q(e.min, e.max, i);
  bi(e, t, n, o, r);
}
function Lt(e, t) {
  ta(e.x, t.x, t.scaleX, t.scale, t.originX), ta(e.y, t.y, t.scaleY, t.scale, t.originY);
}
function bu(e, t) {
  return gu(Kb(e.getBoundingClientRect(), t));
}
function Zb(e, t, n) {
  const r = bu(e, n), { scroll: i } = t;
  return i && (_t(r.x, i.offset.x), _t(r.y, i.offset.y)), r;
}
const na = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), jt = () => ({
  x: na(),
  y: na()
}), ra = () => ({ min: 0, max: 0 }), ee = () => ({
  x: ra(),
  y: ra()
}), wi = { current: null }, wu = { current: !1 };
function Xb() {
  if (wu.current = !0, !!Ki)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => wi.current = e.matches;
      e.addEventListener("change", t), t();
    } else
      wi.current = !1;
}
const qb = /* @__PURE__ */ new WeakMap();
function Jb(e, t, n) {
  for (const r in t) {
    const i = t[r], o = n[r];
    if (de(i))
      e.addValue(r, i);
    else if (de(o))
      e.addValue(r, Ut(i, { owner: e }));
    else if (o !== i)
      if (e.hasValue(r)) {
        const s = e.getValue(r);
        s.liveStyle === !0 ? s.jump(i) : s.hasAnimated || s.set(i);
      } else {
        const s = e.getStaticValue(r);
        e.addValue(r, Ut(s !== void 0 ? s : i, { owner: e }));
      }
  }
  for (const r in n)
    t[r] === void 0 && e.removeValue(r);
  return t;
}
const ia = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class Qb {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n, r) {
    return {};
  }
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: i, blockInitialAnimation: o, visualState: s }, a = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = fo, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const d = ge.now();
      this.renderScheduledAt < d && (this.renderScheduledAt = d, Z.render(this.render, !1, !0));
    };
    const { latestValues: c, renderState: l } = s;
    this.latestValues = c, this.baseTarget = { ...c }, this.initialValues = n.initial ? { ...c } : {}, this.renderState = l, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = i, this.options = a, this.blockInitialAnimation = !!o, this.isControllingVariants = hr(n), this.isVariantNode = ou(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: u, ...f } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const d in f) {
      const h = f[d];
      c[d] !== void 0 && de(h) && h.set(c[d], !1);
    }
  }
  mount(t) {
    this.current = t, qb.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), wu.current || Xb(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : wi.current, process.env.NODE_ENV !== "production" && Qi(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    this.projection && this.projection.unmount(), it(this.notifyUpdate), it(this.render), this.valueSubscriptions.forEach((t) => t()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features) {
      const n = this.features[t];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(t, n) {
    this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)();
    const r = Jt.has(t);
    r && this.onBindTransform && this.onBindTransform();
    const i = n.on("change", (a) => {
      this.latestValues[t] = a, this.props.onUpdate && Z.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0);
    }), o = n.on("renderRequest", this.scheduleRender);
    let s;
    window.MotionCheckAppearSync && (s = window.MotionCheckAppearSync(this, t, n)), this.valueSubscriptions.set(t, () => {
      i(), o(), s && s(), n.owner && n.stop();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in zt) {
      const n = zt[t];
      if (!n)
        continue;
      const { isEnabled: r, Feature: i } = n;
      if (!this.features[t] && i && r(this.props) && (this.features[t] = new i(this)), this.features[t]) {
        const o = this.features[t];
        o.isMounted ? o.update() : (o.mount(), o.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : ee();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < ia.length; r++) {
      const i = ia[r];
      this.propEventSubscriptions[i] && (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
      const o = "on" + i, s = t[o];
      s && (this.propEventSubscriptions[i] = this.on(i, s));
    }
    this.prevMotionValues = Jb(this, this.scrapeMotionValuesFromProps(t, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    const r = this.values.get(t);
    n !== r && (r && this.removeValue(t), this.bindToMotionValue(t, n), this.values.set(t, n), this.latestValues[t] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = Ut(n === null ? void 0 : n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, n) {
    let r = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : this.getBaseTargetFromProps(this.props, t) ?? this.readValueFromInstance(this.current, t, this.options);
    return r != null && (typeof r == "string" && (hl(r) || ml(r)) ? r = parseFloat(r) : !fb(r) && ot.test(n) && (r = Xl(t, n)), this.setBaseTarget(t, de(r) ? r.get() : r)), de(r) ? r.get() : r;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var o;
    const { initial: n } = this.props;
    let r;
    if (typeof n == "string" || typeof n == "object") {
      const s = xo(this.props, n, (o = this.presenceContext) == null ? void 0 : o.custom);
      s && (r = s[t]);
    }
    if (n && r !== void 0)
      return r;
    const i = this.getBaseTargetFromProps(this.props, t);
    return i !== void 0 && !de(i) ? i : this.initialValues[t] !== void 0 && r === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new Ji()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
  scheduleRenderMicrotask() {
    mo.render(this.render);
  }
}
class Tu extends Qb {
  constructor() {
    super(...arguments), this.KeyframeResolver = Q0;
  }
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    de(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
function xu(e, { style: t, vars: n }, r, i) {
  const o = e.style;
  let s;
  for (s in t)
    o[s] = t[s];
  i == null || i.applyProjectionStyles(o, r);
  for (s in n)
    o.setProperty(s, n[s]);
}
function e1(e) {
  return window.getComputedStyle(e);
}
class t1 extends Tu {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = xu;
  }
  readValueFromInstance(t, n) {
    var r;
    if (Jt.has(n))
      return (r = this.projection) != null && r.isProjecting ? fi(n) : y0(t, n);
    {
      const i = e1(t), o = (no(n) ? i.getPropertyValue(n) : i[n]) || 0;
      return typeof o == "string" ? o.trim() : o;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return bu(t, n);
  }
  build(t, n, r) {
    bo(t, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return So(t, n, r);
  }
}
const Su = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function n1(e, t, n, r) {
  xu(e, t, void 0, r);
  for (const i in t.attrs)
    e.setAttribute(Su.has(i) ? i : Eo(i), t.attrs[i]);
}
class r1 extends Tu {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = ee;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (Jt.has(n)) {
      const r = Zl(n);
      return r && r.default || 0;
    }
    return n = Su.has(n) ? n : Eo(n), t.getAttribute(n);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return fu(t, n, r);
  }
  build(t, n, r) {
    cu(t, n, this.isSVGTag, r.transformTemplate, r.style);
  }
  renderInstance(t, n, r, i) {
    n1(t, n, r, i);
  }
  mount(t) {
    this.isSVGTag = uu(t.tagName), super.mount(t);
  }
}
const i1 = (e, t) => To(e) ? new r1(t) : new t1(t, {
  allowProjection: e !== za
});
function wn(e, t, n) {
  const r = e.getProps();
  return xo(r, t, n !== void 0 ? n : r.custom, e);
}
const Ti = (e) => Array.isArray(e);
function o1(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Ut(n));
}
function s1(e) {
  return Ti(e) ? e[e.length - 1] || 0 : e;
}
function a1(e, t) {
  const n = wn(e, t);
  let { transitionEnd: r = {}, transition: i = {}, ...o } = n || {};
  o = { ...o, ...r };
  for (const s in o) {
    const a = s1(o[s]);
    o1(e, s, a);
  }
}
function c1(e) {
  return !!(de(e) && e.add);
}
function xi(e, t) {
  const n = e.getValue("willChange");
  if (c1(n))
    return n.add(t);
  if (!n && Ye.WillChange) {
    const r = new Ye.WillChange("auto");
    e.addValue("willChange", r), r.add(t);
  }
}
function Eu(e) {
  return e.props[hu];
}
const l1 = (e) => e !== null;
function u1(e, { repeat: t, repeatType: n = "loop" }, r) {
  const i = e.filter(l1), o = t && n !== "loop" && t % 2 === 1 ? 0 : i.length - 1;
  return i[o];
}
const d1 = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, f1 = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), h1 = {
  type: "keyframes",
  duration: 0.8
}, p1 = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, m1 = (e, { keyframes: t }) => t.length > 2 ? h1 : Jt.has(e) ? e.startsWith("scale") ? f1(t[1]) : d1 : p1;
function g1({ when: e, delay: t, delayChildren: n, staggerChildren: r, staggerDirection: i, repeat: o, repeatType: s, repeatDelay: a, from: c, elapsed: l, ...u }) {
  return !!Object.keys(u).length;
}
const Ao = (e, t, n, r = {}, i, o) => (s) => {
  const a = ho(r, e) || {}, c = a.delay || r.delay || 0;
  let { elapsed: l = 0 } = r;
  l = l - /* @__PURE__ */ Oe(c);
  const u = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...a,
    delay: -l,
    onUpdate: (d) => {
      t.set(d), a.onUpdate && a.onUpdate(d);
    },
    onComplete: () => {
      s(), a.onComplete && a.onComplete();
    },
    name: e,
    motionValue: t,
    element: o ? void 0 : i
  };
  g1(a) || Object.assign(u, m1(e, u)), u.duration && (u.duration = /* @__PURE__ */ Oe(u.duration)), u.repeatDelay && (u.repeatDelay = /* @__PURE__ */ Oe(u.repeatDelay)), u.from !== void 0 && (u.keyframes[0] = u.from);
  let f = !1;
  if ((u.type === !1 || u.duration === 0 && !u.repeatDelay) && (u.duration = 0, u.delay === 0 && (f = !0)), (Ye.instantAnimations || Ye.skipAnimations) && (f = !0, u.duration = 0, u.delay = 0), u.allowFlatten = !a.type && !a.ease, f && !o && t.get() !== void 0) {
    const d = u1(u.keyframes, a);
    if (d !== void 0) {
      Z.update(() => {
        u.onUpdate(d), u.onComplete();
      });
      return;
    }
  }
  return a.isSync ? new uo(u) : new $0(u);
};
function y1({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function Au(e, t, { delay: n = 0, transitionOverride: r, type: i } = {}) {
  let { transition: o = e.getDefaultTransition(), transitionEnd: s, ...a } = t;
  r && (o = r);
  const c = [], l = i && e.animationState && e.animationState.getState()[i];
  for (const u in a) {
    const f = e.getValue(u, e.latestValues[u] ?? null), d = a[u];
    if (d === void 0 || l && y1(l, u))
      continue;
    const h = {
      delay: n,
      ...ho(o || {}, u)
    }, g = f.get();
    if (g !== void 0 && !f.isAnimating && !Array.isArray(d) && d === g && !h.velocity)
      continue;
    let p = !1;
    if (window.MotionHandoffAnimation) {
      const v = Eu(e);
      if (v) {
        const x = window.MotionHandoffAnimation(v, u, Z);
        x !== null && (h.startTime = x, p = !0);
      }
    }
    xi(e, u), f.start(Ao(u, f, d, e.shouldReduceMotion && Hl.has(u) ? { type: !1 } : h, e, p));
    const y = f.animation;
    y && c.push(y);
  }
  return s && Promise.all(c).then(() => {
    Z.update(() => {
      s && a1(e, s);
    });
  }), c;
}
function Si(e, t, n = {}) {
  var c;
  const r = wn(e, t, n.type === "exit" ? (c = e.presenceContext) == null ? void 0 : c.custom : void 0);
  let { transition: i = e.getDefaultTransition() || {} } = r || {};
  n.transitionOverride && (i = n.transitionOverride);
  const o = r ? () => Promise.all(Au(e, r, n)) : () => Promise.resolve(), s = e.variantChildren && e.variantChildren.size ? (l = 0) => {
    const { delayChildren: u = 0, staggerChildren: f, staggerDirection: d } = i;
    return v1(e, t, l, u, f, d, n);
  } : () => Promise.resolve(), { when: a } = i;
  if (a) {
    const [l, u] = a === "beforeChildren" ? [o, s] : [s, o];
    return l().then(() => u());
  } else
    return Promise.all([o(), s(n.delay)]);
}
function v1(e, t, n = 0, r = 0, i = 0, o = 1, s) {
  const a = [], c = e.variantChildren.size, l = (c - 1) * i, u = typeof r == "function", f = u ? (d) => r(d, c) : (
    // Support deprecated staggerChildren
    o === 1 ? (d = 0) => d * i : (d = 0) => l - d * i
  );
  return Array.from(e.variantChildren).sort(b1).forEach((d, h) => {
    d.notify("AnimationStart", t), a.push(Si(d, t, {
      ...s,
      delay: n + (u ? 0 : r) + f(h)
    }).then(() => d.notify("AnimationComplete", t)));
  }), Promise.all(a);
}
function b1(e, t) {
  return e.sortNodePosition(t);
}
function w1(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const i = t.map((o) => Si(e, o, n));
    r = Promise.all(i);
  } else if (typeof t == "string")
    r = Si(e, t, n);
  else {
    const i = typeof t == "function" ? wn(e, t, n.custom) : t;
    r = Promise.all(Au(e, i, n));
  }
  return r.then(() => {
    e.notify("AnimationComplete", t);
  });
}
function Pu(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
const T1 = vo.length;
function Cu(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const n = e.parent ? Cu(e.parent) || {} : {};
    return e.props.initial !== void 0 && (n.initial = e.props.initial), n;
  }
  const t = {};
  for (let n = 0; n < T1; n++) {
    const r = vo[n], i = e.props[r];
    (vn(i) || i === !1) && (t[r] = i);
  }
  return t;
}
const x1 = [...yo].reverse(), S1 = yo.length;
function E1(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => w1(e, n, r)));
}
function A1(e) {
  let t = E1(e), n = oa(), r = !0;
  const i = (c) => (l, u) => {
    var d;
    const f = wn(e, u, c === "exit" ? (d = e.presenceContext) == null ? void 0 : d.custom : void 0);
    if (f) {
      const { transition: h, transitionEnd: g, ...p } = f;
      l = { ...l, ...p, ...g };
    }
    return l;
  };
  function o(c) {
    t = c(e);
  }
  function s(c) {
    const { props: l } = e, u = Cu(e.parent) || {}, f = [], d = /* @__PURE__ */ new Set();
    let h = {}, g = 1 / 0;
    for (let y = 0; y < S1; y++) {
      const v = x1[y], x = n[v], T = l[v] !== void 0 ? l[v] : u[v], E = vn(T), b = v === c ? x.isActive : null;
      b === !1 && (g = y);
      let A = T === u[v] && T !== l[v] && E;
      if (A && r && e.manuallyAnimateOnMount && (A = !1), x.protectedKeys = { ...h }, // If it isn't active and hasn't *just* been set as inactive
      !x.isActive && b === null || // If we didn't and don't have any defined prop for this animation type
      !T && !x.prevProp || // Or if the prop doesn't define an animation
      fr(T) || typeof T == "boolean")
        continue;
      const P = P1(x.prevProp, T);
      let S = P || // If we're making this variant active, we want to always make it active
      v === c && x.isActive && !A && E || // If we removed a higher-priority variant (i is in reverse order)
      y > g && E, I = !1;
      const G = Array.isArray(T) ? T : [T];
      let he = G.reduce(i(v), {});
      b === !1 && (he = {});
      const { prevResolvedValues: Me = {} } = x, se = {
        ...Me,
        ...he
      }, pe = (z) => {
        S = !0, d.has(z) && (I = !0, d.delete(z)), x.needsAnimating[z] = !0;
        const O = e.getValue(z);
        O && (O.liveStyle = !1);
      };
      for (const z in se) {
        const O = he[z], Re = Me[z];
        if (h.hasOwnProperty(z))
          continue;
        let Te = !1;
        Ti(O) && Ti(Re) ? Te = !Pu(O, Re) : Te = O !== Re, Te ? O != null ? pe(z) : d.add(z) : O !== void 0 && d.has(z) ? pe(z) : x.protectedKeys[z] = !0;
      }
      x.prevProp = T, x.prevResolvedValues = he, x.isActive && (h = { ...h, ...he }), r && e.blockInitialAnimation && (S = !1), S && (!(A && P) || I) && f.push(...G.map((z) => ({
        animation: z,
        options: { type: v }
      })));
    }
    if (d.size) {
      const y = {};
      if (typeof l.initial != "boolean") {
        const v = wn(e, Array.isArray(l.initial) ? l.initial[0] : l.initial);
        v && v.transition && (y.transition = v.transition);
      }
      d.forEach((v) => {
        const x = e.getBaseTarget(v), T = e.getValue(v);
        T && (T.liveStyle = !0), y[v] = x ?? null;
      }), f.push({ animation: y });
    }
    let p = !!f.length;
    return r && (l.initial === !1 || l.initial === l.animate) && !e.manuallyAnimateOnMount && (p = !1), r = !1, p ? t(f) : Promise.resolve();
  }
  function a(c, l) {
    var f;
    if (n[c].isActive === l)
      return Promise.resolve();
    (f = e.variantChildren) == null || f.forEach((d) => {
      var h;
      return (h = d.animationState) == null ? void 0 : h.setActive(c, l);
    }), n[c].isActive = l;
    const u = s(c);
    for (const d in n)
      n[d].protectedKeys = {};
    return u;
  }
  return {
    animateChanges: s,
    setActive: a,
    setAnimateFunction: o,
    getState: () => n,
    reset: () => {
      n = oa(), r = !0;
    }
  };
}
function P1(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !Pu(t, e) : !1;
}
function ht(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function oa() {
  return {
    animate: ht(!0),
    whileInView: ht(),
    whileHover: ht(),
    whileTap: ht(),
    whileDrag: ht(),
    whileFocus: ht(),
    exit: ht()
  };
}
class ct {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
class C1 extends ct {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = A1(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    fr(t) && (this.unmountControls = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var t;
    this.node.animationState.reset(), (t = this.unmountControls) == null || t.call(this);
  }
}
let M1 = 0;
class R1 extends ct {
  constructor() {
    super(...arguments), this.id = M1++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === r)
      return;
    const i = this.node.animationState.setActive("exit", !t);
    n && !t && i.then(() => {
      n(this.id);
    });
  }
  mount() {
    const { register: t, onExitComplete: n } = this.node.presenceContext || {};
    n && n(this.id), t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const D1 = {
  animation: {
    Feature: C1
  },
  exit: {
    Feature: R1
  }
};
function Tn(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
}
function Cn(e) {
  return {
    point: {
      x: e.pageX,
      y: e.pageY
    }
  };
}
const O1 = (e) => (t) => go(t) && e(t, Cn(t));
function ln(e, t, n, r) {
  return Tn(e, t, O1(n), r);
}
const Mu = 1e-4, V1 = 1 - Mu, F1 = 1 + Mu, Ru = 0.01, k1 = 0 - Ru, I1 = 0 + Ru;
function fe(e) {
  return e.max - e.min;
}
function N1(e, t, n) {
  return Math.abs(e - t) <= n;
}
function sa(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = q(t.min, t.max, e.origin), e.scale = fe(n) / fe(t), e.translate = q(n.min, n.max, e.origin) - e.originPoint, (e.scale >= V1 && e.scale <= F1 || isNaN(e.scale)) && (e.scale = 1), (e.translate >= k1 && e.translate <= I1 || isNaN(e.translate)) && (e.translate = 0);
}
function un(e, t, n, r) {
  sa(e.x, t.x, n.x, r ? r.originX : void 0), sa(e.y, t.y, n.y, r ? r.originY : void 0);
}
function aa(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + fe(t);
}
function _1(e, t, n) {
  aa(e.x, t.x, n.x), aa(e.y, t.y, n.y);
}
function ca(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + fe(t);
}
function dn(e, t, n) {
  ca(e.x, t.x, n.x), ca(e.y, t.y, n.y);
}
function Ae(e) {
  return [e("x"), e("y")];
}
const Du = ({ current: e }) => e ? e.ownerDocument.defaultView : null, la = (e, t) => Math.abs(e - t);
function L1(e, t) {
  const n = la(e.x, t.x), r = la(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
class Ou {
  constructor(t, n, { transformPagePoint: r, contextWindow: i = window, dragSnapToOrigin: o = !1, distanceThreshold: s = 3 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const d = Ur(this.lastMoveEventInfo, this.history), h = this.startEvent !== null, g = L1(d.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
      if (!h && !g)
        return;
      const { point: p } = d, { timestamp: y } = ce;
      this.history.push({ ...p, timestamp: y });
      const { onStart: v, onMove: x } = this.handlers;
      h || (v && v(this.lastMoveEvent, d), this.startEvent = this.lastMoveEvent), x && x(this.lastMoveEvent, d);
    }, this.handlePointerMove = (d, h) => {
      this.lastMoveEvent = d, this.lastMoveEventInfo = Br(h, this.transformPagePoint), Z.update(this.updatePoint, !0);
    }, this.handlePointerUp = (d, h) => {
      this.end();
      const { onEnd: g, onSessionEnd: p, resumeAnimation: y } = this.handlers;
      if (this.dragSnapToOrigin && y && y(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const v = Ur(d.type === "pointercancel" ? this.lastMoveEventInfo : Br(h, this.transformPagePoint), this.history);
      this.startEvent && g && g(d, v), p && p(d, v);
    }, !go(t))
      return;
    this.dragSnapToOrigin = o, this.handlers = n, this.transformPagePoint = r, this.distanceThreshold = s, this.contextWindow = i || window;
    const a = Cn(t), c = Br(a, this.transformPagePoint), { point: l } = c, { timestamp: u } = ce;
    this.history = [{ ...l, timestamp: u }];
    const { onSessionStart: f } = n;
    f && f(t, Ur(c, this.history)), this.removeListeners = En(ln(this.contextWindow, "pointermove", this.handlePointerMove), ln(this.contextWindow, "pointerup", this.handlePointerUp), ln(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), it(this.updatePoint);
  }
}
function Br(e, t) {
  return t ? { point: t(e.point) } : e;
}
function ua(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function Ur({ point: e }, t) {
  return {
    point: e,
    delta: ua(e, Vu(t)),
    offset: ua(e, j1(t)),
    velocity: $1(t, 0.1)
  };
}
function j1(e) {
  return e[0];
}
function Vu(e) {
  return e[e.length - 1];
}
function $1(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const i = Vu(e);
  for (; n >= 0 && (r = e[n], !(i.timestamp - r.timestamp > /* @__PURE__ */ Oe(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const o = /* @__PURE__ */ Ne(i.timestamp - r.timestamp);
  if (o === 0)
    return { x: 0, y: 0 };
  const s = {
    x: (i.x - r.x) / o,
    y: (i.y - r.y) / o
  };
  return s.x === 1 / 0 && (s.x = 0), s.y === 1 / 0 && (s.y = 0), s;
}
function B1(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? q(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? q(n, e, r.max) : Math.min(e, n)), e;
}
function da(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function U1(e, { top: t, left: n, bottom: r, right: i }) {
  return {
    x: da(e.x, n, i),
    y: da(e.y, t, r)
  };
}
function fa(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function z1(e, t) {
  return {
    x: fa(e.x, t.x),
    y: fa(e.y, t.y)
  };
}
function W1(e, t) {
  let n = 0.5;
  const r = fe(e), i = fe(t);
  return i > r ? n = /* @__PURE__ */ mn(t.min, t.max - r, e.min) : r > i && (n = /* @__PURE__ */ mn(e.min, e.max - i, t.min)), He(0, 1, n);
}
function G1(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const Ei = 0.35;
function H1(e = Ei) {
  return e === !1 ? e = 0 : e === !0 && (e = Ei), {
    x: ha(e, "left", "right"),
    y: ha(e, "top", "bottom")
  };
}
function ha(e, t, n) {
  return {
    min: pa(e, t),
    max: pa(e, n)
  };
}
function pa(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const K1 = /* @__PURE__ */ new WeakMap();
class Y1 {
  constructor(t) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = ee(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1, distanceThreshold: r } = {}) {
    const { presenceContext: i } = this.visualElement;
    if (i && i.isPresent === !1)
      return;
    const o = (f) => {
      const { dragSnapToOrigin: d } = this.getProps();
      d ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(Cn(f).point);
    }, s = (f, d) => {
      const { drag: h, dragPropagation: g, onDragStart: p } = this.getProps();
      if (h && !g && (this.openDragLock && this.openDragLock(), this.openDragLock = ib(h), !this.openDragLock))
        return;
      this.latestPointerEvent = f, this.latestPanInfo = d, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), Ae((v) => {
        let x = this.getAxisMotionValue(v).get() || 0;
        if (_e.test(x)) {
          const { projection: T } = this.visualElement;
          if (T && T.layout) {
            const E = T.layout.layoutBox[v];
            E && (x = fe(E) * (parseFloat(x) / 100));
          }
        }
        this.originPoint[v] = x;
      }), p && Z.postRender(() => p(f, d)), xi(this.visualElement, "transform");
      const { animationState: y } = this.visualElement;
      y && y.setActive("whileDrag", !0);
    }, a = (f, d) => {
      this.latestPointerEvent = f, this.latestPanInfo = d;
      const { dragPropagation: h, dragDirectionLock: g, onDirectionLock: p, onDrag: y } = this.getProps();
      if (!h && !this.openDragLock)
        return;
      const { offset: v } = d;
      if (g && this.currentDirection === null) {
        this.currentDirection = Z1(v), this.currentDirection !== null && p && p(this.currentDirection);
        return;
      }
      this.updateAxis("x", d.point, v), this.updateAxis("y", d.point, v), this.visualElement.render(), y && y(f, d);
    }, c = (f, d) => {
      this.latestPointerEvent = f, this.latestPanInfo = d, this.stop(f, d), this.latestPointerEvent = null, this.latestPanInfo = null;
    }, l = () => Ae((f) => {
      var d;
      return this.getAnimationState(f) === "paused" && ((d = this.getAxisMotionValue(f).animation) == null ? void 0 : d.play());
    }), { dragSnapToOrigin: u } = this.getProps();
    this.panSession = new Ou(t, {
      onSessionStart: o,
      onStart: s,
      onMove: a,
      onSessionEnd: c,
      resumeAnimation: l
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: u,
      distanceThreshold: r,
      contextWindow: Du(this.visualElement)
    });
  }
  /**
   * @internal
   */
  stop(t, n) {
    const r = t || this.latestPointerEvent, i = n || this.latestPanInfo, o = this.isDragging;
    if (this.cancel(), !o || !i || !r)
      return;
    const { velocity: s } = i;
    this.startAnimation(s);
    const { onDragEnd: a } = this.getProps();
    a && Z.postRender(() => a(r, i));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(t, n, r) {
    const { drag: i } = this.getProps();
    if (!r || !$n(t, i, this.currentDirection))
      return;
    const o = this.getAxisMotionValue(t);
    let s = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (s = B1(s, this.constraints[t], this.elastic[t])), o.set(s);
  }
  resolveConstraints() {
    var o;
    const { dragConstraints: t, dragElastic: n } = this.getProps(), r = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (o = this.visualElement.projection) == null ? void 0 : o.layout, i = this.constraints;
    t && Nt(t) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : t && r ? this.constraints = U1(r.layoutBox, t) : this.constraints = !1, this.elastic = H1(n), i !== this.constraints && r && this.constraints && !this.hasMutatedConstraints && Ae((s) => {
      this.constraints !== !1 && this.getAxisMotionValue(s) && (this.constraints[s] = G1(r.layoutBox[s], this.constraints[s]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !Nt(t))
      return !1;
    const r = t.current;
    Ke(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
    const { projection: i } = this.visualElement;
    if (!i || !i.layout)
      return !1;
    const o = Zb(r, i.root, this.visualElement.getTransformPagePoint());
    let s = z1(i.layout.layoutBox, o);
    if (n) {
      const a = n(Hb(s));
      this.hasMutatedConstraints = !!a, a && (s = gu(a));
    }
    return s;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: i, dragTransition: o, dragSnapToOrigin: s, onDragTransitionEnd: a } = this.getProps(), c = this.constraints || {}, l = Ae((u) => {
      if (!$n(u, n, this.currentDirection))
        return;
      let f = c && c[u] || {};
      s && (f = { min: 0, max: 0 });
      const d = i ? 200 : 1e6, h = i ? 40 : 1e7, g = {
        type: "inertia",
        velocity: r ? t[u] : 0,
        bounceStiffness: d,
        bounceDamping: h,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...o,
        ...f
      };
      return this.startAxisValueAnimation(u, g);
    });
    return Promise.all(l).then(a);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return xi(this.visualElement, t), r.start(Ao(t, r, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    Ae((t) => this.getAxisMotionValue(t).stop());
  }
  pauseAnimation() {
    Ae((t) => {
      var n;
      return (n = this.getAxisMotionValue(t).animation) == null ? void 0 : n.pause();
    });
  }
  getAnimationState(t) {
    var n;
    return (n = this.getAxisMotionValue(t).animation) == null ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = `_drag${t.toUpperCase()}`, r = this.visualElement.getProps(), i = r[n];
    return i || this.visualElement.getValue(t, (r.initial ? r.initial[t] : void 0) || 0);
  }
  snapToCursor(t) {
    Ae((n) => {
      const { drag: r } = this.getProps();
      if (!$n(n, r, this.currentDirection))
        return;
      const { projection: i } = this.visualElement, o = this.getAxisMotionValue(n);
      if (i && i.layout) {
        const { min: s, max: a } = i.layout.layoutBox[n];
        o.set(t[n] - q(s, a, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!Nt(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const i = { x: 0, y: 0 };
    Ae((s) => {
      const a = this.getAxisMotionValue(s);
      if (a && this.constraints !== !1) {
        const c = a.get();
        i[s] = W1({ min: c, max: c }, this.constraints[s]);
      }
    });
    const { transformTemplate: o } = this.visualElement.getProps();
    this.visualElement.current.style.transform = o ? o({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), Ae((s) => {
      if (!$n(s, t, null))
        return;
      const a = this.getAxisMotionValue(s), { min: c, max: l } = this.constraints[s];
      a.set(q(c, l, i[s]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    K1.set(this.visualElement, this);
    const t = this.visualElement.current, n = ln(t, "pointerdown", (c) => {
      const { drag: l, dragListener: u = !0 } = this.getProps();
      l && u && this.start(c);
    }), r = () => {
      const { dragConstraints: c } = this.getProps();
      Nt(c) && c.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: i } = this.visualElement, o = i.addEventListener("measure", r);
    i && !i.layout && (i.root && i.root.updateScroll(), i.updateLayout()), Z.read(r);
    const s = Tn(window, "resize", () => this.scalePositionWithinConstraints()), a = i.addEventListener("didUpdate", ({ delta: c, hasLayoutChanged: l }) => {
      this.isDragging && l && (Ae((u) => {
        const f = this.getAxisMotionValue(u);
        f && (this.originPoint[u] += c[u].translate, f.set(f.get() + c[u].translate));
      }), this.visualElement.render());
    });
    return () => {
      s(), n(), o(), a && a();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: i = !1, dragConstraints: o = !1, dragElastic: s = Ei, dragMomentum: a = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: i,
      dragConstraints: o,
      dragElastic: s,
      dragMomentum: a
    };
  }
}
function $n(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function Z1(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class X1 extends ct {
  constructor(t) {
    super(t), this.removeGroupControls = Ce, this.removeListeners = Ce, this.controls = new Y1(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Ce;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const ma = (e) => (t, n) => {
  e && Z.postRender(() => e(t, n));
};
class q1 extends ct {
  constructor() {
    super(...arguments), this.removePointerDownListener = Ce;
  }
  onPointerDown(t) {
    this.session = new Ou(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: Du(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: i } = this.node.getProps();
    return {
      onSessionStart: ma(t),
      onStart: ma(n),
      onMove: r,
      onEnd: (o, s) => {
        delete this.session, i && Z.postRender(() => i(o, s));
      }
    };
  }
  mount() {
    this.removePointerDownListener = ln(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const Kn = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function ga(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const tn = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (N.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = ga(e, t.target.x), r = ga(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, J1 = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, i = ot.parse(e);
    if (i.length > 5)
      return r;
    const o = ot.createTransformer(e), s = typeof i[0] != "number" ? 1 : 0, a = n.x.scale * t.x, c = n.y.scale * t.y;
    i[0 + s] /= a, i[1 + s] /= c;
    const l = q(a, c, 0.5);
    return typeof i[2 + s] == "number" && (i[2 + s] /= l), typeof i[3 + s] == "number" && (i[3 + s] /= l), o(i);
  }
};
let ya = !1;
class Q1 extends Ci {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: i } = this.props, { projection: o } = t;
    wb(ew), o && (n.group && n.group.add(o), r && r.register && i && r.register(o), ya && o.root.didUpdate(), o.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), o.setOptions({
      ...o.options,
      onExitComplete: () => this.safeToRemove()
    })), Kn.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: i, isPresent: o } = this.props, { projection: s } = r;
    return s && (s.isPresent = o, ya = !0, i || t.layoutDependency !== n || n === void 0 || t.isPresent !== o ? s.willUpdate() : this.safeToRemove(), t.isPresent !== o && (o ? s.promote() : s.relegate() || Z.postRender(() => {
      const a = s.getStack();
      (!a || !a.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: t } = this.props.visualElement;
    t && (t.root.didUpdate(), mo.postRender(() => {
      !t.currentAnimation && t.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: i } = t;
    i && (i.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(i), r && r.deregister && r.deregister(i));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function Fu(e) {
  const [t, n] = hb(), r = ue(fl);
  return M(Q1, { ...e, layoutGroup: r, switchLayoutGroup: ue(pu), isPresent: t, safeToRemove: n });
}
const ew = {
  borderRadius: {
    ...tn,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: tn,
  borderTopRightRadius: tn,
  borderBottomLeftRadius: tn,
  borderBottomRightRadius: tn,
  boxShadow: J1
};
function tw(e, t, n) {
  const r = de(e) ? e : Ut(e);
  return r.start(Ao("", r, t, n)), r.animation;
}
const nw = (e, t) => e.depth - t.depth;
class rw {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    Zi(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    Xi(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(nw), this.isDirty = !1, this.children.forEach(t);
  }
}
function iw(e, t) {
  const n = ge.now(), r = ({ timestamp: i }) => {
    const o = i - n;
    o >= t && (it(r), e(o - t));
  };
  return Z.setup(r, !0), () => it(r);
}
const ku = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], ow = ku.length, va = (e) => typeof e == "string" ? parseFloat(e) : e, ba = (e) => typeof e == "number" || N.test(e);
function sw(e, t, n, r, i, o) {
  i ? (e.opacity = q(0, n.opacity ?? 1, aw(r)), e.opacityExit = q(t.opacity ?? 1, 0, cw(r))) : o && (e.opacity = q(t.opacity ?? 1, n.opacity ?? 1, r));
  for (let s = 0; s < ow; s++) {
    const a = `border${ku[s]}Radius`;
    let c = wa(t, a), l = wa(n, a);
    if (c === void 0 && l === void 0)
      continue;
    c || (c = 0), l || (l = 0), c === 0 || l === 0 || ba(c) === ba(l) ? (e[a] = Math.max(q(va(c), va(l), r), 0), (_e.test(l) || _e.test(c)) && (e[a] += "%")) : e[a] = l;
  }
  (t.rotate || n.rotate) && (e.rotate = q(t.rotate || 0, n.rotate || 0, r));
}
function wa(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const aw = /* @__PURE__ */ Iu(0, 0.5, Sl), cw = /* @__PURE__ */ Iu(0.5, 0.95, Ce);
function Iu(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n(/* @__PURE__ */ mn(e, t, r));
}
function Ta(e, t) {
  e.min = t.min, e.max = t.max;
}
function Ee(e, t) {
  Ta(e.x, t.x), Ta(e.y, t.y);
}
function xa(e, t) {
  e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
function Sa(e, t, n, r, i) {
  return e -= t, e = nr(e, 1 / n, r), i !== void 0 && (e = nr(e, 1 / i, r)), e;
}
function lw(e, t = 0, n = 1, r = 0.5, i, o = e, s = e) {
  if (_e.test(t) && (t = parseFloat(t), t = q(s.min, s.max, t / 100) - s.min), typeof t != "number")
    return;
  let a = q(o.min, o.max, r);
  e === o && (a -= t), e.min = Sa(e.min, t, n, a, i), e.max = Sa(e.max, t, n, a, i);
}
function Ea(e, t, [n, r, i], o, s) {
  lw(e, t[n], t[r], t[i], t.scale, o, s);
}
const uw = ["x", "scaleX", "originX"], dw = ["y", "scaleY", "originY"];
function Aa(e, t, n, r) {
  Ea(e.x, t, uw, n ? n.x : void 0, r ? r.x : void 0), Ea(e.y, t, dw, n ? n.y : void 0, r ? r.y : void 0);
}
function Pa(e) {
  return e.translate === 0 && e.scale === 1;
}
function Nu(e) {
  return Pa(e.x) && Pa(e.y);
}
function Ca(e, t) {
  return e.min === t.min && e.max === t.max;
}
function fw(e, t) {
  return Ca(e.x, t.x) && Ca(e.y, t.y);
}
function Ma(e, t) {
  return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function _u(e, t) {
  return Ma(e.x, t.x) && Ma(e.y, t.y);
}
function Ra(e) {
  return fe(e.x) / fe(e.y);
}
function Da(e, t) {
  return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
class hw {
  constructor() {
    this.members = [];
  }
  add(t) {
    Zi(this.members, t), t.scheduleRender();
  }
  remove(t) {
    if (Xi(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    const n = this.members.findIndex((i) => t === i);
    if (n === 0)
      return !1;
    let r;
    for (let i = n; i >= 0; i--) {
      const o = this.members[i];
      if (o.isPresent !== !1) {
        r = o;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(t, n) {
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.instance && r.scheduleRender(), t.scheduleRender(), t.resumeFrom = r, n && (t.resumeFrom.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), t.root && t.root.isUpdating && (t.isLayoutDirty = !0);
      const { crossfade: i } = t.options;
      i === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      const { options: n, resumingFrom: r } = t;
      n.onExitComplete && n.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => {
      t.instance && t.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function pw(e, t, n) {
  let r = "";
  const i = e.x.translate / t.x, o = e.y.translate / t.y, s = (n == null ? void 0 : n.z) || 0;
  if ((i || o || s) && (r = `translate3d(${i}px, ${o}px, ${s}px) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { transformPerspective: l, rotate: u, rotateX: f, rotateY: d, skewX: h, skewY: g } = n;
    l && (r = `perspective(${l}px) ${r}`), u && (r += `rotate(${u}deg) `), f && (r += `rotateX(${f}deg) `), d && (r += `rotateY(${d}deg) `), h && (r += `skewX(${h}deg) `), g && (r += `skewY(${g}deg) `);
  }
  const a = e.x.scale * t.x, c = e.y.scale * t.y;
  return (a !== 1 || c !== 1) && (r += `scale(${a}, ${c})`), r || "none";
}
const zr = ["", "X", "Y", "Z"], mw = 1e3;
let gw = 0;
function Wr(e, t, n, r) {
  const { latestValues: i } = t;
  i[e] && (n[e] = i[e], t.setStaticValue(e, 0), r && (r[e] = 0));
}
function Lu(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e)
    return;
  const { visualElement: t } = e.options;
  if (!t)
    return;
  const n = Eu(t);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: i, layoutId: o } = e.options;
    window.MotionCancelOptimisedAnimation(n, "transform", Z, !(i || o));
  }
  const { parent: r } = e;
  r && !r.hasCheckedOptimisedAppear && Lu(r);
}
function ju({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: i }) {
  return class {
    constructor(s = {}, a = t == null ? void 0 : t()) {
      this.id = gw++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(bw), this.nodes.forEach(Sw), this.nodes.forEach(Ew), this.nodes.forEach(ww);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = s, this.root = a ? a.root || a : this, this.path = a ? [...a.path, a] : [], this.parent = a, this.depth = a ? a.depth + 1 : 0;
      for (let c = 0; c < this.path.length; c++)
        this.path[c].shouldResetTransform = !0;
      this.root === this && (this.nodes = new rw());
    }
    addEventListener(s, a) {
      return this.eventHandlers.has(s) || this.eventHandlers.set(s, new Ji()), this.eventHandlers.get(s).add(a);
    }
    notifyListeners(s, ...a) {
      const c = this.eventHandlers.get(s);
      c && c.notify(...a);
    }
    hasListeners(s) {
      return this.eventHandlers.has(s);
    }
    /**
     * Lifecycles
     */
    mount(s) {
      if (this.instance)
        return;
      this.isSVG = tu(s) && !ub(s), this.instance = s;
      const { layoutId: a, layout: c, visualElement: l } = this.options;
      if (l && !l.current && l.mount(s), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (c || a) && (this.isLayoutDirty = !0), e) {
        let u, f = 0;
        const d = () => this.root.updateBlockedByResize = !1;
        Z.read(() => {
          f = window.innerWidth;
        }), e(s, () => {
          const h = window.innerWidth;
          h !== f && (f = h, this.root.updateBlockedByResize = !0, u && u(), u = iw(d, 250), Kn.hasAnimatedSinceResize && (Kn.hasAnimatedSinceResize = !1, this.nodes.forEach(Fa)));
        });
      }
      a && this.root.registerSharedNode(a, this), this.options.animate !== !1 && l && (a || c) && this.addEventListener("didUpdate", ({ delta: u, hasLayoutChanged: f, hasRelativeLayoutChanged: d, layout: h }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const g = this.options.transition || l.getDefaultTransition() || Rw, { onLayoutAnimationStart: p, onLayoutAnimationComplete: y } = l.getProps(), v = !this.targetLayout || !_u(this.targetLayout, h), x = !f && d;
        if (this.options.layoutRoot || this.resumeFrom || x || f && (v || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const T = {
            ...ho(g, "layout"),
            onPlay: p,
            onComplete: y
          };
          (l.shouldReduceMotion || this.options.layoutRoot) && (T.delay = 0, T.type = !1), this.startAnimation(T), this.setAnimationOrigin(u, x);
        } else
          f || Fa(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = h;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const s = this.getStack();
      s && s.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), it(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(Aw), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: s } = this.options;
      return s && s.getProps().transformTemplate;
    }
    willUpdate(s = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && Lu(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let u = 0; u < this.path.length; u++) {
        const f = this.path[u];
        f.shouldResetTransform = !0, f.updateScroll("snapshot"), f.options.layoutRoot && f.willUpdate(!1);
      }
      const { layoutId: a, layout: c } = this.options;
      if (a === void 0 && !c)
        return;
      const l = this.getTransformTemplate();
      this.prevTransformTemplateValue = l ? l(this.latestValues, "") : void 0, this.updateSnapshot(), s && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(Oa);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(Va);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(xw), this.nodes.forEach(yw), this.nodes.forEach(vw)) : this.nodes.forEach(Va), this.clearAllSnapshots();
      const a = ge.now();
      ce.delta = He(0, 1e3 / 60, a - ce.timestamp), ce.timestamp = a, ce.isProcessing = !0, kr.update.process(ce), kr.preRender.process(ce), kr.render.process(ce), ce.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, mo.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(Tw), this.sharedNodes.forEach(Pw);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, Z.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      Z.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !fe(this.snapshot.measuredBox.x) && !fe(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let c = 0; c < this.path.length; c++)
          this.path[c].updateScroll();
      const s = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = ee(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: a } = this.options;
      a && a.notify("LayoutMeasure", this.layout.layoutBox, s ? s.layoutBox : void 0);
    }
    updateScroll(s = "measure") {
      let a = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === s && (a = !1), a && this.instance) {
        const c = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: s,
          isRoot: c,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : c
        };
      }
    }
    resetTransform() {
      if (!i)
        return;
      const s = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, a = this.projectionDelta && !Nu(this.projectionDelta), c = this.getTransformTemplate(), l = c ? c(this.latestValues, "") : void 0, u = l !== this.prevTransformTemplateValue;
      s && this.instance && (a || pt(this.latestValues) || u) && (i(this.instance, l), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(s = !0) {
      const a = this.measurePageBox();
      let c = this.removeElementScroll(a);
      return s && (c = this.removeTransform(c)), Dw(c), {
        animationId: this.root.animationId,
        measuredBox: a,
        layoutBox: c,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var l;
      const { visualElement: s } = this.options;
      if (!s)
        return ee();
      const a = s.measureViewportBox();
      if (!(((l = this.scroll) == null ? void 0 : l.wasRoot) || this.path.some(Ow))) {
        const { scroll: u } = this.root;
        u && (_t(a.x, u.offset.x), _t(a.y, u.offset.y));
      }
      return a;
    }
    removeElementScroll(s) {
      var c;
      const a = ee();
      if (Ee(a, s), (c = this.scroll) != null && c.wasRoot)
        return a;
      for (let l = 0; l < this.path.length; l++) {
        const u = this.path[l], { scroll: f, options: d } = u;
        u !== this.root && f && d.layoutScroll && (f.wasRoot && Ee(a, s), _t(a.x, f.offset.x), _t(a.y, f.offset.y));
      }
      return a;
    }
    applyTransform(s, a = !1) {
      const c = ee();
      Ee(c, s);
      for (let l = 0; l < this.path.length; l++) {
        const u = this.path[l];
        !a && u.options.layoutScroll && u.scroll && u !== u.root && Lt(c, {
          x: -u.scroll.offset.x,
          y: -u.scroll.offset.y
        }), pt(u.latestValues) && Lt(c, u.latestValues);
      }
      return pt(this.latestValues) && Lt(c, this.latestValues), c;
    }
    removeTransform(s) {
      const a = ee();
      Ee(a, s);
      for (let c = 0; c < this.path.length; c++) {
        const l = this.path[c];
        if (!l.instance || !pt(l.latestValues))
          continue;
        vi(l.latestValues) && l.updateSnapshot();
        const u = ee(), f = l.measurePageBox();
        Ee(u, f), Aa(a, l.latestValues, l.snapshot ? l.snapshot.layoutBox : void 0, u);
      }
      return pt(this.latestValues) && Aa(a, this.latestValues), a;
    }
    setTargetDelta(s) {
      this.targetDelta = s, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(s) {
      this.options = {
        ...this.options,
        ...s,
        crossfade: s.crossfade !== void 0 ? s.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== ce.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(s = !1) {
      var d;
      const a = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = a.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = a.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = a.isSharedProjectionDirty);
      const c = !!this.resumingFrom || this !== a;
      if (!(s || c && this.isSharedProjectionDirty || this.isProjectionDirty || (d = this.parent) != null && d.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: u, layoutId: f } = this.options;
      if (!(!this.layout || !(u || f))) {
        if (this.resolvedRelativeTargetAt = ce.timestamp, !this.targetDelta && !this.relativeTarget) {
          const h = this.getClosestProjectingParent();
          h && h.layout && this.animationProgress !== 1 ? (this.relativeParent = h, this.forceRelativeParentToResolveTarget(), this.relativeTarget = ee(), this.relativeTargetOrigin = ee(), dn(this.relativeTargetOrigin, this.layout.layoutBox, h.layout.layoutBox), Ee(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = ee(), this.targetWithTransforms = ee()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), _1(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : Ee(this.target, this.layout.layoutBox), vu(this.target, this.targetDelta)) : Ee(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget)) {
          this.attemptToResolveRelativeTarget = !1;
          const h = this.getClosestProjectingParent();
          h && !!h.resumingFrom == !!this.resumingFrom && !h.options.layoutScroll && h.target && this.animationProgress !== 1 ? (this.relativeParent = h, this.forceRelativeParentToResolveTarget(), this.relativeTarget = ee(), this.relativeTargetOrigin = ee(), dn(this.relativeTargetOrigin, this.target, h.target), Ee(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || vi(this.parent.latestValues) || yu(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var g;
      const s = this.getLead(), a = !!this.resumingFrom || this !== s;
      let c = !0;
      if ((this.isProjectionDirty || (g = this.parent) != null && g.isProjectionDirty) && (c = !1), a && (this.isSharedProjectionDirty || this.isTransformDirty) && (c = !1), this.resolvedRelativeTargetAt === ce.timestamp && (c = !1), c)
        return;
      const { layout: l, layoutId: u } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(l || u))
        return;
      Ee(this.layoutCorrected, this.layout.layoutBox);
      const f = this.treeScale.x, d = this.treeScale.y;
      Yb(this.layoutCorrected, this.treeScale, this.path, a), s.layout && !s.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (s.target = s.layout.layoutBox, s.targetWithTransforms = ee());
      const { target: h } = s;
      if (!h) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (xa(this.prevProjectionDelta.x, this.projectionDelta.x), xa(this.prevProjectionDelta.y, this.projectionDelta.y)), un(this.projectionDelta, this.layoutCorrected, h, this.latestValues), (this.treeScale.x !== f || this.treeScale.y !== d || !Da(this.projectionDelta.x, this.prevProjectionDelta.x) || !Da(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", h));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(s = !0) {
      var a;
      if ((a = this.options.visualElement) == null || a.scheduleRender(), s) {
        const c = this.getStack();
        c && c.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = jt(), this.projectionDelta = jt(), this.projectionDeltaWithTransform = jt();
    }
    setAnimationOrigin(s, a = !1) {
      const c = this.snapshot, l = c ? c.latestValues : {}, u = { ...this.latestValues }, f = jt();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !a;
      const d = ee(), h = c ? c.source : void 0, g = this.layout ? this.layout.source : void 0, p = h !== g, y = this.getStack(), v = !y || y.members.length <= 1, x = !!(p && !v && this.options.crossfade === !0 && !this.path.some(Mw));
      this.animationProgress = 0;
      let T;
      this.mixTargetDelta = (E) => {
        const b = E / 1e3;
        ka(f.x, s.x, b), ka(f.y, s.y, b), this.setTargetDelta(f), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (dn(d, this.layout.layoutBox, this.relativeParent.layout.layoutBox), Cw(this.relativeTarget, this.relativeTargetOrigin, d, b), T && fw(this.relativeTarget, T) && (this.isProjectionDirty = !1), T || (T = ee()), Ee(T, this.relativeTarget)), p && (this.animationValues = u, sw(u, l, this.latestValues, b, x, v)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = b;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(s) {
      var a, c, l;
      this.notifyListeners("animationStart"), (a = this.currentAnimation) == null || a.stop(), (l = (c = this.resumingFrom) == null ? void 0 : c.currentAnimation) == null || l.stop(), this.pendingAnimation && (it(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Z.update(() => {
        Kn.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = Ut(0)), this.currentAnimation = tw(this.motionValue, [0, 1e3], {
          ...s,
          velocity: 0,
          isSync: !0,
          onUpdate: (u) => {
            this.mixTargetDelta(u), s.onUpdate && s.onUpdate(u);
          },
          onStop: () => {
          },
          onComplete: () => {
            s.onComplete && s.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const s = this.getStack();
      s && s.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(mw), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const s = this.getLead();
      let { targetWithTransforms: a, target: c, layout: l, latestValues: u } = s;
      if (!(!a || !c || !l)) {
        if (this !== s && this.layout && l && $u(this.options.animationType, this.layout.layoutBox, l.layoutBox)) {
          c = this.target || ee();
          const f = fe(this.layout.layoutBox.x);
          c.x.min = s.target.x.min, c.x.max = c.x.min + f;
          const d = fe(this.layout.layoutBox.y);
          c.y.min = s.target.y.min, c.y.max = c.y.min + d;
        }
        Ee(a, c), Lt(a, u), un(this.projectionDeltaWithTransform, this.layoutCorrected, a, u);
      }
    }
    registerSharedNode(s, a) {
      this.sharedNodes.has(s) || this.sharedNodes.set(s, new hw()), this.sharedNodes.get(s).add(a);
      const l = a.options.initialPromotionConfig;
      a.promote({
        transition: l ? l.transition : void 0,
        preserveFollowOpacity: l && l.shouldPreserveFollowOpacity ? l.shouldPreserveFollowOpacity(a) : void 0
      });
    }
    isLead() {
      const s = this.getStack();
      return s ? s.lead === this : !0;
    }
    getLead() {
      var a;
      const { layoutId: s } = this.options;
      return s ? ((a = this.getStack()) == null ? void 0 : a.lead) || this : this;
    }
    getPrevLead() {
      var a;
      const { layoutId: s } = this.options;
      return s ? (a = this.getStack()) == null ? void 0 : a.prevLead : void 0;
    }
    getStack() {
      const { layoutId: s } = this.options;
      if (s)
        return this.root.sharedNodes.get(s);
    }
    promote({ needsReset: s, transition: a, preserveFollowOpacity: c } = {}) {
      const l = this.getStack();
      l && l.promote(this, c), s && (this.projectionDelta = void 0, this.needsReset = !0), a && this.setOptions({ transition: a });
    }
    relegate() {
      const s = this.getStack();
      return s ? s.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: s } = this.options;
      if (!s)
        return;
      let a = !1;
      const { latestValues: c } = s;
      if ((c.z || c.rotate || c.rotateX || c.rotateY || c.rotateZ || c.skewX || c.skewY) && (a = !0), !a)
        return;
      const l = {};
      c.z && Wr("z", s, l, this.animationValues);
      for (let u = 0; u < zr.length; u++)
        Wr(`rotate${zr[u]}`, s, l, this.animationValues), Wr(`skew${zr[u]}`, s, l, this.animationValues);
      s.render();
      for (const u in l)
        s.setStaticValue(u, l[u]), this.animationValues && (this.animationValues[u] = l[u]);
      s.scheduleRender();
    }
    applyProjectionStyles(s, a) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible) {
        s.visibility = "hidden";
        return;
      }
      const c = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, s.visibility = "", s.opacity = "", s.pointerEvents = Hn(a == null ? void 0 : a.pointerEvents) || "", s.transform = c ? c(this.latestValues, "") : "none";
        return;
      }
      const l = this.getLead();
      if (!this.projectionDelta || !this.layout || !l.target) {
        this.options.layoutId && (s.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, s.pointerEvents = Hn(a == null ? void 0 : a.pointerEvents) || ""), this.hasProjected && !pt(this.latestValues) && (s.transform = c ? c({}, "") : "none", this.hasProjected = !1);
        return;
      }
      s.visibility = "";
      const u = l.animationValues || l.latestValues;
      this.applyTransformsToTarget();
      let f = pw(this.projectionDeltaWithTransform, this.treeScale, u);
      c && (f = c(u, f)), s.transform = f;
      const { x: d, y: h } = this.projectionDelta;
      s.transformOrigin = `${d.origin * 100}% ${h.origin * 100}% 0`, l.animationValues ? s.opacity = l === this ? u.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : u.opacityExit : s.opacity = l === this ? u.opacity !== void 0 ? u.opacity : "" : u.opacityExit !== void 0 ? u.opacityExit : 0;
      for (const g in bn) {
        if (u[g] === void 0)
          continue;
        const { correct: p, applyTo: y, isCSSVariable: v } = bn[g], x = f === "none" ? u[g] : p(u[g], l);
        if (y) {
          const T = y.length;
          for (let E = 0; E < T; E++)
            s[y[E]] = x;
        } else
          v ? this.options.visualElement.renderState.vars[g] = x : s[g] = x;
      }
      this.options.layoutId && (s.pointerEvents = l === this ? Hn(a == null ? void 0 : a.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((s) => {
        var a;
        return (a = s.currentAnimation) == null ? void 0 : a.stop();
      }), this.root.nodes.forEach(Oa), this.root.sharedNodes.clear();
    }
  };
}
function yw(e) {
  e.updateLayout();
}
function vw(e) {
  var n;
  const t = ((n = e.resumeFrom) == null ? void 0 : n.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && t && e.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: i } = e.layout, { animationType: o } = e.options, s = t.source !== e.layout.source;
    o === "size" ? Ae((f) => {
      const d = s ? t.measuredBox[f] : t.layoutBox[f], h = fe(d);
      d.min = r[f].min, d.max = d.min + h;
    }) : $u(o, t.layoutBox, r) && Ae((f) => {
      const d = s ? t.measuredBox[f] : t.layoutBox[f], h = fe(r[f]);
      d.max = d.min + h, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[f].max = e.relativeTarget[f].min + h);
    });
    const a = jt();
    un(a, r, t.layoutBox);
    const c = jt();
    s ? un(c, e.applyTransform(i, !0), t.measuredBox) : un(c, r, t.layoutBox);
    const l = !Nu(a);
    let u = !1;
    if (!e.resumeFrom) {
      const f = e.getClosestProjectingParent();
      if (f && !f.resumeFrom) {
        const { snapshot: d, layout: h } = f;
        if (d && h) {
          const g = ee();
          dn(g, t.layoutBox, d.layoutBox);
          const p = ee();
          dn(p, r, h.layoutBox), _u(g, p) || (u = !0), f.options.layoutRoot && (e.relativeTarget = p, e.relativeTargetOrigin = g, e.relativeParent = f);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: r,
      snapshot: t,
      delta: c,
      layoutDelta: a,
      hasLayoutChanged: l,
      hasRelativeLayoutChanged: u
    });
  } else if (e.isLead()) {
    const { onExitComplete: r } = e.options;
    r && r();
  }
  e.options.transition = void 0;
}
function bw(e) {
  e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function ww(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function Tw(e) {
  e.clearSnapshot();
}
function Oa(e) {
  e.clearMeasurements();
}
function Va(e) {
  e.isLayoutDirty = !1;
}
function xw(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function Fa(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function Sw(e) {
  e.resolveTargetDelta();
}
function Ew(e) {
  e.calcProjection();
}
function Aw(e) {
  e.resetSkewAndRotation();
}
function Pw(e) {
  e.removeLeadSnapshot();
}
function ka(e, t, n) {
  e.translate = q(t.translate, 0, n), e.scale = q(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function Ia(e, t, n, r) {
  e.min = q(t.min, n.min, r), e.max = q(t.max, n.max, r);
}
function Cw(e, t, n, r) {
  Ia(e.x, t.x, n.x, r), Ia(e.y, t.y, n.y, r);
}
function Mw(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const Rw = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, Na = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), _a = Na("applewebkit/") && !Na("chrome/") ? Math.round : Ce;
function La(e) {
  e.min = _a(e.min), e.max = _a(e.max);
}
function Dw(e) {
  La(e.x), La(e.y);
}
function $u(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !N1(Ra(t), Ra(n), 0.2);
}
function Ow(e) {
  var t;
  return e !== e.root && ((t = e.scroll) == null ? void 0 : t.wasRoot);
}
const Vw = ju({
  attachResizeListener: (e, t) => Tn(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), Gr = {
  current: void 0
}, Bu = ju({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!Gr.current) {
      const e = new Vw({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), Gr.current = e;
    }
    return Gr.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), Fw = {
  pan: {
    Feature: q1
  },
  drag: {
    Feature: X1,
    ProjectionNode: Bu,
    MeasureLayout: Fu
  }
};
function ja(e, t, n) {
  const { props: r } = e;
  e.animationState && r.whileHover && e.animationState.setActive("whileHover", n === "Start");
  const i = "onHover" + n, o = r[i];
  o && Z.postRender(() => o(t, Cn(t)));
}
class kw extends ct {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = ob(t, (n, r) => (ja(this.node, r, "Start"), (i) => ja(this.node, i, "End"))));
  }
  unmount() {
  }
}
class Iw extends ct {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = En(Tn(this.node.current, "focus", () => this.onFocus()), Tn(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function $a(e, t, n) {
  const { props: r } = e;
  if (e.current instanceof HTMLButtonElement && e.current.disabled)
    return;
  e.animationState && r.whileTap && e.animationState.setActive("whileTap", n === "Start");
  const i = "onTap" + (n === "End" ? "" : n), o = r[i];
  o && Z.postRender(() => o(t, Cn(t)));
}
class Nw extends ct {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = lb(t, (n, r) => ($a(this.node, r, "Start"), (i, { success: o }) => $a(this.node, i, o ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const Ai = /* @__PURE__ */ new WeakMap(), Hr = /* @__PURE__ */ new WeakMap(), _w = (e) => {
  const t = Ai.get(e.target);
  t && t(e);
}, Lw = (e) => {
  e.forEach(_w);
};
function jw({ root: e, ...t }) {
  const n = e || document;
  Hr.has(n) || Hr.set(n, {});
  const r = Hr.get(n), i = JSON.stringify(t);
  return r[i] || (r[i] = new IntersectionObserver(Lw, { root: e, ...t })), r[i];
}
function $w(e, t, n) {
  const r = jw(t);
  return Ai.set(e, n), r.observe(e), () => {
    Ai.delete(e), r.unobserve(e);
  };
}
const Bw = {
  some: 0,
  all: 1
};
class Uw extends ct {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: i = "some", once: o } = t, s = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof i == "number" ? i : Bw[i]
    }, a = (c) => {
      const { isIntersecting: l } = c;
      if (this.isInView === l || (this.isInView = l, o && !l && this.hasEnteredView))
        return;
      l && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", l);
      const { onViewportEnter: u, onViewportLeave: f } = this.node.getProps(), d = l ? u : f;
      d && d(c);
    };
    return $w(this.node.current, s, a);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(zw(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function zw({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const Ww = {
  inView: {
    Feature: Uw
  },
  tap: {
    Feature: Nw
  },
  focus: {
    Feature: Iw
  },
  hover: {
    Feature: kw
  }
}, Gw = {
  layout: {
    ProjectionNode: Bu,
    MeasureLayout: Fu
  }
}, Hw = {
  ...D1,
  ...Ww,
  ...Fw,
  ...Gw
}, Uu = /* @__PURE__ */ Gb(Hw, i1), Kw = "flex flex-col relative w-full cursor-text", Yw = `
  peer transition-all grow
  px-4 pt-4 pb-2 border border-solid rounded outline-none
  border-gray-200 bg-white text-base-black text-base
  placeholder:text-transparent

  focus:border-primary-100
  hover:bg-gray-25
  disabled:text-gray-200

  data-[has-error=true]:border-feedback-danger-200
  data-[is-loading=true]:animate-pulse
  data-[has-prefix-icon=true]:pl-10
`, Zw = `
  text-xs text-gray-400 px-4 ml-1 w-[125%]
  absolute top-3 origin-top-left text-ellipsis overflow-hidden
  scale-75 duration-300 text-nowrap
  transform -translate-y-1
  
  peer-placeholder-shown:text-base
  peer-placeholder-shown:scale-100
  peer-placeholder-shown:translate-y-0
  peer-placeholder-shown:w-full

  peer-focus:scale-75
  peer-focus:text-xs
  peer-focus:-translate-y-1
  peer-focus:w-[125%]
  peer-focus:ml-1

  peer-placeholder-shown:peer-data-[has-prefix-icon=true]:ml-6
  peer-placeholder-shown:peer-data-[has-prefix-icon=true]:translate-y-0
  peer-placeholder-shown:peer-data-[has-prefix-icon=true]:w-[calc(100%-24px)]

  peer-data-[has-prefix-icon=true]:ml-7
  peer-data-[has-prefix-icon=true]:w-[calc(125%-24px)]

  peer-focus:peer-data-[has-prefix-icon=true]:ml-7
  peer-focus:peer-data-[has-prefix-icon=true]:-translate-y-1
  peer-focus:peer-data-[has-prefix-icon=true]:w-[calc(125%-24px)]
`, Xw = `
  h-4 w-4
  absolute left-4 top-1/2 -translate-y-1/2
`, qw = `
  h-4 w-4
  absolute right-4 top-1/2 -translate-y-1/2
`;
function zu({
  name: e,
  label: t,
  type: n = "text",
  isDisabled: r,
  maxLength: i = 255,
  prefixIcon: o,
  suffixIcon: s,
  className: a,
  fieldClassName: c,
  onChange: l,
  onFocus: u,
  onBlur: f
}) {
  const { isLoading: d } = Hi(), { isSubmitting: h } = Kt(), [g, p] = ur(e), y = (T) => {
    typeof l < "u" && l(T), g.onChange(T);
  }, v = (T) => {
    typeof u < "u" && u(T);
  }, x = (T) => {
    typeof f < "u" && f(T);
  };
  return /* @__PURE__ */ be("div", { className: on(Kw, a || ""), children: [
    /* @__PURE__ */ M(
      cl,
      {
        className: on(Yw, c || ""),
        type: n,
        id: e,
        name: e,
        placeholder: t,
        ...n === "text" ? { maxLength: i } : { max: i },
        disabled: d || r || h,
        "data-is-loading": d,
        "data-has-error": !!p.error,
        "data-has-prefix-icon": !!o,
        "data-1p-ignore": !0,
        onChange: y,
        onFocus: v,
        onBlur: x
      }
    ),
    /* @__PURE__ */ M(Uu.label, { htmlFor: e, className: Zw, children: t }),
    typeof o < "u" && /* @__PURE__ */ M(o, { className: Xw }),
    typeof s < "u" && /* @__PURE__ */ M(s, { className: qw }),
    /* @__PURE__ */ M(
      ll,
      {
        name: e,
        component: "span",
        className: dl
      },
      `error-${e}`
    )
  ] });
}
const Jw = "flex flex-col relative w-full cursor-text", Qw = `
  flex transition-all grow resize-none
  px-4 pt-6 pb-1.5 border border-solid rounded outline-none
  border-gray-200 bg-white text-black

  focus-within:border-primary-100
  hover:bg-gray-25
  disabled:text-gray-200

  data-[has-error=true]:border-feedback-danger-200
  data-[is-loading=true]:animate-pulse
  data-[has-prefix-icon=true]:pl-10
  data-[has-max-length=true]:pb-10
`, eT = `
  p-0 relative peer text-sm placeholder:text-transparent bg-transparent
  max-h-56 min-h-14 w-full border-0 appearance-none
  focus:outline-none resize-none
`, tT = `
  text-sm	text-gray-400
  absolute top-4 origin-top-left
  scale-75 duration-300

  transform
  -translate-y-2

  peer-placeholder-shown:text-base
  peer-placeholder-shown:scale-100
  peer-placeholder-shown:translate-y-0
  peer-focus:text-sm
  peer-focus:scale-75
  peer-focus:-translate-y-2
  peer-data-[has-prefix-icon=true]:mx-10
`, nT = `
  h-4 w-4
  absolute left-4 top-1/2 -translate-y-1/2
`, rT = `
  text-sm text-gray-400
  absolute bottom-3.5 right-8 origin-bottom-right
`;
function iT({
  name: e,
  label: t,
  isDisabled: n,
  maxLength: r,
  rows: i = 1,
  grow: o = !0,
  prefixIcon: s,
  className: a,
  onChange: c
}) {
  const { isLoading: l } = Hi(), { isSubmitting: u } = Kt(), f = ve(null), [d, h, g] = ur(e);
  le(() => {
    !o || !f || f.current && (f.current.style.height = "0px", f.current.style.height = `${f.current.scrollHeight}px`);
  }, [o, f, d.value]);
  const p = (v) => {
    typeof c < "u" && c(v), d.onChange(v);
  }, y = () => {
    var v;
    (v = f.current) == null || v.focus();
  };
  return /* @__PURE__ */ be("div", { className: `${Jw} ${a || ""}`, children: [
    /* @__PURE__ */ be(
      "div",
      {
        className: Qw,
        "data-is-loading": l,
        "data-has-prefix-icon": !!s,
        "data-has-max-length": !!r,
        onClick: y,
        children: [
          /* @__PURE__ */ M(
            cl,
            {
              innerRef: f,
              component: "textarea",
              rows: i,
              className: eT,
              id: e,
              name: e,
              placeholder: t,
              maxLength: r,
              disabled: l || n || u,
              onChange: p,
              "data-1p-ignore": !0
            }
          ),
          /* @__PURE__ */ M(Uu.label, { htmlFor: e, className: tT, children: t }),
          typeof s < "u" && /* @__PURE__ */ M(s, { className: nT }),
          !!r && /* @__PURE__ */ M("div", { className: rT, children: `${h.value.length} / ${r}` })
        ]
      }
    ),
    /* @__PURE__ */ M(
      ll,
      {
        name: e,
        component: "span",
        className: dl
      },
      `error-${e}`
    )
  ] });
}
const oT = "pr-10 truncate", sT = `
  border-0 p-0 cursor-pointer
  absolute top-1/2 -translate-y-1/2
  right-4 bg-transparent
`, aT = `
  h-4 w-4 
`, cT = `
  animate-spin h-4 w-4
  absolute top-4 right-9 
`;
function Wu({
  name: e,
  label: t,
  isLoading: n,
  isDisabled: r,
  maxLength: i = 255,
  prefixIcon: o,
  suffixIcon: s,
  className: a,
  onChange: c,
  onClear: l,
  onFocus: u,
  onBlur: f
}) {
  const [, d, h] = ur(e), g = (y) => {
    typeof c < "u" && c(y);
  }, p = () => {
    h.setValue(""), typeof c < "u" && c({ target: { value: "" } }), typeof l < "u" && l();
  };
  return /* @__PURE__ */ be(Yn, { children: [
    /* @__PURE__ */ M(
      zu,
      {
        name: e,
        label: t,
        isDisabled: r,
        maxLength: i,
        prefixIcon: o,
        suffixIcon: s,
        className: a,
        fieldClassName: oT,
        onChange: g,
        onFocus: u,
        onBlur: f
      }
    ),
    n && /* @__PURE__ */ M(Oc, { className: cT }),
    !!d.value && /* @__PURE__ */ M("button", { type: "button", className: sT, onClick: p, children: /* @__PURE__ */ M(Ii, { className: aT }) })
  ] });
}
const lT = "relative", uT = "relative", dT = `
  absolute top-0 left-0 right-0
  list-none px-0 py-1 mt-1
  rounded-lg overflow-hidden
  bg-white shadow-multi-2sm rounded-lg 
`, fT = `
  py-2.5 px-4 cursor-pointer transition-all
  bg-white hover:bg-primary-10 hover:font-medium hover:text-black
`, hT = `
  absolute top-0 left-0 right-0 bottom-0
  px-4 flex items-center pointer-events-none
  text-gray-800

  data-[has-prefix-icon="true"]:pl-10
`;
function pT({
  name: e,
  label: t,
  options: n = [],
  selectedLabel: r,
  isLoading: i,
  isDisabled: o,
  clearOnSelect: s = !0,
  maxLength: a = 255,
  prefixIcon: c,
  suffixIcon: l,
  className: u,
  onChange: f,
  onClear: d,
  onFocus: h,
  onBlur: g,
  onSelect: p
}) {
  const [y, v] = rr(!1), [x, , T] = ur(e), E = () => {
    const I = n.length > 0;
    y !== I && v(I);
  };
  le(() => {
    E();
  }, [n, E]);
  const b = Ge(
    () => r && s && !y && !x.value,
    [r, s, y, x.value]
  ), A = (I) => {
    E(), typeof h < "u" && h(I);
  }, P = (I) => {
    setTimeout(() => {
      v(!1), typeof r > "u" && s && T.setValue(""), typeof f < "u" && f({ target: { value: "" } }), typeof g < "u" && g(I);
    }, 250);
  }, S = (I) => (G) => {
    typeof p < "u" && p(I), v(!1), s ? T.setValue("") : T.setValue(I);
  };
  return /* @__PURE__ */ be("div", { className: lT, tabIndex: 0, children: [
    /* @__PURE__ */ M(
      Wu,
      {
        name: e,
        label: b ? "" : t,
        isLoading: i,
        isDisabled: o,
        maxLength: a,
        prefixIcon: c,
        suffixIcon: y ? void 0 : l,
        className: u,
        onChange: f,
        onClear: d,
        onBlur: P,
        onFocus: A
      }
    ),
    b && s && /* @__PURE__ */ M("div", { className: hT, "data-has-prefix-icon": !!c, children: r }),
    y && /* @__PURE__ */ M("div", { className: uT, children: /* @__PURE__ */ M("ul", { className: dT, children: n.map((I) => /* @__PURE__ */ M("li", { className: fT, onClick: S(I.value), children: I.label }, I.key)) }) })
  ] });
}
function mT({
  isLoading: e = !1,
  enableReinitialize: t = !0,
  initialValues: n,
  validationSchema: r,
  isForcedDirty: i,
  onSubmit: o,
  className: s,
  children: a
}) {
  const [c, l] = rr(null), u = (d) => {
    l(d);
  }, f = (d, h) => {
    typeof o < "u" ? o(d).finally(() => {
      h.setSubmitting(!1);
    }) : h.setSubmitting(!1);
  };
  return /* @__PURE__ */ M(
    ul.Provider,
    {
      value: { isLoading: e, isForcedDirty: i, onNavigationEvent: u },
      children: /* @__PURE__ */ M(
        Jy,
        {
          enableReinitialize: t,
          initialValues: n,
          validationSchema: r,
          onSubmit: f,
          children: (d) => /* @__PURE__ */ M("form", { onSubmit: d.handleSubmit, className: `${fv} ${s || ""}`, children: a })
        }
      )
    }
  );
}
const ST = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: hv,
  Input: zu,
  Root: mT,
  Search: Wu,
  SearchAndSelect: pT,
  Textarea: iT
}, Symbol.toStringTag, { value: "Module" }));
export {
  ec as Button,
  $d as Card,
  ST as Form,
  TT as Modal
};
